export const metadata = {
  "2833": {
    "name": "Pocket Monsters - Aka (Japan)  ",
    "productCode": "DMG-APAJ-JPN"
  },
  "729": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "683": {
    "name": "Power Pro Kun Pocket 2 (Japan) ",
    "productCode": "DMG-BPWJ-JPN"
  },
  "379": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "2999": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "2130": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "2560": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "2075": {
    "name": "Medarot 3 - Kuwagata Version (Japan)",
    "productCode": "CGB-B33J-JPN"
  },
  "2425": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1659": {
    "name": "Othello (Japan)",
    "productCode": "DMG-OTJ"
  },
  "2976": {
    "name": "Ranma 1-2 (Japan)",
    "productCode": "DMG-RNJ"
  },
  "396": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "1209": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "816": {
    "name": "DuckTales (Japan)",
    "productCode": "DMG-DTJ"
  },
  "1823": {
    "name": "Hamster Paradise 2 (Japan)",
    "productCode": "CGB-BHMJ-JPN"
  },
  "1989": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "115": {
    "name": "Bomber Man GB 3 (Japan) ",
    "productCode": "DMG-AB3J-JPN"
  },
  "1120": {
    "name": "Mario Tennis GB (Japan)",
    "productCode": "CGB-BM8J-JPN"
  },
  "545": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1570": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "1065": {
    "name": "Nintendo World Cup (USA, Europe)",
    "productCode": "DMG-NC-USA"
  },
  "3058": {
    "name": "DX Bakenou Z (Japan)",
    "productCode": "DMG-DZJ"
  },
  "1435": {
    "name": "Super Black Bass Pocket 3 (Japan)",
    "productCode": "DMG-ABQJ-JPN"
  },
  "400": {
    "name": "B-Daman Bakugaiden - Victory e no Michi (Japan) ",
    "productCode": "DMG-AOKJ-JPN"
  },
  "1966": {
    "name": "Pachinko Time (Japan)",
    "productCode": "DMG-PTJ"
  },
  "2649": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "953": {
    "name": "Yoshi no Panepon",
    "productCode": "DMG-AYLJ-JPN"
  },
  "2219": {
    "name": "Higashio Osamu Kanshuu Pro Yakyuu Stadium '92 (Japan)",
    "productCode": "DMG-EIJ"
  },
  "2537": {
    "name": "Looney Tunes (USA)",
    "productCode": "DMG-LN-USA"
  },
  "2167": {
    "name": "Tiny Toon Adventures (USA)",
    "productCode": "DMG-TX-USA"
  },
  "2864": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "284": {
    "name": "SD Gundam - SD Sengokuden - Kunitori Monogatari (Japan)",
    "productCode": "DMG-SDJ"
  },
  "791": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "2921": {
    "name": "Super Gals! Kotobuki Ran (Japan)",
    "productCode": "CGB-BGLJ-JPN"
  },
  "2472": {
    "name": "The Wild Thornberrys - Rambler (USA)",
    "productCode": "CGB-BWTE-USA"
  },
  "2188": {
    "name": "Bikkuri Nekketsu Shin Kiroku! - Dokodemo Kin Medal (Japan)",
    "productCode": "DMG-NQJ"
  },
  "2022": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "1527": {
    "name": "Higashio Osamu Kanshuu Pro Yakyuu Stadium '91 (Japan)",
    "productCode": "DMG-PIJ"
  },
  "512": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1177": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "142": {
    "name": "Hokuto no Ken - Seizetsu Juuban Shoubu (Japan)",
    "productCode": "DMG-HKJ"
  },
  "1874": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "841": {
    "name": "J.League Live '95 (Japan) ",
    "productCode": "DMG-AWGJ-JPN"
  },
  "904": {
    "name": "Outburst (Japan)",
    "productCode": "DMG-OBJ"
  },
  "1931": {
    "name": "Makai Toushi Sa-Ga (Japan)",
    "productCode": "DMG-SAJ"
  },
  "1198": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "457": {
    "name": "Crayon Shin-chan 2 - Ora to Wanpaku Gokko Dazo (Japan)",
    "productCode": "DMG-COJ"
  },
  "1462": {
    "name": "Namco Classic (Japan)",
    "productCode": "DMG-NHJ"
  },
  "1032": {
    "name": "Donkey Kong Land (Japan) ",
    "productCode": "DMG-ADDJ-JPN"
  },
  "292": {
    "name": "LEGO Stunt Rally (USA)",
    "productCode": "CGB-BLYE-USA"
  },
  "2872": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "768": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "338": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "2171": {
    "name": "Lock'n Chase",
    "productCode": "DMG-LCA"
  },
  "2521": {
    "name": "Space Invaders (Japan)",
    "productCode": "DMG-SPA"
  },
  "2034": {
    "name": "Medarot - Kabuto Version (Japan) ",
    "productCode": "DMG-AMXJ-JPN"
  },
  "2464": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "2937": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1618": {
    "name": "Bishoujo Senshi Sailor Moon (Japan)",
    "productCode": "DMG-AQJ"
  },
  "787": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "1248": {
    "name": "The Simpsons - Treehouse of Horror (USA)",
    "productCode": "CGB-BNOE-USA"
  },
  "857": {
    "name": "Pocket Stadium (Japan)",
    "productCode": "DMG-PKJ"
  },
  "1862": {
    "name": "Ohasuta Yama-chan & Raymond (Japan) ",
    "productCode": "DMG-AOSJ-JPN"
  },
  "154": {
    "name": "Racing Damashii (Japan)",
    "productCode": "DMG-RDJ"
  },
  "1161": {
    "name": "Pocket Monsters - Aka (Japan)  ",
    "productCode": "DMG-APAJ-JPN"
  },
  "504": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "1531": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "3019": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "1024": {
    "name": "Pocket Monsters Gin (Japan)  ",
    "productCode": "DMG-AAXJ-JPN"
  },
  "1474": {
    "name": "Alleyway (World)",
    "productCode": "DMG-AWA"
  },
  "441": {
    "name": "Tottoko Hamutarou - Tomodachi Daisakusen Dechu (Japan)",
    "productCode": "CGB-BHTJ-JPN"
  },
  "2608": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1927": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "912": {
    "name": "Space-Net - Cosmo Red (Japan)",
    "productCode": "CGB-BREJ-JPN"
  },
  "2258": {
    "name": "Kirby no Kirakira Kids (Japan) ",
    "productCode": "DMG-AKCJ-JPN"
  },
  "2576": {
    "name": "Meitantei Conan - Karakuri Jiin Satsujin Jiken (Japan) ",
    "productCode": "DMG-A4BJ-JPN"
  },
  "2126": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "695": {
    "name": "Yoshi no Panepon",
    "productCode": "DMG-AYLJ-JPN"
  },
  "2825": {
    "name": "Donkey Kong Land (Japan) ",
    "productCode": "DMG-ADDJ-JPN"
  },
  "380": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "2960": {
    "name": "Power Mission (Japan)",
    "productCode": "DMG-XCA"
  },
  "2433": {
    "name": "Mini 4 Boy (Japan) ",
    "productCode": "DMG-AJ4J-JPN"
  },
  "2063": {
    "name": "Medarot 3 - Kabuto Version (Japan)",
    "productCode": "CGB-B32J-JPN"
  },
  "2599": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1566": {
    "name": "Ou Dorobou Jing - Devil Version (Japan) ",
    "productCode": "DMG-AZKJ-JPN"
  },
  "553": {
    "name": "Penguin Wars (USA)",
    "productCode": "DMG-PWJ"
  },
  "1136": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "103": {
    "name": "Play Action Football (USA)",
    "productCode": "DMG-FL-USA"
  },
  "1835": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "800": {
    "name": "Shrek - Fairy Tale Freakdown (USA, Europe) ",
    "productCode": "CGB-PFUE-USA"
  },
  "945": {
    "name": "Bakuten Shoot Beyblade (Japan)",
    "productCode": "CGB-BB3J-JPN"
  },
  "1970": {
    "name": "Soccer Boy (Japan)",
    "productCode": "DMG-SBA"
  },
  "416": {
    "name": "Pipe Dream (USA)",
    "productCode": "DMG-PDA"
  },
  "1423": {
    "name": "J.League Winning Goal (Japan)",
    "productCode": "DMG-W7J"
  },
  "1589": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1073": {
    "name": "Shougi (Japan)",
    "productCode": "DMG-SGJ"
  },
  "1264": {
    "name": "SolarStriker (USA)",
    "productCode": "DMG-SS-USA"
  },
  "251": {
    "name": "Famista (Japan)",
    "productCode": "DMG-FSJ"
  },
  "1634": {
    "name": "Double Yakuman II (Japan)",
    "productCode": "DMG-DVJ"
  },
  "601": {
    "name": "Phantom Zona (Japan) ",
    "productCode": "DMG-BKZJ-JPN"
  },
  "2448": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "2018": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "314": {
    "name": "Hamster Paradise 3 (Japan)",
    "productCode": "CGB-BH3J-JPN"
  },
  "1321": {
    "name": "Purikura Pocket 3 - Talent Debut Daisakusen (Japan) ",
    "productCode": "DMG-A3PJ-JPN"
  },
  "744": {
    "name": "SolarStriker (World)",
    "productCode": "DMG-SSA"
  },
  "1771": {
    "name": "Tennis (World)",
    "productCode": "DMG-TNA"
  },
  "894": {
    "name": "Doraemon - Taiketsu Himitsu Dougu (Japan)",
    "productCode": "DMG-DEJ"
  },
  "2274": {
    "name": "TUROK RAGE WARS (USA)",
    "productCode": "CGB-AR7E-USA"
  },
  "2624": {
    "name": "Selection - Erabareshi Mono (Japan)",
    "productCode": "DMG-SEJ"
  },
  "197": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "1458": {
    "name": "Kawa no Nushi Tsuri 3 (Japan) ",
    "productCode": "DMG-A7KJ-JPN"
  },
  "3035": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "1008": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "528": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "482": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "178": {
    "name": "Cyborg Kuro-chan 2 - White Woods no Gyakushuu (Japan)",
    "productCode": "CGB-BSBJ-JPN"
  },
  "20": {
    "name": "Kirby no Block Ball (Japan) ",
    "productCode": "DMG-AKXJ-JPN"
  },
  "2331": {
    "name": "QIX (World)",
    "productCode": "DMG-QXA"
  },
  "2761": {
    "name": "Bishoujo Senshi Sailor Moon R (Japan)",
    "productCode": "DMG-QAJ"
  },
  "656": {
    "name": "Wataru Mazekko Monster 2 (Japan) ",
    "productCode": "DMG-AWMJ-JPN"
  },
  "1399": {
    "name": "Hamster Paradise 3 (Japan)",
    "productCode": "CGB-BH3J-JPN"
  },
  "1663": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "206": {
    "name": "Yoshi no Panepon",
    "productCode": "DMG-AYLJ-JPN"
  },
  "1233": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2809": {
    "name": "The Powerpuff Girls - Battle Him (USA)",
    "productCode": "CGB-BBHE-USA"
  },
  "1726": {
    "name": "Mini 4 Boy (Japan) ",
    "productCode": "DMG-AJ4J-JPN"
  },
  "713": {
    "name": "Triple Play 2001 (USA)",
    "productCode": "CGB-BTPE-USA"
  },
  "1376": {
    "name": "Hamster Paradise",
    "productCode": "DMG-AHMJ-JPN"
  },
  "343": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "590": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "3062": {
    "name": "Hamster Paradise 3 (Japan)",
    "productCode": "CGB-BH3J-JPN"
  },
  "2673": {
    "name": "World Cup USA '94 (Japan) ",
    "productCode": "DMG-W9A"
  },
  "98": {
    "name": "Pocket Monsters - Pikachu (Japan)  ",
    "productCode": "DMG-APSJ-JPN"
  },
  "2389": {
    "name": "Bakuten Shoot Beyblade (Japan)",
    "productCode": "CGB-BB3J-JPN"
  },
  "969": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2223": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "2736": {
    "name": "Crayon Shin-chan - Ora to Shiro wa Otomodachi Da yo (Japan)",
    "productCode": "DMG-K4J"
  },
  "1819": {
    "name": "Pocket Monsters Kin (Japan)  ",
    "productCode": "DMG-AAUJ-JPN"
  },
  "986": {
    "name": "Medarot 2 - Kabuto Version (Japan) ",
    "productCode": "DMG-A2MJ-JPN"
  },
  "77": {
    "name": "Megami Tensei Gaiden - Last Bible II (Japan)",
    "productCode": "DMG-M9J"
  },
  "2366": {
    "name": "Medarot 4 - Kabuto Version (Japan)",
    "productCode": "CGB-B4MJ-JPN"
  },
  "1225": {
    "name": "Fushigi no Dungeon Fuurai No Shiren (Japan) ",
    "productCode": "DMG-AFDJ-JPN"
  },
  "210": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1675": {
    "name": "Ultraman Club - Tekikaijuu o Hakken seyo! (Japan)",
    "productCode": "DMG-ULJ"
  },
  "640": {
    "name": "Mario Tennis GB (Japan)",
    "productCode": "CGB-BM8J-JPN"
  },
  "2409": {
    "name": "CyberTiger (USA)",
    "productCode": "CGB-BCTE-USA"
  },
  "2059": {
    "name": "Penguin Wars (USA)",
    "productCode": "DMG-PWJ"
  },
  "355": {
    "name": "Hamster Club (Japan)",
    "productCode": "DMG-AJNJ-JPN"
  },
  "1360": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "705": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1730": {
    "name": "Pocket Pro Yakyuu (Japan)",
    "productCode": "CGB-BPPJ-JPN"
  },
  "2235": {
    "name": "Shin Megami Tensei Devil Children - Aka no Sho (Japan) ",
    "productCode": "DMG-BHNJ-JPN"
  },
  "2665": {
    "name": "Karakuri Kengou Den - Musashi Lord (Japan)",
    "productCode": "DMG-MUJ"
  },
  "1419": {
    "name": "Tottoko Hamutarou 2 (Japan)",
    "productCode": "CGB-B86J-JPN"
  },
  "1049": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "586": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "569": {
    "name": "Beatmania GB2 - Gotcha Mix (Japan) ",
    "productCode": "DMG-A2GJ-JPN"
  },
  "139": {
    "name": "Power Pro Kun Pocket 2 (Japan) ",
    "productCode": "DMG-BPWJ-JPN"
  },
  "2370": {
    "name": "GB Pachi-Slot Hisshouhou! Jr (Japan)",
    "productCode": "DMG-IPJ"
  },
  "61": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "990": {
    "name": "Dr. Rin ni Kiitemite! - Koi no Rin Fuusui (Japan)",
    "productCode": "CGB-BDFJ-JPN"
  },
  "2720": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "617": {
    "name": "Mickey Mouse II (Japan)",
    "productCode": "DMG-M2A"
  },
  "1622": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1788": {
    "name": "Mortal Kombat 3 (USA)",
    "productCode": "DMG-A3ME-USA"
  },
  "247": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "1272": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1767": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "2848": {
    "name": "Gakkyuu Ou Yamazaki (Japan) ",
    "productCode": "DMG-AYMJ-JPN"
  },
  "752": {
    "name": "Makai Toushi Sa-Ga (Japan)",
    "productCode": "DMG-SAJ"
  },
  "1337": {
    "name": "Meitantei Conan - Giwaku no Gouka Ressha (Japan) ",
    "productCode": "DMG-ADKJ-JPN"
  },
  "302": {
    "name": "Honoo no Toukyuuji - Dodge Danpei (Japan)",
    "productCode": "DMG-DAJ"
  },
  "3023": {
    "name": "Sanrio Carnival (Japan)",
    "productCode": "DMG-CSJ"
  },
  "181": {
    "name": "B-Daman Bakugaiden - Victory e no Michi (Japan) ",
    "productCode": "DMG-AOKJ-JPN"
  },
  "2632": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "928": {
    "name": "Pocket Monsters - Aka (Japan)  ",
    "productCode": "DMG-APAJ-JPN"
  },
  "2262": {
    "name": "Pocket Mahjong (Japan)",
    "productCode": "DMG-ABGJ-JPN"
  },
  "882": {
    "name": "The XVII Olympic Winter Games - Lillehammer 1994 (USA)",
    "productCode": "DMG-YC-USA"
  },
  "2798": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "1858": {
    "name": "Ultraman Club - Tekikaijuu o Hakken seyo! (Japan)",
    "productCode": "DMG-ULJ"
  },
  "2777": {
    "name": "Bomber Man GB (Japan) ",
    "productCode": "DMG-EEJ"
  },
  "2327": {
    "name": "Crayon Shin-chan 2 - Ora to Wanpaku Gokko Dazo (Japan)",
    "productCode": "DMG-COJ"
  },
  "36": {
    "name": "Puyo Puyo (Japan)  ",
    "productCode": "DMG-QQJ"
  },
  "494": {
    "name": "Mickey Mouse (Japan)",
    "productCode": "DMG-MMA"
  },
  "549": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "1086": {
    "name": "Jordan vs Bird - One on One (Japan)",
    "productCode": "DMG-JBA"
  },
  "119": {
    "name": "MIGHTY MORPHIN POWER RANGERS THE MOVIE (USA)",
    "productCode": "DMG-A2RE-USA"
  },
  "2350": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "41": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1985": {
    "name": "Kirby no Kirakira Kids (Japan) ",
    "productCode": "DMG-AKCJ-JPN"
  },
  "2700": {
    "name": "Pro Mahjong Kiwame GB II (Japan) ",
    "productCode": "DMG-AA2J-JPN"
  },
  "2215": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2645": {
    "name": "Bases Loaded for Game Boy (USA)",
    "productCode": "DMG-BK-USA"
  },
  "1439": {
    "name": "Bakuten Shoot Beyblade (Japan)",
    "productCode": "CGB-BB3J-JPN"
  },
  "1593": {
    "name": "Mahoujin Guruguru (Japan) ",
    "productCode": "DMG-AMGJ-JPN"
  },
  "3054": {
    "name": "Boxing (Japan)",
    "productCode": "DMG-BXA"
  },
  "1069": {
    "name": "Zelda no Densetsu - Yume o Miru Shima (Japan)",
    "productCode": "DMG-ZLJ"
  },
  "2096": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2995": {
    "name": "Gakken - Rekishi 512",
    "productCode": "DMG-AR3J-JPN"
  },
  "375": {
    "name": "Pitfall: Beyond the Jungle (USA)",
    "productCode": "DMG-AFLE-USA"
  },
  "1340": {
    "name": "Pocket Monsters - Aka (Japan)  ",
    "productCode": "DMG-APAJ-JPN"
  },
  "725": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1710": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "1205": {
    "name": "Bokujou Monogatari GB (Japan)  ",
    "productCode": "DMG-AYWJ-JPN"
  },
  "230": {
    "name": "Kinniku Banzuke GB - Chousensha wa Kimida! (Japan) ",
    "productCode": "DMG-A5KJ-JPN"
  },
  "1655": {
    "name": "Crayon Shin-chan - Ora to Shiro wa Otomodachi Da yo (Japan)",
    "productCode": "DMG-K4J"
  },
  "660": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2429": {
    "name": "Captain Tsubasa VS (Japan)",
    "productCode": "DMG-T5J"
  },
  "2079": {
    "name": "TNN Outdoors Fishing Champ (USA) ",
    "productCode": "DMG-AFCE-USA"
  },
  "2583": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1878": {
    "name": "The Smurfs (USA)",
    "productCode": "DMG-UF-USA"
  },
  "2757": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "2307": {
    "name": "Twinbee Da!! (Japan)",
    "productCode": "DMG-TDJ"
  },
  "16": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1481": {
    "name": "Black Bass - Lure Fishing (USA)",
    "productCode": "DMG-ALFE-USA"
  },
  "3003": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "1194": {
    "name": "Moguranya (Japan) ",
    "productCode": "DMG-AMOJ-JPN"
  },
  "2612": {
    "name": "Bionic Battler (USA)",
    "productCode": "DMG-VSA"
  },
  "908": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2242": {
    "name": "Bishoujo Senshi Sailor Moon R (Japan)",
    "productCode": "DMG-QAJ"
  },
  "1897": {
    "name": "Pac-Man (USA)",
    "productCode": "DMG-PCA"
  },
  "288": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1747": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "2868": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "772": {
    "name": "Motocross Maniacs (Japan)",
    "productCode": "DMG-MXA"
  },
  "1317": {
    "name": "Pinball - 66hiki no Wani Daikoushin! (Japan)",
    "productCode": "DMG-PBJ"
  },
  "322": {
    "name": "World Bowling (Japan)",
    "productCode": "DMG-WBA"
  },
  "2491": {
    "name": "Seaside Volley (Japan)",
    "productCode": "DMG-SVJ"
  },
  "2184": {
    "name": "Mario Golf GB (Japan)",
    "productCode": "CGB-AWXJ-JPN"
  },
  "637": {
    "name": "Top Rank Tennis (USA)",
    "productCode": "DMG-XT-USA"
  },
  "1602": {
    "name": "Go! Go! Tank (USA)",
    "productCode": "DMG-GT-USA"
  },
  "2887": {
    "name": "Super Mario Land (World)",
    "productCode": "DMG-ML-USA"
  },
  "267": {
    "name": "Medarot 2 - Kuwagata Version (Japan) ",
    "productCode": "DMG-A2NJ-JPN"
  },
  "1252": {
    "name": "RUGRATS IN PARIS: THE MOVIE (USA)",
    "productCode": "CGB-BRPE-USA"
  },
  "508": {
    "name": "Ultra Golf (USA)",
    "productCode": "DMG-KGA"
  },
  "1497": {
    "name": "Choro Q - Hyper Customable GB (Japan) ",
    "productCode": "DMG-ACQJ-JPN"
  },
  "158": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "2311": {
    "name": "Makai Toushi Sa-Ga (Japan)",
    "productCode": "DMG-SAJ"
  },
  "2741": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1881": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "2254": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2604": {
    "name": "Hello Kitty's Cube Frenzy (USA)",
    "productCode": "DMG-AF4E-USA"
  },
  "1182": {
    "name": "Doraemon no Quiz Boy (Japan)",
    "productCode": "CGB-BQBJ-JPN"
  },
  "1478": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1028": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "3015": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "2487": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "334": {
    "name": "Sanrio Uranai Party (Japan)",
    "productCode": "DMG-AG7J-JPN"
  },
  "1301": {
    "name": "Dino Breeder (Japan)  ",
    "productCode": "DMG-AWDJ-JPN"
  },
  "764": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1751": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "1244": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "271": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "2891": {
    "name": "From TV Animation Slam Dunk - Gakeppuchi no Kesshou League (Japan) ",
    "productCode": "DMG-HXJ"
  },
  "1614": {
    "name": "Medarot 2 - Kabuto Version (Japan) ",
    "productCode": "DMG-A2MJ-JPN"
  },
  "621": {
    "name": "Mario Golf GB (Japan)",
    "productCode": "CGB-AWXJ-JPN"
  },
  "2468": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "2192": {
    "name": "Donkey Kong Land (Japan) ",
    "productCode": "DMG-ADDJ-JPN"
  },
  "2038": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "2716": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1839": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "1993": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "57": {
    "name": "Pocket Monsters - Pikachu (Japan)  ",
    "productCode": "DMG-APSJ-JPN"
  },
  "2346": {
    "name": "Senkai Ibunroku Juntei Taisen - TV Animation Senkaiden Houshin Engi Yori (Japan) ",
    "productCode": "DMG-BHSJ-JPN"
  },
  "1090": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "3042": {
    "name": "Game Boy Wars (Japan)",
    "productCode": "DMG-GWJ"
  },
  "1585": {
    "name": "Wheel of Fortune (USA)",
    "productCode": "DMG-WF-USA"
  },
  "2653": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "949": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "2203": {
    "name": "Hyper Lode Runner",
    "productCode": "DMG-HLA"
  },
  "2829": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "1706": {
    "name": "Flipull (USA)",
    "productCode": "DMG-FP-USA"
  },
  "733": {
    "name": "Downtown - Nekketsu Koushinkyoku - Dokodemo Daiundoukai (Japan)",
    "productCode": "DMG-DUJ"
  },
  "1356": {
    "name": "Hunter X Hunter - Hunter no Keifu (Japan)",
    "productCode": "CGB-BHHJ-JPN"
  },
  "699": {
    "name": "Meitantei Conan - Chika Yuuenchi Satsujin Jiken (Japan) ",
    "productCode": "DMG-ADCJ-JPN"
  },
  "363": {
    "name": "Bokujou Monogatari GB (Japan)  ",
    "productCode": "DMG-AYWJ-JPN"
  },
  "2983": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "2080": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "2595": {
    "name": "Game Boy Gallery 3 (Japan) ",
    "productCode": "DMG-AGQJ-JPN"
  },
  "676": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1643": {
    "name": "Hokuto no Ken - Seizetsu Juuban Shoubu (Japan)",
    "productCode": "DMG-HKJ"
  },
  "226": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "1213": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1004": {
    "name": "WWF Superstars 2 (Japan)",
    "productCode": "DMG-WXA"
  },
  "3039": {
    "name": "Wataru Mazekko Monster (Japan) ",
    "productCode": "DMG-AWAJ-JPN"
  },
  "1454": {
    "name": "Buster Bros. (USA)",
    "productCode": "DMG-AGNJ-JPN"
  },
  "461": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2628": {
    "name": "Monster Maker (Japan)",
    "productCode": "DMG-MRJ"
  },
  "1907": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "932": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "2278": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "898": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "2782": {
    "name": "Honkaku Yonin Uchi Mahjong - Mahjong Ou (Japan) ",
    "productCode": "DMG-AAAJ-JPN"
  },
  "877": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQIJ-JPN"
  },
  "2297": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1842": {
    "name": "SpongeBob SquarePants - Legend of the Lost Spatula (USA, Europe)",
    "productCode": "CGB-BQPP-EUR"
  },
  "174": {
    "name": "Dungeon Land (Japan)",
    "productCode": "DMG-DGJ"
  },
  "1141": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "524": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "1511": {
    "name": "Power Pro GB (Japan)  ",
    "productCode": "DMG-APWJ-JPN"
  },
  "2014": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2444": {
    "name": "Bokujou Monogatari GB2 (Japan)",
    "productCode": "DMG-A37J-JPN"
  },
  "2917": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1638": {
    "name": "Boomer's Adventure in ASMIK World (USA)",
    "productCode": "DMG-AS-USA"
  },
  "1792": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "1268": {
    "name": "Shougi 3 (Japan)",
    "productCode": "DMG-B9SJ-JPN"
  },
  "2852": {
    "name": "Donkey Kong Land (Japan) ",
    "productCode": "DMG-ADDJ-JPN"
  },
  "1287": {
    "name": "Kirby no Block Ball (Japan) ",
    "productCode": "DMG-AKXJ-JPN"
  },
  "748": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "318": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2151": {
    "name": "Flappy Special (Japan)",
    "productCode": "DMG-V2A"
  },
  "2501": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "965": {
    "name": "Donkey Kong GB - Dinky Kong & Dixie Kong (Japan)",
    "productCode": "CGB-AD3J-JPN"
  },
  "94": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2385": {
    "name": "Jinsei Game - Tomodachi Takusan Tsukurou yo! (Japan) ",
    "productCode": "DMG-ACJJ-JPN"
  },
  "1950": {
    "name": "Honoo no Toukyuuji - Dodge Danpei (Japan)",
    "productCode": "DMG-DAJ"
  },
  "436": {
    "name": "Soldam (Japan)",
    "productCode": "DMG-S9J"
  },
  "1403": {
    "name": "Meitantei Conan - Giwaku no Gouka Ressha (Japan) ",
    "productCode": "DMG-ADKJ-JPN"
  },
  "1053": {
    "name": "Donkey Kong 2001 (Japan)",
    "productCode": "CGB-BDDJ-JPN"
  },
  "1546": {
    "name": "Zelda no Densetsu - Yume o Miru Shima (Japan)",
    "productCode": "DMG-ZLJ"
  },
  "573": {
    "name": "Mini 4 Boy (Japan) ",
    "productCode": "DMG-AJ4J-JPN"
  },
  "1116": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "123": {
    "name": "Kizuchi da Quiz da Gen-san da! (Japan)",
    "productCode": "DMG-QGJ"
  },
  "2690": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1815": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "820": {
    "name": "Kakomunja Serpent (USA)",
    "productCode": "DMG-KMJ"
  },
  "2940": {
    "name": "Pinball - 66hiki no Wani Daikoushin! (Japan)",
    "productCode": "DMG-PBJ"
  },
  "1395": {
    "name": "Sanrio Uranai Party (Japan)",
    "productCode": "DMG-AG7J-JPN"
  },
  "2413": {
    "name": "Bomber Man GB (Japan) ",
    "productCode": "DMG-EEJ"
  },
  "2043": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "2556": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "2106": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "1680": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2805": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1045": {
    "name": "Picross 2 (Japan) ",
    "productCode": "DMG-AP2J-JPN"
  },
  "1415": {
    "name": "Medarot 3 - Kuwagata Version (Japan)",
    "productCode": "CGB-B33J-JPN"
  },
  "420": {
    "name": "Medarot Cardrobottle - Kabuto Version (Japan) ",
    "productCode": "DMG-A8CJ-JPN"
  },
  "1946": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "2669": {
    "name": "Magical Taruruuto-kun (Japan)",
    "productCode": "DMG-MGJ"
  },
  "2393": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "82": {
    "name": "Kirby no Kirakira Kids (Japan) ",
    "productCode": "DMG-AKCJ-JPN"
  },
  "6": {
    "name": "DuckTales (Japan)",
    "productCode": "DMG-DTJ"
  },
  "973": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "2239": {
    "name": "Kikou Keisatsu Metal Jack (Japan)",
    "productCode": "DMG-M5J"
  },
  "836": {
    "name": "Medarot - Kuwagata Version (Japan)",
    "productCode": "DMG-AMYJ-JPN"
  },
  "1803": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2686": {
    "name": "Home Alone 2 Lost In New York (USA)",
    "productCode": "DMG-AHHJ-JPN"
  },
  "135": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1100": {
    "name": "Yu Yu Hakusho Dai-3-tama : Makai no Tobira (Japan)",
    "productCode": "DMG-UGJ"
  },
  "565": {
    "name": "The Jungle Book - Mowgli's Wild Adventure (USA) ",
    "productCode": "CGB-BJGE-USA"
  },
  "1550": {
    "name": "Wataru Mazekko Monster (Japan) ",
    "productCode": "DMG-AWAJ-JPN"
  },
  "2055": {
    "name": "Bomber Boy (Japan)",
    "productCode": "DMG-HBA"
  },
  "2405": {
    "name": "Shanghai (Japan) (Activision)",
    "productCode": "DMG-SHJ"
  },
  "1383": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "1679": {
    "name": "Beauty and the Beast - A Board Game Adventure (USA) ",
    "productCode": "DMG-AVUE-USA"
  },
  "2956": {
    "name": "Sylvanian Melodies - Mori no Nakama to Odori Masho! (Japan) ",
    "productCode": "DMG-BMKJ-JPN"
  },
  "1229": {
    "name": "From TV Animation Slam Dunk - Gakeppuchi no Kesshou League (Japan) ",
    "productCode": "DMG-HXJ"
  },
  "2813": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "709": {
    "name": "NFL Blitz (USA)",
    "productCode": "DMG-ABZE-USA"
  },
  "359": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "1696": {
    "name": "Kawa no Nushi Tsuri 3 (Japan) ",
    "productCode": "DMG-A7KJ-JPN"
  },
  "2110": {
    "name": "Yu-Gi-Oh! - Dark Duel Stories (USA)",
    "productCode": "CGB-BY3E-USA"
  },
  "2540": {
    "name": "Chicken Run (USA)",
    "productCode": "CGB-BCKE-USA"
  },
  "2794": {
    "name": "Tennis (World)",
    "productCode": "DMG-TNA"
  },
  "924": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1911": {
    "name": "Doraemon Kart (Japan) ",
    "productCode": "DMG-ADRJ-JPN"
  },
  "477": {
    "name": "World Cup Striker (Japan)",
    "productCode": "DMG-YKA"
  },
  "1442": {
    "name": "Kinniku Banzuke GB2 - Mezase! Muscle Champion (Japan) ",
    "productCode": "DMG-B6KJ-JPN"
  },
  "1012": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1507": {
    "name": "Monster Farm Battle Card GB (Japan) ",
    "productCode": "DMG-A6TJ-JPN"
  },
  "532": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "498": {
    "name": "Power Pro Kun Pocket 2 (Japan) ",
    "productCode": "DMG-BPWJ-JPN"
  },
  "1157": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "162": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1854": {
    "name": "Keitai Denjuu Telefang - Power Version (Japan)",
    "productCode": "DMG-BTXJ-JPN"
  },
  "2281": {
    "name": "Higashio Osamu Kanshuu Pro Yakyuu Stadium '91 (Japan)",
    "productCode": "DMG-PIJ"
  },
  "861": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "1784": {
    "name": "Who Wants to Be a Millionaire - 2nd Edition (USA)",
    "productCode": "CGB-BMOE-USA"
  },
  "2901": {
    "name": "DX Jinsei Game (Japan)",
    "productCode": "CGB-BZGJ-JPN"
  },
  "2452": {
    "name": "Mario Tennis GB (Japan)",
    "productCode": "CGB-BM8J-JPN"
  },
  "2002": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "2517": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "2147": {
    "name": "Dance Dance Revolution GB (Japan)",
    "productCode": "CGB-BDGJ-JPN"
  },
  "1291": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2844": {
    "name": "Golf (World)",
    "productCode": "DMG-GO-USA"
  },
  "1785": {
    "name": "Double Yakuman (Japan)",
    "productCode": "DMG-YVJ"
  },
  "2900": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "2453": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "2003": {
    "name": "Warriors of Might and Magic (USA) ",
    "productCode": "CGB-BMME-USA"
  },
  "2516": {
    "name": "Monster Race (Japan) ",
    "productCode": "DMG-AMRJ-JPN"
  },
  "2146": {
    "name": "Medarot 2 - Kabuto Version (Japan) ",
    "productCode": "DMG-A2MJ-JPN"
  },
  "1290": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "2845": {
    "name": "Penguin Wars (USA)",
    "productCode": "DMG-PWJ"
  },
  "2795": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "925": {
    "name": "Patlabor: The Mobile Police",
    "productCode": "DMG-MOJ"
  },
  "1910": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "476": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "1443": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "1013": {
    "name": "Cubix - Robots for Everyone - Race 'n Robots (USA) ",
    "productCode": "CGB-BCXE-USA"
  },
  "1506": {
    "name": "Chachamaru Panic (Japan)",
    "productCode": "DMG-CCJ"
  },
  "533": {
    "name": "Bomber Boy (Japan)",
    "productCode": "DMG-HBA"
  },
  "1156": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "499": {
    "name": "Bokujou Monogatari GB (Japan)  ",
    "productCode": "DMG-AYWJ-JPN"
  },
  "163": {
    "name": "Medarot - Kabuto Version (Japan) ",
    "productCode": "DMG-AMXJ-JPN"
  },
  "1855": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "860": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2280": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "2054": {
    "name": "Mini Yonku GB Let's & Go!! (Japan) ",
    "productCode": "DMG-AM4J-JPN"
  },
  "2404": {
    "name": "Nemesis (Japan)",
    "productCode": "DMG-NMA"
  },
  "1382": {
    "name": "Doraemon 2 - Animal Planet Densetsu (Japan)",
    "productCode": "DMG-DMJ"
  },
  "1678": {
    "name": "QIX (World)",
    "productCode": "DMG-QXA"
  },
  "2957": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1228": {
    "name": "Medarot - Kuwagata Version (Japan)",
    "productCode": "DMG-AMYJ-JPN"
  },
  "2812": {
    "name": "Home Alone 2 Lost In New York (USA)",
    "productCode": "DMG-AHHJ-JPN"
  },
  "708": {
    "name": "Trip World (Europe)",
    "productCode": "DMG-T4-NOE"
  },
  "1697": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "358": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "2111": {
    "name": "Donkey Kong (World)  ",
    "productCode": "DMG-QDA"
  },
  "2541": {
    "name": "Makai Toushi Sa-Ga (Japan)",
    "productCode": "DMG-SAJ"
  },
  "1044": {
    "name": "From TV Animation One Piece - Maboroshi no Grand Line Boukenki! (Japan) ",
    "productCode": "DMG-BZOJ-JPN"
  },
  "1414": {
    "name": "Bomber Boy (Japan)",
    "productCode": "DMG-HBA"
  },
  "421": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1947": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2668": {
    "name": "Capcom Quiz - Hatena no Daibouken (Japan)",
    "productCode": "DMG-HHJ"
  },
  "972": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "7": {
    "name": "Yoshi no Panepon",
    "productCode": "DMG-AYLJ-JPN"
  },
  "2392": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "83": {
    "name": "Momotarou Dentetsu jr. - Zenkoku Ramen Meguri no Maki (Japan) ",
    "productCode": "DMG-AD8J-JPN"
  },
  "2238": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "837": {
    "name": "Mario Tennis GB (Japan)",
    "productCode": "CGB-BM8J-JPN"
  },
  "1802": {
    "name": "Pocket Bass Fishing (Japan)",
    "productCode": "DMG-ABFJ-JPN"
  },
  "2687": {
    "name": "Rockman World 1",
    "productCode": "DMG-RWA"
  },
  "134": {
    "name": "Hamster Club 2 (Japan)",
    "productCode": "DMG-BJNJ-JPN"
  },
  "1101": {
    "name": "Crayon Shin-chan 2 - Ora to Wanpaku Gokko Dazo (Japan)",
    "productCode": "DMG-COJ"
  },
  "564": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1551": {
    "name": "Othello World (Japan) ",
    "productCode": "DMG-ATOJ-JPN"
  },
  "2941": {
    "name": "From TV Animation One Piece - Maboroshi no Grand Line Boukenki! (Japan) ",
    "productCode": "DMG-BZOJ-JPN"
  },
  "1394": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2412": {
    "name": "Kizuchi da Quiz da Gen-san da! (Japan)",
    "productCode": "DMG-QGJ"
  },
  "2042": {
    "name": "Love Hina Pocket (Japan)",
    "productCode": "CGB-BPHJ-JPN"
  },
  "2557": {
    "name": "Super Robot Taisen (Japan)",
    "productCode": "DMG-SZJ"
  },
  "2107": {
    "name": "Power Pro Kun Pocket (Japan)  ",
    "productCode": "DMG-AVVJ-JPN"
  },
  "1681": {
    "name": "Kawa no Nushi Tsuri 3 (Japan) ",
    "productCode": "DMG-A7KJ-JPN"
  },
  "2804": {
    "name": "Double Yakuman II (Japan)",
    "productCode": "DMG-DVJ"
  },
  "95": {
    "name": "Hokuto no Ken - Seizetsu Juuban Shoubu (Japan)",
    "productCode": "DMG-HKJ"
  },
  "2384": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "964": {
    "name": "Ranma 1-2 (Japan)",
    "productCode": "DMG-RNJ"
  },
  "1951": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "437": {
    "name": "Keitai Denjuu Telefang - Speed Version (Japan)",
    "productCode": "DMG-BTZJ-JPN"
  },
  "1402": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "1052": {
    "name": "Quarth (Japan)",
    "productCode": "DMG-QRJ"
  },
  "1547": {
    "name": "Kinniku Banzuke GB - Chousensha wa Kimida! (Japan) ",
    "productCode": "DMG-A5KJ-JPN"
  },
  "572": {
    "name": "Mario Tennis GB (Japan)",
    "productCode": "CGB-BM8J-JPN"
  },
  "1117": {
    "name": "Nekketsu Koukou Soccer-bu - World Cup Hen (Japan)",
    "productCode": "DMG-NCJ"
  },
  "122": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "2691": {
    "name": "Dino Breeder (Japan)  ",
    "productCode": "DMG-AWDJ-JPN"
  },
  "1814": {
    "name": "Puzzle Boy (Japan)",
    "productCode": "DMG-APJ"
  },
  "821": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "2015": {
    "name": "Shangai - Activision",
    "productCode": "DMG-ZZJ"
  },
  "2445": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2916": {
    "name": "Taikyoku Renju (Japan) ",
    "productCode": "DMG-TCA"
  },
  "1639": {
    "name": "Batman - The Video Game (World)",
    "productCode": "DMG-BAA"
  },
  "1793": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "1269": {
    "name": "Medarot 3 - Parts Collection - Z kara no Chousenjou (Japan)",
    "productCode": "CGB-B3PJ-JPN"
  },
  "2853": {
    "name": "Funny Field (Japan)",
    "productCode": "DMG-FUA"
  },
  "749": {
    "name": "From TV Animation One Piece - Maboroshi no Grand Line Boukenki! (Japan) ",
    "productCode": "DMG-BZOJ-JPN"
  },
  "1286": {
    "name": "Tottoko Hamutarou - Tomodachi Daisakusen Dechu (Japan)",
    "productCode": "CGB-BHTJ-JPN"
  },
  "319": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2150": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2500": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "3038": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1005": {
    "name": "Baseball Kids (Japan)",
    "productCode": "DMG-BKJ"
  },
  "1455": {
    "name": "Tottoko Hamutarou 2 (Japan)",
    "productCode": "CGB-B86J-JPN"
  },
  "460": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2629": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1906": {
    "name": "Donkey Kong GB - Dinky Kong & Dixie Kong (Japan)",
    "productCode": "CGB-AD3J-JPN"
  },
  "933": {
    "name": "Zoids - Jashin Fukkatsu! Genobreaker Hen (Japan)  ",
    "productCode": "DMG-BGZJ-JPN"
  },
  "899": {
    "name": "SolarStriker (World)",
    "productCode": "DMG-SSA"
  },
  "2279": {
    "name": "Picross 2 (Japan) ",
    "productCode": "DMG-AP2J-JPN"
  },
  "2783": {
    "name": "Game Boy Gallery 2 (Japan)",
    "productCode": "DMG-AGIJ-JPN"
  },
  "2296": {
    "name": "Tottoko Hamutarou 2 (Japan)",
    "productCode": "CGB-B86J-JPN"
  },
  "876": {
    "name": "From TV Animation One Piece - Maboroshi no Grand Line Boukenki! (Japan) ",
    "productCode": "DMG-BZOJ-JPN"
  },
  "1843": {
    "name": "OLYMPIC SUMMER GAMES (USA)",
    "productCode": "DMG-AO9E-USA"
  },
  "175": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1140": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "525": {
    "name": "Nekketsu Koukou Soccer-bu - World Cup Hen (Japan)",
    "productCode": "DMG-NCJ"
  },
  "1510": {
    "name": "Disney Pixar - MONSTERS INC (USA)",
    "productCode": "CGB-B4QE-USA"
  },
  "2828": {
    "name": "Penguin Wars (USA)",
    "productCode": "DMG-PWJ"
  },
  "1707": {
    "name": "Pro Mahjong Kiwame GB",
    "productCode": "DMG-AZZJ-JPN"
  },
  "732": {
    "name": "Super Black Bass Pocket (Japan) ",
    "productCode": "DMG-ABPJ-JPN"
  },
  "698": {
    "name": "Hamster Paradise 3 (Japan)",
    "productCode": "CGB-BH3J-JPN"
  },
  "1357": {
    "name": "Chibi Maruko-chan - Okozukai Daisakusen! (Japan)",
    "productCode": "DMG-CMJ"
  },
  "2982": {
    "name": "Medarot 2 - Kabuto Version (Japan) ",
    "productCode": "DMG-A2MJ-JPN"
  },
  "362": {
    "name": "Hunter X Hunter - Kindan no Hihou (Japan)",
    "productCode": "CGB-BHKJ-JPN"
  },
  "2081": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "2594": {
    "name": "Sanrio Uranai Party (Japan)",
    "productCode": "DMG-AG7J-JPN"
  },
  "677": {
    "name": "Sagaia (Japan)",
    "productCode": "DMG-S8A"
  },
  "1642": {
    "name": "Seaside Volley (Japan)",
    "productCode": "DMG-SVJ"
  },
  "227": {
    "name": "Medarot 2 - Parts Collection (Japan) ",
    "productCode": "DMG-A7CJ-JPN"
  },
  "1212": {
    "name": "Mickey's Ultimate Challenge (USA)",
    "productCode": "DMG-UV-USA"
  },
  "2717": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "1838": {
    "name": "Home Alone 2 Lost In New York (USA)",
    "productCode": "DMG-AHHJ-JPN"
  },
  "1992": {
    "name": "Bokujou Monogatari GB (Japan)  ",
    "productCode": "DMG-AYWJ-JPN"
  },
  "56": {
    "name": "Zelda no Densetsu - Yume o Miru Shima DX (Japan)  ",
    "productCode": "DMG-AZLJ-JPN"
  },
  "2347": {
    "name": "SD Sengokuden 2 - Tenka Touitsu Hen (Japan)",
    "productCode": "DMG-G3J"
  },
  "1091": {
    "name": "Super Chinese Land (Japan)",
    "productCode": "DMG-CLJ"
  },
  "3043": {
    "name": "Dracula Densetsu II (Japan)",
    "productCode": "DMG-CWJ"
  },
  "1584": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2652": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "948": {
    "name": "Sanrio Uranai Party (Japan)",
    "productCode": "DMG-AG7J-JPN"
  },
  "2202": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "2486": {
    "name": "Sa-Ga 2 - Hihou Densetsu (Japan)",
    "productCode": "DMG-S2J"
  },
  "335": {
    "name": "Wataru Mazekko Monster (Japan) ",
    "productCode": "DMG-AWAJ-JPN"
  },
  "1300": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "765": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "1750": {
    "name": "Power Pro Kun Pocket 2 (Japan) ",
    "productCode": "DMG-BPWJ-JPN"
  },
  "1245": {
    "name": "G-Arms Operation Gundam",
    "productCode": "DMG-GAJ"
  },
  "2890": {
    "name": "Cyborg Kuro-chan - Devil Fukkatsu (Japan)",
    "productCode": "CGB-BSKJ-JPN"
  },
  "270": {
    "name": "Purikura Pocket (Japan) ",
    "productCode": "DMG-APPJ-JPN"
  },
  "1615": {
    "name": "F-1 Spirit (Japan)",
    "productCode": "DMG-FZJ"
  },
  "620": {
    "name": "Kirby no Block Ball (Japan) ",
    "productCode": "DMG-AKXJ-JPN"
  },
  "2469": {
    "name": "Medarot - Kuwagata Version (Japan)",
    "productCode": "DMG-AMYJ-JPN"
  },
  "2193": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2039": {
    "name": "The Jungle Book (USA, Europe)",
    "productCode": "DMG-J7-USA"
  },
  "509": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "159": {
    "name": "Tetris Flash (Japan) ",
    "productCode": "DMG-EHJ"
  },
  "1496": {
    "name": "Double Yakuman (Japan)",
    "productCode": "DMG-YVJ"
  },
  "2310": {
    "name": "T2: Terminator 2 The Arcade Game (USA)",
    "productCode": "DMG-AV-USA"
  },
  "2740": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "1880": {
    "name": "Quest for Camelot (USA)  ",
    "productCode": "DMG-ACNE-USA"
  },
  "2255": {
    "name": "Sanrio Uranai Party (Japan)",
    "productCode": "DMG-AG7J-JPN"
  },
  "2605": {
    "name": "Shaman King Card Game - Chou Senjiryakketsu - Funbari Hen (Japan)",
    "productCode": "CGB-BQUJ-JPN"
  },
  "1183": {
    "name": "Bomber Man GB (Japan) ",
    "productCode": "DMG-EEJ"
  },
  "1479": {
    "name": "SD Gundam Gaiden : Lacroan' Heroes (Japan)",
    "productCode": "DMG-LHJ"
  },
  "3014": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1029": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "1746": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2869": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "289": {
    "name": "Malibu Beach Volleyball (USA)",
    "productCode": "DMG-SV-USA"
  },
  "773": {
    "name": "From TV Animation One Piece - Maboroshi no Grand Line Boukenki! (Japan) ",
    "productCode": "DMG-BZOJ-JPN"
  },
  "1316": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "323": {
    "name": "Tottoko Hamutarou - Tomodachi Daisakusen Dechu (Japan)",
    "productCode": "CGB-BHTJ-JPN"
  },
  "2490": {
    "name": "Flappy Special (Japan)",
    "productCode": "DMG-V2A"
  },
  "2185": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "636": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1603": {
    "name": "DX Bakenou Z (Japan)",
    "productCode": "DMG-DZJ"
  },
  "266": {
    "name": "Space Invaders (Japan)",
    "productCode": "DMG-SPA"
  },
  "2886": {
    "name": "Shougi (Japan)",
    "productCode": "DMG-SGJ"
  },
  "1253": {
    "name": "F1 Boy (Japan)",
    "productCode": "DMG-FBJ"
  },
  "1879": {
    "name": "Mario Tennis GB (Japan)",
    "productCode": "CGB-BM8J-JPN"
  },
  "2756": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "2306": {
    "name": "CROC 2 (USA)",
    "productCode": "CGB-BK2E-USA"
  },
  "17": {
    "name": "Sanrio Uranai Party (Japan)",
    "productCode": "DMG-AG7J-JPN"
  },
  "1480": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "3002": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1195": {
    "name": "Tetris DX (World)  ",
    "productCode": "DMG-ATEA-JPN"
  },
  "2613": {
    "name": "Boomer's Adventure in ASMIK World (USA)",
    "productCode": "DMG-ASJJ-JPN"
  },
  "909": {
    "name": "Cubix - Robots for Everyone - Race 'n Robots (USA) ",
    "productCode": "CGB-BCXE-USA"
  },
  "2243": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "1896": {
    "name": "SOCCER - Tonkin House (Japan) ",
    "productCode": "DMG-GSA"
  },
  "2097": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "374": {
    "name": "Puzzle Nintama Rantarou (Japan) ",
    "productCode": "DMG-APNJ-JPN"
  },
  "2994": {
    "name": "Tottoko Hamutarou 2 (Japan)",
    "productCode": "CGB-B86J-JPN"
  },
  "1341": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "724": {
    "name": "Ultraman (Japan)",
    "productCode": "DMG-UNJ"
  },
  "1711": {
    "name": "Tiny Toon Adventures 2 (Japan)",
    "productCode": "DMG-T8J"
  },
  "1204": {
    "name": "Sanrio Uranai Party (Japan)",
    "productCode": "DMG-AG7J-JPN"
  },
  "231": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1654": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VU-USA-1"
  },
  "661": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "2428": {
    "name": "Puyo Puyo (Japan)  ",
    "productCode": "DMG-QQJ"
  },
  "2078": {
    "name": "Kinniku Banzuke GB2 - Mezase! Muscle Champion (Japan) ",
    "productCode": "DMG-B6KJ-JPN"
  },
  "2582": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1087": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "548": {
    "name": "Bo Jackson - Two Games in One (USA)",
    "productCode": "DMG-BJ-USA"
  },
  "118": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2351": {
    "name": "Animal Breeder (Japan) ",
    "productCode": "DMG-AJAJ-JPN"
  },
  "40": {
    "name": "Pokemon - Red Version (USA, Europe) ",
    "productCode": "DMG-APAE-USA"
  },
  "1984": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "2701": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2214": {
    "name": "Rugrats Time Travelers (USA)",
    "productCode": "DMG-AVME-USA"
  },
  "2644": {
    "name": "Super B-Daman - Fighting Phoenix (Japan) ",
    "productCode": "DMG-ABDJ-JPN"
  },
  "1438": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1592": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "1068": {
    "name": "The Addams Family (USA)",
    "productCode": "DMG-AFFJ-JPN"
  },
  "3055": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "3022": {
    "name": "Nakajima Satoru - F-1 Hero GB - World Championship '91 (Japan)",
    "productCode": "DMG-F3J"
  },
  "180": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2633": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "929": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "883": {
    "name": "Hokuto no Ken - Seizetsu Juuban Shoubu (Japan)",
    "productCode": "DMG-HKJ"
  },
  "2263": {
    "name": "Pitman (Japan)",
    "productCode": "DMG-PMA"
  },
  "2799": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1859": {
    "name": "Nekketsu Kouha Kunio-kun - Bangai Rantou Hen (Japan)",
    "productCode": "DMG-KUJ"
  },
  "2776": {
    "name": "Gex 3 - Deep Pocket Gecko (USA)",
    "productCode": "CGB-AXGE-USA"
  },
  "2326": {
    "name": "Bishoujo Senshi Sailor Moon R (Japan)",
    "productCode": "DMG-QAJ"
  },
  "37": {
    "name": "X (Japan)",
    "productCode": "DMG-ECJ"
  },
  "495": {
    "name": "Nekketsu Kouha Kunio-kun - Bangai Rantou Hen (Japan)",
    "productCode": "DMG-KUJ"
  },
  "616": {
    "name": "DuckTales 2 (Japan)",
    "productCode": "DMG-Z2J"
  },
  "1623": {
    "name": "Super B-Daman - Fighting Phoenix (Japan) ",
    "productCode": "DMG-ABDJ-JPN"
  },
  "246": {
    "name": "Boomer's Adventure in ASMIK World (USA)",
    "productCode": "DMG-AS2J-JPN"
  },
  "1789": {
    "name": "Power Pro Kun Pocket (Japan)  ",
    "productCode": "DMG-AVVJ-JPN"
  },
  "1273": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "1766": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2849": {
    "name": "Hamster Paradise",
    "productCode": "DMG-AHMJ-JPN"
  },
  "753": {
    "name": "Bishoujo Senshi Sailor Moon (Japan)",
    "productCode": "DMG-AQJ"
  },
  "1336": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "303": {
    "name": "Aretha",
    "productCode": "DMG-A1J"
  },
  "2234": {
    "name": "Nekketsu Kouha Kunio-kun - Bangai Rantou Hen (Japan)",
    "productCode": "DMG-KUJ"
  },
  "2664": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "1418": {
    "name": "Makai Toushi Sa-Ga (Japan)",
    "productCode": "DMG-SAJ"
  },
  "587": {
    "name": "Goukaku Boy GOLD - Shikakui Atama o Maruku Suru - Joushiki no Sho (Japan)",
    "productCode": "DMG-AM5J-JPN"
  },
  "1048": {
    "name": "Doraemon Kart 2 (Japan) ",
    "productCode": "DMG-ADOJ-JPN"
  },
  "568": {
    "name": "Double Dragon (Japan)",
    "productCode": "DMG-DDA"
  },
  "138": {
    "name": "Dai-2-ji Super Robot Taisen G (Japan) ",
    "productCode": "DMG-AG2J-JPN"
  },
  "991": {
    "name": "Disney Mickey Mouse Magic Wands (USA)",
    "productCode": "DMG-I5-USA"
  },
  "2371": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "60": {
    "name": "Fushigi no Dungeon Fuurai No Shiren (Japan) ",
    "productCode": "DMG-AFDJ-JPN"
  },
  "2721": {
    "name": "Kawa no Nushi Tsuri 3 (Japan) ",
    "productCode": "DMG-A7KJ-JPN"
  },
  "1224": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "211": {
    "name": "Game Boy Gallery 2 (Japan)",
    "productCode": "DMG-AGIJ-JPN"
  },
  "1674": {
    "name": "Hamster Club (Japan)",
    "productCode": "DMG-AJNJ-JPN"
  },
  "641": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2408": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2058": {
    "name": "Cult Master - Ultraman ni Miserarete (Japan)",
    "productCode": "DMG-C5J"
  },
  "354": {
    "name": "Doraemon no Study Boy 6",
    "productCode": "DMG-AKNJ-JPN"
  },
  "1361": {
    "name": "Medarot - Kuwagata Version (Japan)",
    "productCode": "DMG-AMYJ-JPN"
  },
  "704": {
    "name": "Kakutou Ryouri Densetsu Bistro Recipe - Kettou Bistgarm Hen (Japan) ",
    "productCode": "DMG-A2WJ-JPN"
  },
  "1731": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "3063": {
    "name": "Dragon Ball Z - Gokuu Gekitouden (Japan) ",
    "productCode": "DMG-AZ2J-JPN"
  },
  "591": {
    "name": "Pocket Puyo Puyo Tsuu (Japan) ",
    "productCode": "DMG-APYJ-JPN"
  },
  "2672": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "968": {
    "name": "Ms. Pac-Man (USA)",
    "productCode": "DMG-N4-USA"
  },
  "99": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2388": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2222": {
    "name": "Red Arremer - Makaimura Gaiden (Japan)",
    "productCode": "DMG-RAJ"
  },
  "2737": {
    "name": "Sangokushi - Game Boy Ban (Japan)",
    "productCode": "DMG-ISJ"
  },
  "1818": {
    "name": "Jantaku Boy (Japan)",
    "productCode": "DMG-GJJ"
  },
  "76": {
    "name": "Z-Kai Kyuukyoku no Eitango 1500",
    "productCode": "DMG-AC2J-JPN"
  },
  "2367": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "987": {
    "name": "Phantom Zona (Japan) ",
    "productCode": "DMG-BKZJ-JPN"
  },
  "1398": {
    "name": "Higashio Osamu Kanshuu Pro Yakyuu Stadium '91 (Japan)",
    "productCode": "DMG-PIJ"
  },
  "657": {
    "name": "Bomber Man GB (Japan) ",
    "productCode": "DMG-EEJ"
  },
  "1662": {
    "name": "Pocket Monsters Gin (Japan)  ",
    "productCode": "DMG-AAXJ-JPN"
  },
  "207": {
    "name": "NBA Show Time - NBA on NBC (USA)",
    "productCode": "CGB-AA5E-USA"
  },
  "1232": {
    "name": "Barbie - Ocean Discovery (USA)",
    "productCode": "DMG-ADYE-USA-1"
  },
  "2808": {
    "name": "Teenage Mutant Ninja Turtles - Fall of the Foot Clan (USA)",
    "productCode": "DMG-NTJ"
  },
  "1727": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "712": {
    "name": "Robot Poncots - Sun Version (Japan) ",
    "productCode": "DMG-HREJ-JPN"
  },
  "1377": {
    "name": "Wataru Mazekko Monster (Japan) ",
    "productCode": "DMG-AWAJ-JPN"
  },
  "342": {
    "name": "Wario Land 3 (World) ",
    "productCode": "CGB-AW8A-JPN"
  },
  "2275": {
    "name": "From TV Animation One Piece - Maboroshi no Grand Line Boukenki! (Japan) ",
    "productCode": "DMG-BZOJ-JPN"
  },
  "895": {
    "name": "Hunter X Hunter - Hunter no Keifu (Japan)",
    "productCode": "CGB-BHHJ-JPN"
  },
  "2625": {
    "name": "Baseball Kids (Japan)",
    "productCode": "DMG-BKJ"
  },
  "1459": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "196": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1009": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "3034": {
    "name": "Hamster Club (Japan)",
    "productCode": "DMG-AJNJ-JPN"
  },
  "529": {
    "name": "Baseball (World)",
    "productCode": "DMG-BS-USA"
  },
  "483": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "179": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "21": {
    "name": "Super Gals! Kotobuki Ran (Japan)",
    "productCode": "CGB-BGLJ-JPN"
  },
  "2330": {
    "name": "4-in-1 Fun Pak (Japan)",
    "productCode": "DMG-F4J"
  },
  "2760": {
    "name": "Umi no Nushi Tsuri 2",
    "productCode": "DMG-A8UJ-JPN"
  },
  "1265": {
    "name": "Rugrats Totally Angelica (USA)",
    "productCode": "CGB-BAGE-USA"
  },
  "250": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1635": {
    "name": "Medarot 2 - Parts Collection (Japan) ",
    "productCode": "DMG-A7CJ-JPN"
  },
  "600": {
    "name": "Kirby no Block Ball (Japan) ",
    "productCode": "DMG-AKXJ-JPN"
  },
  "2449": {
    "name": "Power Pro GB (Japan)  ",
    "productCode": "DMG-APWJ-JPN"
  },
  "2019": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "315": {
    "name": "Dino Breeder 3 - Gaia Fukkatsu (Japan) ",
    "productCode": "DMG-A3DJ-JPN"
  },
  "1320": {
    "name": "Ishido - The Way of Stones (USA)",
    "productCode": "DMG-STJ"
  },
  "745": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "1770": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1567": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "552": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1137": {
    "name": "Kirby no Kirakira Kids (Japan) ",
    "productCode": "DMG-AKCJ-JPN"
  },
  "102": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1834": {
    "name": "Rockman World 5 (Japan) ",
    "productCode": "DMG-WMJ"
  },
  "801": {
    "name": "Peke to Poko no Daruman Busters (Japan)",
    "productCode": "DMG-DBJ"
  },
  "944": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "1971": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "417": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "1422": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "1588": {
    "name": "Bakukyuu Renpatsu!! Super B-Daman - Gekitan! Rising Valkyrie!! (Japan) ",
    "productCode": "DMG-A4RJ-JPN"
  },
  "1072": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "2577": {
    "name": "Shougi (Japan)",
    "productCode": "DMG-SGJ"
  },
  "2127": {
    "name": "Momotarou Densetsu Gaiden (Japan)",
    "productCode": "DMG-MIJ"
  },
  "694": {
    "name": "Kirby no Block Ball (Japan) ",
    "productCode": "DMG-AKXJ-JPN"
  },
  "2824": {
    "name": "Sakura Taisen GB - Geki Hana Gumi Nyuutai! (Japan)",
    "productCode": "CGB-BRJJ-JPN"
  },
  "2961": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "381": {
    "name": "Pokemon Pinball (Japan)  ",
    "productCode": "DMG-VPHJ-JPN"
  },
  "2432": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "2062": {
    "name": "Othello (Japan)",
    "productCode": "DMG-OTJ"
  },
  "2598": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "856": {
    "name": "Super Robot Taisen (Japan)",
    "productCode": "DMG-SZJ"
  },
  "1863": {
    "name": "Arthur's Absolutely Fun Day! (USA)",
    "productCode": "CGB-BFDE-USA"
  },
  "155": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1160": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "505": {
    "name": "FASTEST LAP",
    "productCode": "DMG-F2A"
  },
  "1530": {
    "name": "Medarot 2 - Kabuto Version (Japan) ",
    "productCode": "DMG-A2MJ-JPN"
  },
  "1025": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "3018": {
    "name": "Moguranya (Japan) ",
    "productCode": "DMG-AMOJ-JPN"
  },
  "1475": {
    "name": "Saban's Power Rangers: Time Force (USA)",
    "productCode": "CGB-B4TE-USA"
  },
  "440": {
    "name": "Shikakui Atama o Maru Kusuru: Shakai Battle-hen",
    "productCode": "DMG-BE3J-JPN"
  },
  "2609": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1926": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "913": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2259": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "2873": {
    "name": "MTV PURE RIDE (USA)",
    "productCode": "CGB-BPVE-USA"
  },
  "293": {
    "name": "Meitantei Conan - Kigantou Hihou Densetsu (Japan) ",
    "productCode": "DMG-A5BJ-JPN"
  },
  "769": {
    "name": "Fairy Kitty no Kaiun Jiten - Yousei no Kuni no Uranai Shugyou (Japan)  ",
    "productCode": "DMG-AFUJ-JPN"
  },
  "339": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "2170": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "2520": {
    "name": "Tottoko Hamutarou 2 (Japan)",
    "productCode": "CGB-B86J-JPN"
  },
  "2035": {
    "name": "America Oudan Ultra Quiz Part 3 (Japan)",
    "productCode": "DMG-U3J"
  },
  "2465": {
    "name": "Double Dragon (Japan)",
    "productCode": "DMG-DDA"
  },
  "2936": {
    "name": "Doraemon 2 - Animal Planet Densetsu (Japan)",
    "productCode": "DMG-DMJ"
  },
  "1619": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "1249": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "786": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1526": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "513": {
    "name": "Mickey's Racing Adventure (USA)",
    "productCode": "CGB-ARNE-USA"
  },
  "1176": {
    "name": "Nettou Garou Densetsu 2 - Aratanaru Tatakai (Japan) ",
    "productCode": "DMG-X3J"
  },
  "143": {
    "name": "Blades of Steel (USA)",
    "productCode": "DMG-UB-USA"
  },
  "1875": {
    "name": "Medarot - Kuwagata Version (Japan)",
    "productCode": "DMG-AMYJ-JPN"
  },
  "840": {
    "name": "Ganbare Goemon - Sarawareta Ebisumaru (Japan)",
    "productCode": "DMG-GCJ"
  },
  "905": {
    "name": "Yu-Gi-Oh! - Dark Duel Stories (USA)",
    "productCode": "CGB-BY3E-USA"
  },
  "1930": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "456": {
    "name": "From TV Animation One Piece - Maboroshi no Grand Line Boukenki! (Japan) ",
    "productCode": "DMG-BZOJ-JPN"
  },
  "1199": {
    "name": "GB Pachi-Slot Hisshouhou! Jr (Japan)",
    "productCode": "DMG-IPJ"
  },
  "1463": {
    "name": "Lock'n Chase",
    "productCode": "DMG-LCA"
  },
  "1033": {
    "name": "G-Arms Operation Gundam",
    "productCode": "DMG-GAJ"
  },
  "2536": {
    "name": "F1 Boy (Japan)",
    "productCode": "DMG-FBJ"
  },
  "2166": {
    "name": "Cave Noire (USA)",
    "productCode": "DMG-MQ-USA"
  },
  "285": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "2865": {
    "name": "Mini Yonku GB Let's & Go!! - All-Star Battle Max (Japan) ",
    "productCode": "DMG-AAMJ-JPN"
  },
  "790": {
    "name": "Lock'n Chase",
    "productCode": "DMG-LCA"
  },
  "2920": {
    "name": "Quarth (Japan)",
    "productCode": "DMG-QRJ"
  },
  "2473": {
    "name": "B-Daman Bakugaiden V - Final Mega Tune (Japan)",
    "productCode": "CGB-AIRJ-JPN"
  },
  "2189": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "2023": {
    "name": "Jinsei Game (Japan) ",
    "productCode": "DMG-AZGJ-JPN"
  },
  "817": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1822": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "1988": {
    "name": "Soreyuke! Amida-Kun (Japan)",
    "productCode": "DMG-AMA"
  },
  "114": {
    "name": "Dracula Densetsu (Japan)",
    "productCode": "DMG-CVJ"
  },
  "1121": {
    "name": "Cult Master - Ultraman ni Miserarete (Japan)",
    "productCode": "DMG-C5J"
  },
  "544": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "1571": {
    "name": "Rugrats Time Travelers (USA)",
    "productCode": "DMG-AVME-USA"
  },
  "3059": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "1064": {
    "name": "B-Daman Bakugaiden - Victory e no Michi (Japan) ",
    "productCode": "DMG-AOKJ-JPN"
  },
  "1434": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "401": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "1967": {
    "name": "Dracula Densetsu (Japan)",
    "productCode": "DMG-CVJ"
  },
  "2648": {
    "name": "Mario Golf GB (Japan)",
    "productCode": "CGB-AWXJ-JPN"
  },
  "952": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2218": {
    "name": "Wario Land 3 (World) ",
    "productCode": "CGB-AW8A-JPN"
  },
  "2832": {
    "name": "Yu Yu Hakusho Dai-3-tama : Makai no Tobira (Japan)",
    "productCode": "DMG-UGJ"
  },
  "728": {
    "name": "Wataru Mazekko Monster (Japan) ",
    "productCode": "DMG-AWAJ-JPN"
  },
  "682": {
    "name": "Hamster Club (Japan)",
    "productCode": "DMG-AJNJ-JPN"
  },
  "2998": {
    "name": "Tottoko Hamutarou 2 (Japan)",
    "productCode": "CGB-B86J-JPN"
  },
  "378": {
    "name": "Moguranya (Japan) ",
    "productCode": "DMG-AMOJ-JPN"
  },
  "2131": {
    "name": "Gensou Maden Saiyuuki - Sabaku no Shijin (Japan)",
    "productCode": "CGB-BGSJ-JPN"
  },
  "2561": {
    "name": "Jinsei Game (Japan) ",
    "productCode": "DMG-AZGJ-JPN"
  },
  "2074": {
    "name": "Mickey Mouse V (Japan)",
    "productCode": "DMG-I5J"
  },
  "2424": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "397": {
    "name": "Dragon Ball Z - Densetsu no Chou Senshi-tachi (Japan)",
    "productCode": "CGB-BBZJ-JPN"
  },
  "1658": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "2977": {
    "name": "Kizuchi da Quiz da Gen-san da! (Japan)",
    "productCode": "DMG-QGJ"
  },
  "1208": {
    "name": "Double Dragon (Japan)",
    "productCode": "DMG-DDA"
  },
  "1983": {
    "name": "Puyo Puyo (Japan)  ",
    "productCode": "DMG-QQJ"
  },
  "2356": {
    "name": "Shougi (Japan)",
    "productCode": "DMG-SGJ"
  },
  "47": {
    "name": "Ganbare Goemon - Sarawareta Ebisumaru (Japan)",
    "productCode": "DMG-GCJ"
  },
  "1829": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "2706": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "1080": {
    "name": "Meitantei Conan - Chika Yuuenchi Satsujin Jiken (Japan) ",
    "productCode": "DMG-ADCJ-JPN"
  },
  "3052": {
    "name": "The Addams Family (USA)",
    "productCode": "DMG-AF3J-JPN"
  },
  "1595": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "2213": {
    "name": "Medarot 4 - Kabuto Version (Japan)",
    "productCode": "CGB-B4MJ-JPN"
  },
  "2643": {
    "name": "Dokidoki Densetsu - Mahoujin Guruguru (Japan)",
    "productCode": "CGB-B96J-JPN"
  },
  "959": {
    "name": "Chibi Maruko-chan 2 - Deluxe Maruko World (Japan)",
    "productCode": "DMG-C2J"
  },
  "689": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1346": {
    "name": "Street Fighter II (Japan) ",
    "productCode": "DMG-ASFJ-JPN"
  },
  "2993": {
    "name": "Super B-Daman - Fighting Phoenix (Japan) ",
    "productCode": "DMG-ABDJ-JPN"
  },
  "373": {
    "name": "Meitantei Conan - Chika Yuuenchi Satsujin Jiken (Japan) ",
    "productCode": "DMG-ADCJ-JPN"
  },
  "1716": {
    "name": "Tottoko Hamutarou 2 (Japan)",
    "productCode": "CGB-B86J-JPN"
  },
  "2839": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "723": {
    "name": "Pachinko Time (Japan)",
    "productCode": "DMG-PTJ"
  },
  "2090": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "2585": {
    "name": "Super Momotarou Dentetsu II (Japan)",
    "productCode": "DMG-G9J"
  },
  "236": {
    "name": "America Oudan Ultra Quiz Part 2 (Japan)",
    "productCode": "DMG-AUJ"
  },
  "1203": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "666": {
    "name": "Dino Breeder (Japan)  ",
    "productCode": "DMG-AWDJ-JPN"
  },
  "1653": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "148": {
    "name": "Momotarou Densetsu Gaiden (Japan)",
    "productCode": "DMG-MIJ"
  },
  "1487": {
    "name": "Dai-2-ji Super Robot Taisen G (Japan) ",
    "productCode": "DMG-AG2J-JPN"
  },
  "518": {
    "name": "Kirby no Block Ball (Japan) ",
    "productCode": "DMG-AKXJ-JPN"
  },
  "2751": {
    "name": "Seiken Densetsu - Final Fantasy Gaiden (Japan)",
    "productCode": "DMG-FFJ"
  },
  "2301": {
    "name": "Metroid II - Return of Samus (World)",
    "productCode": "DMG-MEA"
  },
  "10": {
    "name": "Chibi Maruko-chan - Maruko Deluxe Theater (Japan) ",
    "productCode": "DMG-ACMJ-JPN"
  },
  "2614": {
    "name": "Tottoko Hamutarou - Tomodachi Daisakusen Dechu (Japan)",
    "productCode": "CGB-BHTJ-JPN"
  },
  "1891": {
    "name": "Puzzle Bobble GB (Japan)",
    "productCode": "DMG-AGPJ-JPN"
  },
  "2244": {
    "name": "Toy Story 2 (USA)",
    "productCode": "DMG-AOQE-USA"
  },
  "1038": {
    "name": "Medarot 2 - Parts Collection (Japan) ",
    "productCode": "DMG-A7CJ-JPN"
  },
  "3005": {
    "name": "Power Pro Kun Pocket (Japan)  ",
    "productCode": "DMG-AVVJ-JPN"
  },
  "1192": {
    "name": "Dragon Slayer - Nemuri no Oukan (Japan)",
    "productCode": "DMG-DQJ"
  },
  "1468": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2497": {
    "name": "Yu Yu Hakusho Dai-2-dan - Ankoku Bujutsukai Hen (Japan)",
    "productCode": "DMG-UKJ"
  },
  "774": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1741": {
    "name": "Pocket Color Mahjong (Japan)",
    "productCode": "DMG-A2AJ-JPN"
  },
  "324": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1311": {
    "name": "Beatmania GB (Japan) ",
    "productCode": "DMG-AOOJ-JPN"
  },
  "1604": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "631": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1254": {
    "name": "Atsumete Asobu Kuma no Pooh-san - Mori no Takaramono (Japan)",
    "productCode": "CGB-BPUJ-JPN"
  },
  "2881": {
    "name": "Disney's Mulan (USA)",
    "productCode": "DMG-AMLE-USA"
  },
  "261": {
    "name": "Yu Yu Hakusho (Japan)",
    "productCode": "DMG-UUJ"
  },
  "2028": {
    "name": "Medarot Cardrobottle - Kabuto Version (Japan) ",
    "productCode": "DMG-A8CJ-JPN"
  },
  "2478": {
    "name": "Jinsei Game Densetsu (Japan)",
    "productCode": "DMG-JGJ"
  },
  "2182": {
    "name": "Speedy Gonzales (USA)",
    "productCode": "DMG-G6-USA"
  },
  "2317": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "2747": {
    "name": "Dungeon Land (Japan)",
    "productCode": "DMG-DGJ"
  },
  "1868": {
    "name": "Tennis (World)",
    "productCode": "DMG-TNA"
  },
  "1491": {
    "name": "Goukaku Boy Series: Eitango Target 1900",
    "productCode": "DMG-AT2J-JPN"
  },
  "1184": {
    "name": "Mickey's Racing Adventure (USA)",
    "productCode": "CGB-ARNE-USA"
  },
  "3013": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "2252": {
    "name": "Janshirou (Japan)",
    "productCode": "DMG-JFJ"
  },
  "1887": {
    "name": "Othello World (Japan) ",
    "productCode": "DMG-ATOJ-JPN"
  },
  "2602": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "918": {
    "name": "Medarot 3 - Kabuto Version (Japan)",
    "productCode": "CGB-B32J-JPN"
  },
  "1307": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "332": {
    "name": "Heisei Tensai Bakabon (Japan)",
    "productCode": "DMG-TFJ"
  },
  "2878": {
    "name": "Batman - Return of the Joker (Japan)",
    "productCode": "DMG-B5A"
  },
  "1757": {
    "name": "SolarStriker (World)",
    "productCode": "DMG-SSA"
  },
  "298": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "762": {
    "name": "Zelda no Densetsu - Yume o Miru Shima DX (Japan)  ",
    "productCode": "DMG-AZLJ-JPN"
  },
  "2481": {
    "name": "Mini Yonku GB Let's & Go!! (Japan) ",
    "productCode": "DMG-AM4J-JPN"
  },
  "2194": {
    "name": "Taikyoku Renju (Japan) ",
    "productCode": "DMG-TCA"
  },
  "277": {
    "name": "Magical Taruruuto-kun (Japan)",
    "productCode": "DMG-MGJ"
  },
  "2897": {
    "name": "Yu Yu Hakusho Dai-3-tama : Makai no Tobira (Japan)",
    "productCode": "DMG-UGJ"
  },
  "1242": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "627": {
    "name": "Game de Hakken!! Tamagotchi - Osutchi to Mesutchi (Japan) ",
    "productCode": "DMG-AOMJ-JPN"
  },
  "1612": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "109": {
    "name": "Chousoku Spinner (Japan) ",
    "productCode": "DMG-AYYJ-JPN"
  },
  "1096": {
    "name": "Pokemon - Yellow Version - Special Pikachu Edition (USA, Europe) ",
    "productCode": "DMG-APSE-USA"
  },
  "559": {
    "name": "Magical Taruruuto-kun (Japan)",
    "productCode": "DMG-MGJ"
  },
  "2710": {
    "name": "Konamic Sports in Barcelona (Japan)",
    "productCode": "DMG-KHJ"
  },
  "51": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "2340": {
    "name": "Pocket Monsters - Ao (Japan) ",
    "productCode": "DMG-APEJ-JPN"
  },
  "1995": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "2655": {
    "name": "Game Boy Gallery 3 (Japan) ",
    "productCode": "DMG-AGQJ-JPN"
  },
  "2205": {
    "name": "Kirby no Block Ball (Japan) ",
    "productCode": "DMG-AKXJ-JPN"
  },
  "1583": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "3044": {
    "name": "Dragon Ball Z - Gokuu Gekitouden (Japan) ",
    "productCode": "DMG-AZ2J-JPN"
  },
  "1079": {
    "name": "Namco Classic (Japan)",
    "productCode": "DMG-NHJ"
  },
  "1429": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "2086": {
    "name": "Downtown - Nekketsu Koushinkyoku - Dokodemo Daiundoukai (Japan)",
    "productCode": "DMG-DUJ"
  },
  "735": {
    "name": "Hamster Club (Japan)",
    "productCode": "DMG-AJNJ-JPN"
  },
  "1700": {
    "name": "Block Kuzushi GB (Japan) ",
    "productCode": "DMG-ABKJ-JPN"
  },
  "365": {
    "name": "Dragon Quest I & II (Japan) ",
    "productCode": "DMG-AEDJ-JPN"
  },
  "2985": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1350": {
    "name": "Famista 3 (Japan)",
    "productCode": "DMG-N3J"
  },
  "1645": {
    "name": "Power Pro Kun Pocket 2 (Japan) ",
    "productCode": "DMG-BPWJ-JPN"
  },
  "670": {
    "name": "Pac-Man (USA)",
    "productCode": "DMG-PCA"
  },
  "1215": {
    "name": "Puzzle Boy (Japan)",
    "productCode": "DMG-APJ"
  },
  "220": {
    "name": "Puyo Puyo (Japan)  ",
    "productCode": "DMG-QQJ"
  },
  "2069": {
    "name": "Game de Hakken!! Tamagotchi - Osutchi to Mesutchi (Japan) ",
    "productCode": "DMG-AOMJ-JPN"
  },
  "2593": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2439": {
    "name": "Super Robot Taisen (Japan)",
    "productCode": "DMG-SZJ"
  },
  "934": {
    "name": "Motocross Maniacs (Japan)",
    "productCode": "DMG-MXA"
  },
  "1901": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2784": {
    "name": "Picross 2 (Japan) ",
    "productCode": "DMG-AP2J-JPN"
  },
  "1002": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "467": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1452": {
    "name": "Shougi (Japan)",
    "productCode": "DMG-SGJ"
  },
  "1147": {
    "name": "Popeye (Japan)",
    "productCode": "DMG-PYA"
  },
  "488": {
    "name": "Meitantei Conan - Chika Yuuenchi Satsujin Jiken (Japan) ",
    "productCode": "DMG-ADCJ-JPN"
  },
  "172": {
    "name": "Tekkyu Fight! - The Great Battle Gaiden (Japan)",
    "productCode": "DMG-IBJ"
  },
  "1517": {
    "name": "Looney Tunes Racing (USA) ",
    "productCode": "CGB-BLQE-USA"
  },
  "522": {
    "name": "Makai Toushi Sa-Ga (Japan)",
    "productCode": "DMG-SAJ"
  },
  "1844": {
    "name": "Meitantei Conan - Chika Yuuenchi Satsujin Jiken (Japan) ",
    "productCode": "DMG-ADCJ-JPN"
  },
  "871": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "2291": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "2911": {
    "name": "Tennis (World)",
    "productCode": "DMG-TNA"
  },
  "1794": {
    "name": "G-Arms Operation Gundam",
    "productCode": "DMG-GAJ"
  },
  "2012": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "2442": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "2157": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2507": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "1281": {
    "name": "Hayaoshi Quiz - Ouza Ketteisen (Japan) ",
    "productCode": "DMG-AQZJ-JPN"
  },
  "2854": {
    "name": "Game Boy Gallery (Japan) ",
    "productCode": "DMG-AGAJ-JPN"
  },
  "1405": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "430": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "3068": {
    "name": "Phantom Zona (Japan) ",
    "productCode": "DMG-BKZJ-JPN"
  },
  "1055": {
    "name": "Medarot 3 - Kabuto Version (Japan)",
    "productCode": "CGB-B32J-JPN"
  },
  "2229": {
    "name": "Mickey Mouse V (Japan)",
    "productCode": "DMG-I5J"
  },
  "2679": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "1956": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "963": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "92": {
    "name": "Oni V - Oni wo Tsugumono (Japan)",
    "productCode": "DMG-AO5J-JPN"
  },
  "2383": {
    "name": "Crayon Shin-chan 2 - Ora to Wanpaku Gokko Dazo (Japan)",
    "productCode": "DMG-COJ"
  },
  "2696": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "826": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "1813": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "575": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "1540": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "125": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "1110": {
    "name": "Keibajou e Ikou! Wide (Japan)",
    "productCode": "DMG-A5CJ-JPN"
  },
  "2415": {
    "name": "The Jungle Book (USA, Europe)",
    "productCode": "DMG-J7-USA"
  },
  "2045": {
    "name": "Pro Wrestling (Japan)",
    "productCode": "DMG-PRJ"
  },
  "1239": {
    "name": "Tsuri Sensei (Japan) ",
    "productCode": "DMG-AFWJ-JPN"
  },
  "1393": {
    "name": "Mickey Mouse (Japan)",
    "productCode": "DMG-MMA"
  },
  "2946": {
    "name": "Doraemon - Taiketsu Himitsu Dougu (Japan)",
    "productCode": "DMG-DEJ"
  },
  "1669": {
    "name": "Quarth (Japan)",
    "productCode": "DMG-QRJ"
  },
  "1686": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "349": {
    "name": "Wario Land 3 (World) ",
    "productCode": "CGB-AW8A-JPN"
  },
  "2803": {
    "name": "Medarot - Kabuto Version (Japan) ",
    "productCode": "DMG-AMXJ-JPN"
  },
  "719": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2550": {
    "name": "Pro Darts (USA)",
    "productCode": "CGB-AVDE-USA"
  },
  "2100": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "2395": {
    "name": "Double Yakuman (Japan)",
    "productCode": "DMG-YVJ"
  },
  "84": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "975": {
    "name": "Minnie & Friends - Yume no Kuni o Sagashite (Japan)",
    "productCode": "CGB-BYKJ-JPN"
  },
  "1940": {
    "name": "Phantom Zona (Japan) ",
    "productCode": "DMG-BKZJ-JPN"
  },
  "1043": {
    "name": "Looney Tunes (USA)",
    "productCode": "DMG-LN-USA"
  },
  "426": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1413": {
    "name": "Kandume Monsters (Japan) ",
    "productCode": "DMG-AKMJ-JPN"
  },
  "1106": {
    "name": "Pocket Monsters - Pikachu (Japan)  ",
    "productCode": "DMG-APSJ-JPN"
  },
  "133": {
    "name": "Picross 2 (Japan) ",
    "productCode": "DMG-AP2J-JPN"
  },
  "1556": {
    "name": "Makai Toushi Sa-Ga (Japan)",
    "productCode": "DMG-SAJ"
  },
  "563": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "1805": {
    "name": "SD Gundam - SD Sengokuden - Kunitori Monogatari (Japan)",
    "productCode": "DMG-SDJ"
  },
  "830": {
    "name": "Pachinko Time (Japan)",
    "productCode": "DMG-PTJ"
  },
  "2680": {
    "name": "SD Sengokuden 2 - Tenka Touitsu Hen (Japan)",
    "productCode": "DMG-G3J"
  },
  "2950": {
    "name": "Pro Mahjong Kiwame GB II (Japan) ",
    "productCode": "DMG-AA2J-JPN"
  },
  "1385": {
    "name": "Momotarou Dengeki Momotaro Thunderbolt",
    "productCode": "DMG-G5J"
  },
  "2053": {
    "name": "Ultraman Club - Tekikaijuu o Hakken seyo! (Japan)",
    "productCode": "DMG-ULJ"
  },
  "2403": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "2116": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2546": {
    "name": "Super Mario Bros. Deluxe (USA, Europe)",
    "productCode": "CGB-AHYE-USA"
  },
  "2815": {
    "name": "Family Jockey 2 - Meiba no Kettou (Japan)",
    "productCode": "DMG-FVJ"
  },
  "1690": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1444": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "471": {
    "name": "Teenage Mutant Ninja Turtles 3 - Turtles Kikiippatsu (Japan)",
    "productCode": "DMG-K8J"
  },
  "1014": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "3029": {
    "name": "Ganbare Goemon - Sarawareta Ebisumaru (Japan)",
    "productCode": "DMG-GCJ"
  },
  "888": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "2268": {
    "name": "Wave Race",
    "productCode": "DMG-WA"
  },
  "2792": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQIJ-JPN"
  },
  "1917": {
    "name": "Majokko Mari-chan no Kisekae Monogatari (Japan)  ",
    "productCode": "DMG-A23J-JPN"
  },
  "2638": {
    "name": "Bishoujo Senshi Sailor Moon (Japan)",
    "productCode": "DMG-AQJ"
  },
  "922": {
    "name": "Rayman - Mister Dark no Wana (Japan)",
    "productCode": "CGB-BURJ-JPN"
  },
  "2287": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "867": {
    "name": "Gremlins 2 - The New Batch (World)",
    "productCode": "DMG-GRA"
  },
  "1852": {
    "name": "Captain Tsubasa J (Japan) ",
    "productCode": "DMG-ACTJ-JPN"
  },
  "534": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1501": {
    "name": "Penguin Wars (USA)",
    "productCode": "DMG-PWJ"
  },
  "164": {
    "name": "Higashio Osamu Kanshuu Pro Yakyuu Stadium '92 (Japan)",
    "productCode": "DMG-EIJ"
  },
  "1151": {
    "name": "Kinniku Banzuke GB2 - Mezase! Muscle Champion (Japan) ",
    "productCode": "DMG-B6KJ-JPN"
  },
  "2454": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2004": {
    "name": "Bakenou V3 (Japan)",
    "productCode": "DMG-VVJ"
  },
  "1782": {
    "name": "Tetris DX (World)  ",
    "productCode": "DMG-ATEA-JPN"
  },
  "1278": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "1628": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2907": {
    "name": "The Bugs Bunny Crazy Castle (USA, Europe)",
    "productCode": "DMG-BB-USA"
  },
  "308": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "2842": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "758": {
    "name": "Hiryuu no Ken Gaiden (Japan)",
    "productCode": "DMG-HRJ"
  },
  "1297": {
    "name": "Power Pro Kun Pocket 2 (Japan) ",
    "productCode": "DMG-BPWJ-JPN"
  },
  "2511": {
    "name": "Monster Farm Battle Card GB (Japan) ",
    "productCode": "DMG-A6TJ-JPN"
  },
  "2141": {
    "name": "Bishoujo Senshi Sailor Moon R (Japan)",
    "productCode": "DMG-QAJ"
  },
  "2136": {
    "name": "Phantom Zona (Japan) ",
    "productCode": "DMG-BKZJ-JPN"
  },
  "2566": {
    "name": "Bishoujo Senshi Sailor Moon R (Japan)",
    "productCode": "DMG-QAJ"
  },
  "2835": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "685": {
    "name": "Jinsei Game (Japan) ",
    "productCode": "DMG-AZGJ-JPN"
  },
  "2970": {
    "name": "Blodia (Japan)",
    "productCode": "DMG-BLA"
  },
  "390": {
    "name": "Beatmania GB (Japan) ",
    "productCode": "DMG-AOOJ-JPN"
  },
  "2073": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2589": {
    "name": "Donkey Kong Land (Japan) ",
    "productCode": "DMG-ADDJ-JPN"
  },
  "2423": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1126": {
    "name": "Sa-Ga 3 - Jikuu no Hasha (Japan)",
    "productCode": "DMG-OSJ"
  },
  "113": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "1576": {
    "name": "Pocket Puyo Puyo Tsuu (Japan) ",
    "productCode": "DMG-APYJ-JPN"
  },
  "543": {
    "name": "Kinniku Banzuke GB2 - Mezase! Muscle Champion (Japan) ",
    "productCode": "DMG-B6KJ-JPN"
  },
  "1825": {
    "name": "Battle Dodge Ball (Japan)",
    "productCode": "DMG-D6J"
  },
  "810": {
    "name": "Momotarou Densetsu Gaiden (Japan)",
    "productCode": "DMG-MIJ"
  },
  "955": {
    "name": "Winnie the Pooh - Adventures in the 100 Acre Wood (USA)",
    "productCode": "CGB-BPOE-USA"
  },
  "1960": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1599": {
    "name": "Power Pro Kun Pocket (Japan)  ",
    "productCode": "DMG-AVVJ-JPN"
  },
  "1063": {
    "name": "Sanrio Uranai Party (Japan)",
    "productCode": "DMG-AG7J-JPN"
  },
  "406": {
    "name": "Medarot 2 - Kabuto Version (Japan) ",
    "productCode": "DMG-A2MJ-JPN"
  },
  "1433": {
    "name": "Power Pro GB (Japan)  ",
    "productCode": "DMG-APWJ-JPN"
  },
  "328": {
    "name": "Play Action Football (USA)",
    "productCode": "DMG-FL-USA"
  },
  "2862": {
    "name": "Kinniku Banzuke GB2 - Mezase! Muscle Champion (Japan) ",
    "productCode": "DMG-B6KJ-JPN"
  },
  "282": {
    "name": "Bugs Bunny - Crazy Castle 3 (USA) ",
    "productCode": "DMG-AB6E-USA"
  },
  "778": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2531": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2161": {
    "name": "Meitantei Conan - Chika Yuuenchi Satsujin Jiken (Japan) ",
    "productCode": "DMG-ADCJ-JPN"
  },
  "2474": {
    "name": "Jinsei Game Densetsu (Japan)",
    "productCode": "DMG-JGJ"
  },
  "2024": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1258": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "797": {
    "name": "Kinniku Banzuke GB - Chousensha wa Kimida! (Japan) ",
    "productCode": "DMG-A5KJ-JPN"
  },
  "1608": {
    "name": "Sesame Street - The Adventures of Elmo in Grouchland (USA)",
    "productCode": "DMG-AELE-USA"
  },
  "2927": {
    "name": "Mario Tennis GB (Japan)",
    "productCode": "CGB-BM8J-JPN"
  },
  "847": {
    "name": "Nekketsu Kouha Kunio-kun - Bangai Rantou Hen (Japan)",
    "productCode": "DMG-KUJ"
  },
  "1872": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "514": {
    "name": "Shikakui Atama o Maru Kusuru: Joushiki no Ka",
    "productCode": "DMG-BJ3J-JPN"
  },
  "1521": {
    "name": "Mini Yonku GB Let's & Go!! (Japan) ",
    "productCode": "DMG-AM4J-JPN"
  },
  "144": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1171": {
    "name": "Power Pro Kun Pocket 2 (Japan) ",
    "productCode": "DMG-BPWJ-JPN"
  },
  "1464": {
    "name": "Power Pro Kun Pocket 2 (Japan) ",
    "productCode": "DMG-BPWJ-JPN"
  },
  "451": {
    "name": "Medarot 4 - Kabuto Version (Japan)",
    "productCode": "CGB-B4MJ-JPN"
  },
  "3009": {
    "name": "Phantom Zona (Japan) ",
    "productCode": "DMG-BKZJ-JPN"
  },
  "1034": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "2248": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1937": {
    "name": "Crayon Shin-chan 2 - Ora to Wanpaku Gokko Dazo (Japan)",
    "productCode": "DMG-COJ"
  },
  "2618": {
    "name": "Super B-Daman - Fighting Phoenix (Japan) ",
    "productCode": "DMG-ABDJ-JPN"
  },
  "902": {
    "name": "Nintendo Power Memory Cartridge",
    "productCode": "DMG-MMSA-JPN"
  },
  "2177": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "2527": {
    "name": "Alleyway (World)",
    "productCode": "DMG-AWA"
  },
  "294": {
    "name": "Radar Mission (Japan)",
    "productCode": "DMG-RMA"
  },
  "2874": {
    "name": "Phantom Zona (Japan) ",
    "productCode": "DMG-BKZJ-JPN"
  },
  "2931": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "781": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2032": {
    "name": "Medarot 4 - Kuwagata Version (Japan)",
    "productCode": "CGB-B4NJ-JPN"
  },
  "2462": {
    "name": "Jantaku Boy (Japan)",
    "productCode": "DMG-GJJ"
  },
  "2198": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1167": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "152": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1537": {
    "name": "Boxing (Japan)",
    "productCode": "DMG-BXA"
  },
  "502": {
    "name": "Home Alone 2 Lost In New York (USA)",
    "productCode": "DMG-AHHJ-JPN"
  },
  "1864": {
    "name": "Yu-Gi-Oh! - Monster Capsule GB (Japan) ",
    "productCode": "DMG-AYCJ-JPN"
  },
  "851": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "914": {
    "name": "Kawa no Nushi Tsuri 4 (Japan)  ",
    "productCode": "DMG-VUTJ-JPN"
  },
  "1921": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1022": {
    "name": "Donkey Kong (World)  ",
    "productCode": "DMG-QDA"
  },
  "447": {
    "name": "Flipull (Japan)",
    "productCode": "DMG-FPA"
  },
  "1188": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "1472": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "693": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2989": {
    "name": "Itsudemo! Nyan to Wonderful (Japan) ",
    "productCode": "DMG-ANWJ-JPN"
  },
  "369": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2823": {
    "name": "Super Bikkuriman - Densetsu no Sekiban (Japan)",
    "productCode": "DMG-CYJ"
  },
  "739": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2570": {
    "name": "Dr. Rin ni Kiitemite! - Koi no Rin Fuusui (Japan)",
    "productCode": "CGB-BDFJ-JPN"
  },
  "2120": {
    "name": "Captain Tsubasa J (Japan) ",
    "productCode": "DMG-ACTJ-JPN"
  },
  "2435": {
    "name": "From TV Animation One Piece - Maboroshi no Grand Line Boukenki! (Japan) ",
    "productCode": "DMG-BZOJ-JPN"
  },
  "2065": {
    "name": "Dragon Ball Z - Legendary Super Warriors (USA)",
    "productCode": "CGB-BBZE-USA"
  },
  "1219": {
    "name": "Ninku Dai-2-dan - Ninku Sensou Hen (Japan) ",
    "productCode": "DMG-ANSJ-JPN"
  },
  "386": {
    "name": "Home Alone 2 Lost In New York (USA)",
    "productCode": "DMG-AH-USA"
  },
  "2966": {
    "name": "WWF Superstars 2 (Japan)",
    "productCode": "DMG-WXA"
  },
  "1649": {
    "name": "G-Arms Operation Gundam",
    "productCode": "DMG-GAJ"
  },
  "1999": {
    "name": "Super B-Daman - Fighting Phoenix (Japan) ",
    "productCode": "DMG-ABDJ-JPN"
  },
  "806": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1833": {
    "name": "Teke Teke! Asmik-kun World (Japan)",
    "productCode": "DMG-ASJ"
  },
  "555": {
    "name": "Ultra Golf (USA)",
    "productCode": "DMG-KGA"
  },
  "1560": {
    "name": "Akazukin Chacha (Japan) ",
    "productCode": "DMG-ACCJ-JPN"
  },
  "105": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1130": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1425": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "410": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "1075": {
    "name": "Kirby no Kirakira Kids (Japan) ",
    "productCode": "DMG-AKCJ-JPN"
  },
  "3048": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "2209": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "2659": {
    "name": "Tony Hawk's Pro Skater 2 (USA, Europe)",
    "productCode": "CGB-BTGE-USA"
  },
  "1976": {
    "name": "Nihonshi Target 201 (Japan)",
    "productCode": "DMG-AN3J-JPN"
  },
  "943": {
    "name": "Kirby no Block Ball (Japan) ",
    "productCode": "DMG-AKXJ-JPN"
  },
  "257": {
    "name": "Wario Land 3 (World) ",
    "productCode": "CGB-AW8A-JPN"
  },
  "1798": {
    "name": "F-1 Spirit (Japan)",
    "productCode": "DMG-FZJ"
  },
  "1262": {
    "name": "Sylvanian Melodies - Mori no Nakama to Odori Masho! (Japan) ",
    "productCode": "DMG-BMKJ-JPN"
  },
  "607": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "1632": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "1327": {
    "name": "Kirby no Kirakira Kids (Japan) ",
    "productCode": "DMG-AKCJ-JPN"
  },
  "312": {
    "name": "Donkey Kong Land (Japan) ",
    "productCode": "DMG-ADDJ-JPN"
  },
  "2858": {
    "name": "Minnie & Friends - Yume no Kuni o Sagashite (Japan)",
    "productCode": "CGB-BYKJ-JPN"
  },
  "1777": {
    "name": "Rockman World 1",
    "productCode": "DMG-RWA"
  },
  "742": {
    "name": "Power Pro Kun Pocket (Japan)  ",
    "productCode": "DMG-AVVJ-JPN"
  },
  "191": {
    "name": "M&M's Minis Madness (USA)",
    "productCode": "CGB-BMIE-USA"
  },
  "3033": {
    "name": "Pocket Bomber Man (Japan) ",
    "productCode": "DMG-APOJ-JPN"
  },
  "892": {
    "name": "Power Pro Kun Pocket (Japan)  ",
    "productCode": "DMG-AVVJ-JPN"
  },
  "2272": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "2788": {
    "name": "Shounen Ashibe - Yuuenchi Panic (Japan)",
    "productCode": "DMG-A2J"
  },
  "2622": {
    "name": "SD Gundam - SD Sengokuden - Kunitori Monogatari (Japan)",
    "productCode": "DMG-SDJ"
  },
  "938": {
    "name": "Daikaijuu Monogatari - Poyon no Dungeon Room (Japan) ",
    "productCode": "DMG-ADZJ-JPN"
  },
  "26": {
    "name": "Pocket Monsters - Midori (Japan)  ",
    "productCode": "DMG-APBJ-JPN"
  },
  "2337": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2767": {
    "name": "Shougi (Japan)",
    "productCode": "DMG-SGJ"
  },
  "1848": {
    "name": "Animal Breeder 2 (Japan) ",
    "productCode": "DMG-AAJJ-JPN"
  },
  "484": {
    "name": "Soccer Boy (Japan)",
    "productCode": "DMG-SBA"
  },
  "1665": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "650": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1235": {
    "name": "WWF Superstars 2 (USA)",
    "productCode": "DMG-WX-USA"
  },
  "200": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "2049": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "2419": {
    "name": "Medarot 2 - Kabuto Version (Japan) ",
    "productCode": "DMG-A2MJ-JPN"
  },
  "715": {
    "name": "Lock'n Chase",
    "productCode": "DMG-LCA"
  },
  "1720": {
    "name": "Kingyo Chuuihou! - Wapiko no Wakuwaku Stamp Rally! (Japan)",
    "productCode": "DMG-KTJ"
  },
  "345": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "1370": {
    "name": "Power Pro GB (Japan)  ",
    "productCode": "DMG-APWJ-JPN"
  },
  "2675": {
    "name": "Pro Soccer (Japan)",
    "productCode": "DMG-KFJ"
  },
  "2225": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "596": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "1059": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "3064": {
    "name": "The Incredible Crash Dummies (USA, Europe)",
    "productCode": "DMG-C8-USA"
  },
  "1409": {
    "name": "Pocket GI Stable (Japan) ",
    "productCode": "DMG-APUJ-JPN"
  },
  "129": {
    "name": "Medarot 4 - Kabuto Version (Japan)",
    "productCode": "CGB-B4MJ-JPN"
  },
  "579": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "2730": {
    "name": "America Oudan Ultra Quiz Part 2 (Japan)",
    "productCode": "DMG-AUJ"
  },
  "980": {
    "name": "Umi no Nushi Tsuri 2",
    "productCode": "DMG-A8UJ-JPN"
  },
  "71": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "2360": {
    "name": "Beatmania GB (Japan) ",
    "productCode": "DMG-AOOJ-JPN"
  },
  "216": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1223": {
    "name": "Crayon Shin-chan - Ora to Shiro wa Otomodachi Da yo (Japan)",
    "productCode": "DMG-K4J"
  },
  "1389": {
    "name": "Rockman World 2 (Japan)",
    "productCode": "DMG-W2J"
  },
  "646": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "1673": {
    "name": "Game de Hakken!! Tamagotchi - Osutchi to Mesutchi (Japan) ",
    "productCode": "DMG-AOMJ-JPN"
  },
  "1366": {
    "name": "The Simpsons - Bart vs. the Juggernauts (USA, Europe)",
    "productCode": "DMG-JU-USA"
  },
  "353": {
    "name": "Krusty's Fun House (USA)",
    "productCode": "DMG-FK-USA"
  },
  "1736": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2819": {
    "name": "Donkey Kong 2001 (Japan)",
    "productCode": "CGB-BDDJ-JPN"
  },
  "703": {
    "name": "Kirby no Block Ball (Japan) ",
    "productCode": "DMG-AKXJ-JPN"
  },
  "580": {
    "name": "Snoopy Magic Show (USA)",
    "productCode": "DMG-SNA"
  },
  "2233": {
    "name": "The Hunt for Red October (USA, Europe)",
    "productCode": "DMG-HF-USA"
  },
  "2663": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "979": {
    "name": "Magical Taruruuto-kun (Japan)",
    "productCode": "DMG-MGJ"
  },
  "2399": {
    "name": "Ganbare Goemon - Kurofunetou no Nazo (Japan) ",
    "productCode": "DMG-AGDJ-JPN"
  },
  "88": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2376": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "67": {
    "name": "Ishido - The Way of Stones (USA)",
    "productCode": "DMG-STJ"
  },
  "996": {
    "name": "Kirby no Block Ball (Japan) ",
    "productCode": "DMG-AKXJ-JPN"
  },
  "1809": {
    "name": "Family Jockey (Japan)",
    "productCode": "DMG-FJJ"
  },
  "2726": {
    "name": "Mini Yonku GB Let's & Go!! (Japan) ",
    "productCode": "DMG-AM4J-JPN"
  },
  "1624": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "611": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "1274": {
    "name": "Puzzle Boy (Japan)",
    "productCode": "DMG-APJ"
  },
  "241": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2008": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2458": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "754": {
    "name": "Phantom Zona (Japan) ",
    "productCode": "DMG-BKZJ-JPN"
  },
  "1761": {
    "name": "Killer Instinct (USA, Europe) ",
    "productCode": "DMG-AKLE-USA"
  },
  "304": {
    "name": "Monster Race (Japan) ",
    "productCode": "DMG-AMRJ-JPN"
  },
  "1331": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "2634": {
    "name": "Tottoko Hamutarou 2 (Japan)",
    "productCode": "CGB-B86J-JPN"
  },
  "2264": {
    "name": "Doraemon Kart (Japan) ",
    "productCode": "DMG-ADRJ-JPN"
  },
  "884": {
    "name": "Super R.C. Pro-Am (USA, Europe)",
    "productCode": "DMG-RC-USA"
  },
  "3025": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1018": {
    "name": "Puyo Puyo (Japan)  ",
    "productCode": "DMG-QQJ"
  },
  "1448": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "187": {
    "name": "Tetris (World) ",
    "productCode": "DMG-TR-USA"
  },
  "492": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "168": {
    "name": "Jikuu Senki Mu (Japan)",
    "productCode": "DMG-H1J"
  },
  "538": {
    "name": "J.League Winning Goal (Japan)",
    "productCode": "DMG-W7J"
  },
  "2771": {
    "name": "Medarot 2 - Kuwagata Version (Japan) ",
    "productCode": "DMG-A2NJ-JPN"
  },
  "2321": {
    "name": "Bart Simpson's Escape from Camp Deadly (USA, Europe)",
    "productCode": "DMG-TS-USA"
  },
  "30": {
    "name": "Teenage Mutant Ninja Turtles 2 (Japan)",
    "productCode": "DMG-TTA"
  },
  "2635": {
    "name": "Meitantei Conan - Chika Yuuenchi Satsujin Jiken (Japan) ",
    "productCode": "DMG-ADCJ-JPN"
  },
  "885": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "2265": {
    "name": "Seaside Volley (Japan)",
    "productCode": "DMG-SVJ"
  },
  "1019": {
    "name": "Doraemon Memories - Nobita no Omoide Daibouken (Japan)",
    "productCode": "DMG-BDMJ-JPN"
  },
  "3024": {
    "name": "Kinniku Banzuke GB2 - Mezase! Muscle Champion (Japan) ",
    "productCode": "DMG-B6KJ-JPN"
  },
  "186": {
    "name": "Space Invaders (Japan)",
    "productCode": "DMG-SPA"
  },
  "1449": {
    "name": "Command Master (Japan)",
    "productCode": "CGB-KCEJ-JPN"
  },
  "493": {
    "name": "Bomber Man Max - Yami no Senshi (Japan)",
    "productCode": "CGB-A7BJ-JPN"
  },
  "169": {
    "name": "Medarot 2 - Kuwagata Version (Japan) ",
    "productCode": "DMG-A2NJ-JPN"
  },
  "539": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "2770": {
    "name": "Crayon Shin-chan 2 - Ora to Wanpaku Gokko Dazo (Japan)",
    "productCode": "DMG-COJ"
  },
  "2320": {
    "name": "Super Snakey (Japan) ",
    "productCode": "DMG-AWSJ-JPN"
  },
  "31": {
    "name": "Uno - Small World (Japan)",
    "productCode": "DMG-UCJ"
  },
  "1625": {
    "name": "Snowboard Champion (Japan)",
    "productCode": "CGB-B5CJ-JPN"
  },
  "610": {
    "name": "Pocket Bomber Man (Japan) ",
    "productCode": "DMG-APOJ-JPN"
  },
  "1275": {
    "name": "Penguin Wars (USA)",
    "productCode": "DMG-PWJ"
  },
  "240": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "2009": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "2459": {
    "name": "Fleet Commander VS. (Japan)",
    "productCode": "DMG-FCJ"
  },
  "755": {
    "name": "J.League Live '95 (Japan) ",
    "productCode": "DMG-AWGJ-JPN"
  },
  "1760": {
    "name": "Hamster Paradise",
    "productCode": "DMG-AHMJ-JPN"
  },
  "305": {
    "name": "Bomber Man GB 2 (Japan) ",
    "productCode": "DMG-AB2J-JPN"
  },
  "1330": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "581": {
    "name": "G-Arms Operation Gundam",
    "productCode": "DMG-GAJ"
  },
  "2232": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "2662": {
    "name": "Animal Breeder 2 (Japan) ",
    "productCode": "DMG-AAJJ-JPN"
  },
  "2398": {
    "name": "Korokoro Kirby (Japan)",
    "productCode": "CGB-KKKJ-JPN"
  },
  "89": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "978": {
    "name": "Sa-Ga 3 - Jikuu no Hasha (Japan)",
    "productCode": "DMG-OSJ"
  },
  "997": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "2377": {
    "name": "Zelda no Densetsu - Yume o Miru Shima DX (Japan)  ",
    "productCode": "DMG-AZLJ-JPN"
  },
  "66": {
    "name": "The Muppets (USA)",
    "productCode": "CGB-BMUE-USA"
  },
  "1808": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "2727": {
    "name": "World Cup Striker (Japan)",
    "productCode": "DMG-YKA"
  },
  "217": {
    "name": "Monster Race (Japan) ",
    "productCode": "DMG-AMRJ-JPN"
  },
  "1222": {
    "name": "Q Billion (Japan)",
    "productCode": "DMG-QBA"
  },
  "647": {
    "name": "Kinniku Banzuke GB3 - Shinseiki Survival Retsuden! (Japan)",
    "productCode": "CGB-B7KJ-JPN"
  },
  "1388": {
    "name": "Monster Farm Battle Card GB (Japan) ",
    "productCode": "DMG-A6TJ-JPN"
  },
  "1672": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1367": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "352": {
    "name": "Famista (Japan)",
    "productCode": "DMG-FSJ"
  },
  "1737": {
    "name": "Hyper Lode Runner",
    "productCode": "DMG-HLA"
  },
  "2818": {
    "name": "Soukoban 2",
    "productCode": "DMG-SQJ"
  },
  "702": {
    "name": "Jinsei Game Densetsu (Japan)",
    "productCode": "DMG-JGJ"
  },
  "2674": {
    "name": "Medarot 3 - Kuwagata Version (Japan)",
    "productCode": "CGB-B33J-JPN"
  },
  "2224": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "3065": {
    "name": "Spot - The Video Game (USA)",
    "productCode": "DMG-S3-USA"
  },
  "1058": {
    "name": "Castlevania - The Adventure (USA)",
    "productCode": "DMG-CV-USA"
  },
  "597": {
    "name": "Momotarou Dengeki Momotaro Thunderbolt",
    "productCode": "DMG-G5J"
  },
  "1408": {
    "name": "Tetris DX (World)  ",
    "productCode": "DMG-ATEA-JPN"
  },
  "128": {
    "name": "Rockman World 3 (Japan)",
    "productCode": "DMG-W3J"
  },
  "578": {
    "name": "SD Gundam - SD Sengokuden - Kunitori Monogatari (Japan)",
    "productCode": "DMG-SDJ"
  },
  "2731": {
    "name": "Meitantei Conan - Karakuri Jiin Satsujin Jiken (Japan) ",
    "productCode": "DMG-A4BJ-JPN"
  },
  "70": {
    "name": "Chachamaru Boukenki 3 - Abyss no Tou (Japan)",
    "productCode": "DMG-A3J"
  },
  "2361": {
    "name": "Power Pro Kun Pocket 2 (Japan) ",
    "productCode": "DMG-BPWJ-JPN"
  },
  "981": {
    "name": "SD Lupin Sansei - Kinko Yaburi Daisakusen (Japan)",
    "productCode": "DMG-XRJ"
  },
  "1664": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "651": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "1234": {
    "name": "Meitantei Conan - Giwaku no Gouka Ressha (Japan) ",
    "productCode": "DMG-ADKJ-JPN"
  },
  "201": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "2048": {
    "name": "Funny Field (Japan)",
    "productCode": "DMG-FUA"
  },
  "2418": {
    "name": "Midori no Makibaou (Japan) ",
    "productCode": "DMG-ANAJ-JPN"
  },
  "714": {
    "name": "Karakuri Kengou Den - Musashi Lord (Japan)",
    "productCode": "DMG-MUJ"
  },
  "1721": {
    "name": "Sanrio Timenet - Kako Hen (Japan) ",
    "productCode": "DMG-ATPJ-JPN"
  },
  "344": {
    "name": "Namco Gallery Vol.2 (Japan) ",
    "productCode": "DMG-AN2J-JPN"
  },
  "1371": {
    "name": "Las Vegas Cool Hand (USA)",
    "productCode": "DMG-ACWE-USA"
  },
  "190": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "3032": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "2273": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "893": {
    "name": "Nettou Samurai Spirits (Japan)  ",
    "productCode": "DMG-X4J"
  },
  "2789": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2623": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "939": {
    "name": "GB Harobots (Japan)",
    "productCode": "CGB-BHRJ-JPN"
  },
  "27": {
    "name": "Bomber Man GB (Japan) ",
    "productCode": "DMG-EEJ"
  },
  "2336": {
    "name": "Centipede (USA)",
    "productCode": "DMG-AC5E-USA"
  },
  "2766": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1849": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "485": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1799": {
    "name": "Moguranya (Japan) ",
    "productCode": "DMG-AMOJ-JPN"
  },
  "256": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "1263": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "606": {
    "name": "Bomber Man - Pocket (USA)",
    "productCode": "DMG-AKQE-USA"
  },
  "1633": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "1326": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "313": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "2859": {
    "name": "Yoshi no Panepon",
    "productCode": "DMG-AYLJ-JPN"
  },
  "1776": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "743": {
    "name": "Game Boy Gallery (Japan) ",
    "productCode": "DMG-AGAJ-JPN"
  },
  "1998": {
    "name": "Contra (Japan)",
    "productCode": "DMG-CNJ"
  },
  "807": {
    "name": "Soreike! Anpanman - 5-tsu no Tou no Ousama (Japan)",
    "productCode": "CGB-BS2J-JPN"
  },
  "1832": {
    "name": "QIX (USA)",
    "productCode": "DMG-QX-USA"
  },
  "554": {
    "name": "Hiryuu no Ken Gaiden (Japan)",
    "productCode": "DMG-HRJ"
  },
  "1561": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "104": {
    "name": "Shanghai Pocket (Japan) ",
    "productCode": "DMG-ASEJ-JPN"
  },
  "1131": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1424": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "411": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "3049": {
    "name": "Nakayoshi Pet Series 1 - Kawaii Hamster (Japan) ",
    "productCode": "DMG-B7HJ-JPN"
  },
  "1074": {
    "name": "Ganbare Goemon - Sarawareta Ebisumaru (Japan)",
    "productCode": "DMG-GCJ"
  },
  "2208": {
    "name": "Pocket Monsters - Pikachu (Japan)  ",
    "productCode": "DMG-APSJ-JPN"
  },
  "2658": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1977": {
    "name": "Gremlins 2 - The New Batch (World)",
    "productCode": "DMG-GRA"
  },
  "942": {
    "name": "Dead Heat Scramble (USA)",
    "productCode": "DMG-DHA"
  },
  "692": {
    "name": "Kinniku Banzuke GB - Chousensha wa Kimida! (Japan) ",
    "productCode": "DMG-A5KJ-JPN"
  },
  "368": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQIJ-JPN"
  },
  "2988": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "2822": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "738": {
    "name": "Shounen Ashibe - Yuuenchi Panic (Japan)",
    "productCode": "DMG-A2J"
  },
  "2571": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "2121": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2434": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "2064": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1218": {
    "name": "Magical Taruruuto-kun (Japan)",
    "productCode": "DMG-MGJ"
  },
  "2967": {
    "name": "Donkey Kong Land (Japan) ",
    "productCode": "DMG-ADDJ-JPN"
  },
  "1648": {
    "name": "Kinniku Banzuke GB3 - Shinseiki Survival Retsuden! (Japan)",
    "productCode": "CGB-B7KJ-JPN"
  },
  "387": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1166": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "153": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1536": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "503": {
    "name": "Medarot 3 - Kabuto Version (Japan)",
    "productCode": "CGB-B32J-JPN"
  },
  "1865": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "850": {
    "name": "Mario Tennis GB (Japan)",
    "productCode": "CGB-BM8J-JPN"
  },
  "915": {
    "name": "Kawa no Nushi Tsuri 3 (Japan) ",
    "productCode": "DMG-A7KJ-JPN"
  },
  "1920": {
    "name": "Shounen Ashibe - Yuuenchi Panic (Japan)",
    "productCode": "DMG-A2J"
  },
  "1023": {
    "name": "Namco Classic (Japan)",
    "productCode": "DMG-NHJ"
  },
  "1189": {
    "name": "Balloon Kid (USA, Europe)",
    "productCode": "DMG-BT-USA"
  },
  "446": {
    "name": "Game Boy Gallery (Japan) ",
    "productCode": "DMG-AGAJ-JPN"
  },
  "1473": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "2176": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "2526": {
    "name": "Bokujou Monogatari GB (Japan)  ",
    "productCode": "DMG-AYWJ-JPN"
  },
  "2875": {
    "name": "Bakuten Shoot Beyblade (Japan)",
    "productCode": "CGB-BB3J-JPN"
  },
  "295": {
    "name": "Alleyway (World)",
    "productCode": "DMG-AWA"
  },
  "2930": {
    "name": "Doraemon - Taiketsu Himitsu Dougu (Japan)",
    "productCode": "DMG-DEJ"
  },
  "780": {
    "name": "Famista (Japan)",
    "productCode": "DMG-FSJ"
  },
  "2033": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQIJ-JPN"
  },
  "2463": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "2199": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "846": {
    "name": "Fushigi no Dungeon Fuurai No Shiren (Japan) ",
    "productCode": "DMG-AFDJ-JPN"
  },
  "1873": {
    "name": "Ultraman Club - Tekikaijuu o Hakken seyo! (Japan)",
    "productCode": "DMG-ULJ"
  },
  "515": {
    "name": "Medarot - Kuwagata Version (Japan)",
    "productCode": "DMG-AMYJ-JPN"
  },
  "1520": {
    "name": "Game de Hakken!! Tamagotchi - Osutchi to Mesutchi (Japan) ",
    "productCode": "DMG-AOMJ-JPN"
  },
  "145": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "1170": {
    "name": "Oyatsu Quiz Mogu Mogu Q (Japan) ",
    "productCode": "DMG-AMQJ-JPN"
  },
  "1465": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "450": {
    "name": "Looney Tunes - Twouble! (USA) ",
    "productCode": "DMG-AYRE-USA"
  },
  "1035": {
    "name": "Hyper Lode Runner",
    "productCode": "DMG-HLA"
  },
  "3008": {
    "name": "Onigashima Pachinkoten (Japan)",
    "productCode": "DMG-OGJ"
  },
  "2249": {
    "name": "Mickey Mouse (Japan)",
    "productCode": "DMG-MMA"
  },
  "1936": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2619": {
    "name": "Monopoly (Japan) ",
    "productCode": "DMG-AHAJ-JPN"
  },
  "903": {
    "name": "Nemesis (Japan)",
    "productCode": "DMG-NMA"
  },
  "329": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "283": {
    "name": "Nekketsu Kouha Kunio-kun - Bangai Rantou Hen (Japan)",
    "productCode": "DMG-KUJ"
  },
  "2863": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "779": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2530": {
    "name": "Dragon Ball Z - Gokuu Gekitouden (Japan) ",
    "productCode": "DMG-AZ2J-JPN"
  },
  "2160": {
    "name": "Shanghai Pocket (Japan) ",
    "productCode": "DMG-ASEJ-JPN"
  },
  "2475": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "2025": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "796": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1259": {
    "name": "Majokko Mari-chan no Kisekae Monogatari (Japan)  ",
    "productCode": "DMG-A23J-JPN"
  },
  "1609": {
    "name": "Soukoban",
    "productCode": "DMG-SOJ"
  },
  "2926": {
    "name": "Quarth (Japan)",
    "productCode": "DMG-QRJ"
  },
  "1127": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "112": {
    "name": "James Bond 007 (USA, Europe) ",
    "productCode": "DMG-AW7E-USA-1"
  },
  "1577": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "542": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "1824": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "811": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "954": {
    "name": "Crayon Shin-chan - Ora to Shiro wa Otomodachi Da yo (Japan)",
    "productCode": "DMG-K4J"
  },
  "1961": {
    "name": "Donkey Kong Land (Japan) ",
    "productCode": "DMG-ADDJ-JPN"
  },
  "1598": {
    "name": "Bishoujo Senshi Sailor Moon R (Japan)",
    "productCode": "DMG-QAJ"
  },
  "1062": {
    "name": "Super Mario Land (World)",
    "productCode": "DMG-ML-USA"
  },
  "407": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "1432": {
    "name": "Cosmo Tank (Japan)",
    "productCode": "DMG-CTJ"
  },
  "2137": {
    "name": "Super Street Basketball (Japan)",
    "productCode": "DMG-F7A"
  },
  "2567": {
    "name": "Kisekae Series 3 - Kisekae Hamster (Japan)",
    "productCode": "CGB-BKHJ-JPN"
  },
  "2834": {
    "name": "Phantom Zona (Japan) ",
    "productCode": "DMG-BKZJ-JPN"
  },
  "684": {
    "name": "Ultraman (Japan)",
    "productCode": "DMG-UNJ"
  },
  "391": {
    "name": "Nakayoshi Pet Series 1 - Kawaii Hamster (Japan) ",
    "productCode": "DMG-B7HJ-JPN"
  },
  "2971": {
    "name": "Battle Space (Japan)",
    "productCode": "DMG-NXJ"
  },
  "2072": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2588": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "2422": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2455": {
    "name": "Pipe Dream (USA)",
    "productCode": "DMG-PDA"
  },
  "2005": {
    "name": "Tetris Flash (Japan) ",
    "productCode": "DMG-EHJ"
  },
  "1783": {
    "name": "Monopoly (Japan) ",
    "productCode": "DMG-AHAJ-JPN"
  },
  "1279": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1629": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2906": {
    "name": "Tales of Phantasia - Narikiri Dungeon (Japan) ",
    "productCode": "DMG-AN6J-JPN"
  },
  "309": {
    "name": "Cardcaptor Sakura - Itsumo Sakura-chan to Issho (Japan)",
    "productCode": "DMG-AM7J-JPN"
  },
  "2843": {
    "name": "Sanrio Timenet - Kako Hen (Japan) ",
    "productCode": "DMG-ATPJ-JPN"
  },
  "1296": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "759": {
    "name": "F-1 Spirit (Japan)",
    "productCode": "DMG-FZJ"
  },
  "2510": {
    "name": "Volley Fire (Japan)",
    "productCode": "DMG-VFJ"
  },
  "2140": {
    "name": "Pokemon - Gold Version (USA, Europe)  ",
    "productCode": "DMG-AAUE-USA"
  },
  "1445": {
    "name": "Kinniku Banzuke GB - Chousensha wa Kimida! (Japan) ",
    "productCode": "DMG-A5KJ-JPN"
  },
  "470": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "3028": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "1015": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2269": {
    "name": "Dracula Densetsu (Japan)",
    "productCode": "DMG-CVJ"
  },
  "889": {
    "name": "TUROK RAGE WARS (USA)",
    "productCode": "CGB-AR7E-USA"
  },
  "2793": {
    "name": "SD Gundam - SD Sengokuden - Kunitori Monogatari (Japan)",
    "productCode": "DMG-SDJ"
  },
  "1916": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "2639": {
    "name": "FASTEST LAP",
    "productCode": "DMG-F2A"
  },
  "923": {
    "name": "Golf de Ohasuta (Japan)",
    "productCode": "DMG-AOHJ-JPN"
  },
  "866": {
    "name": "GB Basketball (Japan)",
    "productCode": "DMG-OFJ"
  },
  "2286": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1853": {
    "name": "Mini Yonku GB Let's & Go!! (Japan) ",
    "productCode": "DMG-AM4J-JPN"
  },
  "535": {
    "name": "Q Billion (Japan)",
    "productCode": "DMG-QBA"
  },
  "1500": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "165": {
    "name": "Dragon Ball Z - Gokuu Hishouden (Japan) ",
    "productCode": "DMG-ADBJ-JPN"
  },
  "1150": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "2951": {
    "name": "Hyper Lode Runner",
    "productCode": "DMG-HLA"
  },
  "1384": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2052": {
    "name": "Tennis (World)",
    "productCode": "DMG-TNA"
  },
  "2402": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2117": {
    "name": "NBA All Star Challenge 2 (Japan)",
    "productCode": "DMG-H2A"
  },
  "2547": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2814": {
    "name": "Nekketsu Kouha Kunio-kun - Bangai Rantou Hen (Japan)",
    "productCode": "DMG-KUJ"
  },
  "1691": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "974": {
    "name": "Pocket Monsters - Ao (Japan) ",
    "productCode": "DMG-APEJ-JPN"
  },
  "1": {
    "name": "Golf Ou: The King of Golf",
    "productCode": "DMG-AZAJ-JPN"
  },
  "2394": {
    "name": "Bomber Boy (Japan)",
    "productCode": "DMG-HBA"
  },
  "85": {
    "name": "Picross 2 (Japan) ",
    "productCode": "DMG-AP2J-JPN"
  },
  "1941": {
    "name": "Puyo Puyo (Japan)  ",
    "productCode": "DMG-QQJ"
  },
  "1042": {
    "name": "SD Gundam - SD Sengokuden - Kunitori Monogatari (Japan)",
    "productCode": "DMG-SDJ"
  },
  "427": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "1412": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "1107": {
    "name": "Double Dragon (Japan)",
    "productCode": "DMG-DDA"
  },
  "132": {
    "name": "Pocket Family GB 2 (Japan)",
    "productCode": "CGB-HF2J-JPN"
  },
  "1557": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "562": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "1804": {
    "name": "Kindaichi Shounen no Jikenbo - 10nenme no Shoutaijou (Japan) ",
    "productCode": "DMG-BKSJ-JPN"
  },
  "831": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "2681": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "2414": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2044": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1238": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "1392": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2947": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "1668": {
    "name": "Othello World (Japan) ",
    "productCode": "DMG-ATOJ-JPN"
  },
  "348": {
    "name": "Pachi-Slot Kids 2 (Japan)",
    "productCode": "DMG-OHJ"
  },
  "1687": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2802": {
    "name": "Phantasm (Japan)",
    "productCode": "DMG-P8J"
  },
  "718": {
    "name": "Pocket Color Block (Japan) ",
    "productCode": "DMG-AC6J-JPN"
  },
  "2551": {
    "name": "Bakuten Shoot Beyblade (Japan)",
    "productCode": "CGB-BB3J-JPN"
  },
  "2101": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "1404": {
    "name": "SD Gundam - SD Sengokuden - Kunitori Monogatari (Japan)",
    "productCode": "DMG-SDJ"
  },
  "431": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "1054": {
    "name": "Power Pro Kun Pocket 2 (Japan) ",
    "productCode": "DMG-BPWJ-JPN"
  },
  "3069": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "2228": {
    "name": "Meitantei Conan - Giwaku no Gouka Ressha (Japan) ",
    "productCode": "DMG-ADKJ-JPN"
  },
  "2678": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "1957": {
    "name": "Zelda no Densetsu - Fushigi no Kinomi - Daichi no Shou (Japan)",
    "productCode": "CGB-AZ7J-JPN"
  },
  "93": {
    "name": "Moguranya (Japan) ",
    "productCode": "DMG-AMOJ-JPN"
  },
  "2382": {
    "name": "Alleyway (World)",
    "productCode": "DMG-AWA"
  },
  "962": {
    "name": "Dragon Quest I & II (Japan) ",
    "productCode": "DMG-AEDJ-JPN"
  },
  "2697": {
    "name": "Kaisen Game - Navyblue (Japan)",
    "productCode": "DMG-NBA"
  },
  "827": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "1812": {
    "name": "Tottoko Hamutarou 2 (Japan)",
    "productCode": "CGB-B86J-JPN"
  },
  "574": {
    "name": "Power Pro Kun Pocket 2 (Japan) ",
    "productCode": "DMG-BPWJ-JPN"
  },
  "1541": {
    "name": "J.League Winning Goal (Japan)",
    "productCode": "DMG-W7J"
  },
  "124": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "1111": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2910": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1795": {
    "name": "Bomber Man GB (Japan) ",
    "productCode": "DMG-EEJ"
  },
  "2013": {
    "name": "Alleyway (World)",
    "productCode": "DMG-AWA"
  },
  "2443": {
    "name": "Pocket Puyo Puyo Sun (Japan) ",
    "productCode": "DMG-AYSJ-JPN"
  },
  "2156": {
    "name": "Puyo Puyo (Japan)  ",
    "productCode": "DMG-QQJ"
  },
  "2506": {
    "name": "Othello World (Japan) ",
    "productCode": "DMG-ATOJ-JPN"
  },
  "1280": {
    "name": "All-Star Baseball 2000 (USA)",
    "productCode": "CGB-AATE-USA"
  },
  "2855": {
    "name": "Bomber Man GB (Japan) ",
    "productCode": "DMG-EEJ"
  },
  "935": {
    "name": "Medarot 2 - Kabuto Version (Japan) ",
    "productCode": "DMG-A2MJ-JPN"
  },
  "1900": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2785": {
    "name": "Wataru Mazekko Monster (Japan) ",
    "productCode": "DMG-AWAJ-JPN"
  },
  "1003": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "466": {
    "name": "Crayon Shin-chan - Ora to Shiro wa Otomodachi Da yo (Japan)",
    "productCode": "DMG-K4J"
  },
  "1453": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "489": {
    "name": "Pocket Pro Wrestling - Perfect Wrestler (Japan)",
    "productCode": "CGB-AJVJ-JPN"
  },
  "1146": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "173": {
    "name": "TONY HAWK'S PRO SKATER (USA)",
    "productCode": "CGB-BTFE-USA"
  },
  "1516": {
    "name": "The King of Fighters '95 (USA) ",
    "productCode": "DMG-AKFE-USA"
  },
  "523": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1845": {
    "name": "F-1 Race (USA)",
    "productCode": "DMG-F1-USA"
  },
  "2290": {
    "name": "Golf Daisuki! (Japan) ",
    "productCode": "DMG-AAGJ-JPN"
  },
  "870": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2087": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "734": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "1701": {
    "name": "Magical Taruruuto-kun (Japan)",
    "productCode": "DMG-MGJ"
  },
  "2984": {
    "name": "Nakajima Satoru - F-1 Hero GB - World Championship '91 (Japan)",
    "productCode": "DMG-F3J"
  },
  "364": {
    "name": "America Oudan Ultra Quiz Part 3 (Japan)",
    "productCode": "DMG-U3J"
  },
  "1351": {
    "name": "Famista (Japan)",
    "productCode": "DMG-FSJ"
  },
  "1644": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "671": {
    "name": "Bomberman Max - Red Challenger (USA)",
    "productCode": "CGB-A7BE-USA"
  },
  "1214": {
    "name": "Mr. Driller (Japan)",
    "productCode": "CGB-BMDJ-JPN"
  },
  "221": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "2068": {
    "name": "Nekketsu Kouha Kunio-kun - Bangai Rantou Hen (Japan)",
    "productCode": "DMG-KUJ"
  },
  "2592": {
    "name": "Godzilla - The Series (USA) ",
    "productCode": "DMG-AZIE-USA"
  },
  "2438": {
    "name": "Super Black Bass Pocket 2 (Japan) ",
    "productCode": "DMG-ABTJ-JPN"
  },
  "108": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "558": {
    "name": "Medarot 4 - Kabuto Version (Japan)",
    "productCode": "CGB-B4MJ-JPN"
  },
  "1097": {
    "name": "Shougi (Japan)",
    "productCode": "DMG-SGJ"
  },
  "2711": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "50": {
    "name": "Karakuri Kengou Den - Musashi Lord (Japan)",
    "productCode": "DMG-MUJ"
  },
  "2341": {
    "name": "SD Gundam Gaiden : Lacroan' Heroes (Japan)",
    "productCode": "DMG-LHJ"
  },
  "1994": {
    "name": "Bomber Man GB 2 (Japan) ",
    "productCode": "DMG-AB2J-JPN"
  },
  "2654": {
    "name": "Medarot 4 - Kabuto Version (Japan)",
    "productCode": "CGB-B4MJ-JPN"
  },
  "2204": {
    "name": "Jimmy Connors no Pro Tennis Tour (Japan)",
    "productCode": "DMG-JCA"
  },
  "1582": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1078": {
    "name": "Super Momotarou Dentetsu II (Japan)",
    "productCode": "DMG-G9J"
  },
  "3045": {
    "name": "Doraemon - Taiketsu Himitsu Dougu (Japan)",
    "productCode": "DMG-DEJ"
  },
  "1428": {
    "name": "R-Type (Japan)",
    "productCode": "DMG-REA"
  },
  "1306": {
    "name": "Pac-Panic (Japan) ",
    "productCode": "DMG-NOA"
  },
  "333": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "299": {
    "name": "Parodius Da! (Japan)",
    "productCode": "DMG-PVJ"
  },
  "2879": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "1756": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "763": {
    "name": "Pocket Monsters - Aka (Japan)  ",
    "productCode": "DMG-APAJ-JPN"
  },
  "2480": {
    "name": "Space Invaders (USA)",
    "productCode": "DMG-SP-USA"
  },
  "2195": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "2896": {
    "name": "Sanrio Timenet - Mirai Hen (Japan) ",
    "productCode": "DMG-ATFJ-JPN"
  },
  "276": {
    "name": "Tennis (World)",
    "productCode": "DMG-TNA"
  },
  "1243": {
    "name": "Pachinko Time (Japan)",
    "productCode": "DMG-PTJ"
  },
  "626": {
    "name": "Ultraman Club - Tekikaijuu o Hakken seyo! (Japan)",
    "productCode": "DMG-ULJ"
  },
  "1613": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2316": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "2746": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1869": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1490": {
    "name": "Meitantei Conan - Kigantou Hihou Densetsu (Japan) ",
    "productCode": "DMG-A5BJ-JPN"
  },
  "1185": {
    "name": "NBA All Star Challenge 2 (Japan)",
    "productCode": "DMG-H2A"
  },
  "3012": {
    "name": "SOCCER - Tonkin House (Japan) ",
    "productCode": "DMG-GSA"
  },
  "2253": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "1886": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2603": {
    "name": "Bakuten Shoot Beyblade (Japan)",
    "productCode": "CGB-BB3J-JPN"
  },
  "919": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "2496": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "775": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "1740": {
    "name": "Avenging Spirit",
    "productCode": "DMG-P8-USA"
  },
  "325": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1310": {
    "name": "Medarot - Kabuto Version (Japan) ",
    "productCode": "DMG-AMXJ-JPN"
  },
  "1605": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "630": {
    "name": "WWF WAR ZONE (USA)",
    "productCode": "DMG-AWWE-USA"
  },
  "1255": {
    "name": "Bubble Bobble (Japan)",
    "productCode": "DMG-B2A"
  },
  "260": {
    "name": "NBA JAM 99 (USA)",
    "productCode": "DMG-AJME-USA"
  },
  "2880": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2029": {
    "name": "Pokemon - Blue Version (USA, Europe) ",
    "productCode": "DMG-APEE-USA"
  },
  "2479": {
    "name": "Medarot - Kuwagata Version (Japan)",
    "productCode": "DMG-AMYJ-JPN"
  },
  "2183": {
    "name": "Captain Tsubasa VS (Japan)",
    "productCode": "DMG-T5J"
  },
  "1486": {
    "name": "Bug's Life, A (USA) ",
    "productCode": "DMG-APXE-USA"
  },
  "149": {
    "name": "Alleyway (World)",
    "productCode": "DMG-AWA"
  },
  "519": {
    "name": "Zelda no Densetsu - Yume o Miru Shima (Japan)",
    "productCode": "DMG-ZLJ"
  },
  "2750": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2300": {
    "name": "Sports Illustrated for Kids - The Ultimate Triple Dare! (USA)",
    "productCode": "DMG-U8-USA"
  },
  "11": {
    "name": "Robot Poncots - Sun Version (Japan) ",
    "productCode": "DMG-HREJ-JPN"
  },
  "2615": {
    "name": "Magical Taruruuto-kun 2 - Raibaa Zone Panic!! (Japan)",
    "productCode": "DMG-MFJ"
  },
  "1890": {
    "name": "Mini 4 Boy (Japan) ",
    "productCode": "DMG-AJ4J-JPN"
  },
  "2245": {
    "name": "Pocket Monsters - Aka (Japan)  ",
    "productCode": "DMG-APAJ-JPN"
  },
  "3004": {
    "name": "Sanrio Uranai Party (Japan)",
    "productCode": "DMG-AG7J-JPN"
  },
  "1039": {
    "name": "Pocket Monsters - Aka (Japan)  ",
    "productCode": "DMG-APAJ-JPN"
  },
  "1193": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "1469": {
    "name": "Donkey Kong (World)  ",
    "productCode": "DMG-QDA"
  },
  "1347": {
    "name": "Sanrio Timenet - Mirai Hen (Japan) ",
    "productCode": "DMG-ATFJ-JPN"
  },
  "688": {
    "name": "Power Pro Kun Pocket (Japan)  ",
    "productCode": "DMG-AVVJ-JPN"
  },
  "372": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "2992": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "1717": {
    "name": "Super B-Daman - Fighting Phoenix (Japan) ",
    "productCode": "DMG-ABDJ-JPN"
  },
  "2838": {
    "name": "Korokoro Kirby (Japan)",
    "productCode": "CGB-KKKJ-JPN"
  },
  "722": {
    "name": "Yuu Yuu Hakusho Dai-4-Tama: Makai Touitsu (Japan) ",
    "productCode": "DMG-AUUJ-JPN"
  },
  "2091": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2584": {
    "name": "Puyo Puyo (Japan)  ",
    "productCode": "DMG-QQJ"
  },
  "237": {
    "name": "Racing Damashii (Japan)",
    "productCode": "DMG-RDJ"
  },
  "1202": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "667": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1652": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "1982": {
    "name": "Super Gals! Kotobuki Ran (Japan)",
    "productCode": "CGB-BGLJ-JPN"
  },
  "2357": {
    "name": "Momotarou Densetsu Gaiden (Japan)",
    "productCode": "DMG-MIJ"
  },
  "46": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "1828": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "2707": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1081": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "3053": {
    "name": "Skate or Die - Bad 'N Rad (USA)",
    "productCode": "DMG-SK-USA"
  },
  "1594": {
    "name": "Tottoko Hamutarou - Tomodachi Daisakusen Dechu (Japan)",
    "productCode": "CGB-BHTJ-JPN"
  },
  "2212": {
    "name": "Momotarou Dentetsu jr. - Zenkoku Ramen Meguri no Maki (Japan) ",
    "productCode": "DMG-AD8J-JPN"
  },
  "2642": {
    "name": "Pro Mahjong Kiwame GB II (Japan) ",
    "productCode": "DMG-AA2J-JPN"
  },
  "958": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "2513": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "2143": {
    "name": "Heiankyou Alien (Japan)",
    "productCode": "DMG-HAA"
  },
  "2840": {
    "name": "Hamster Paradise 2 (Japan)",
    "productCode": "CGB-BHMJ-JPN"
  },
  "1295": {
    "name": "Parodius Da! (Japan)",
    "productCode": "DMG-PVJ"
  },
  "1780": {
    "name": "Kinniku Banzuke GB2 - Mezase! Muscle Champion (Japan) ",
    "productCode": "DMG-B6KJ-JPN"
  },
  "2905": {
    "name": "Pocket Monsters - Midori (Japan)  ",
    "productCode": "DMG-APBJ-JPN"
  },
  "2456": {
    "name": "Osawagase! Penguin Boy",
    "productCode": "DMG-PNJ"
  },
  "2006": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "536": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "1503": {
    "name": "Family Jockey (Japan)",
    "productCode": "DMG-FJJ"
  },
  "166": {
    "name": "Kaijuu Ou Gojira (Japan)",
    "productCode": "DMG-G7J"
  },
  "1153": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "865": {
    "name": "Medarot 2 - Kabuto Version (Japan) ",
    "productCode": "DMG-A2MJ-JPN"
  },
  "2285": {
    "name": "Bomber Man Max - Yami no Senshi (Japan)",
    "productCode": "CGB-A7BJ-JPN"
  },
  "1850": {
    "name": "Rockman World 2 (Japan)",
    "productCode": "DMG-W2J"
  },
  "2790": {
    "name": "Pocket Monsters Gin (Japan)  ",
    "productCode": "DMG-AAXJ-JPN"
  },
  "1915": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "920": {
    "name": "Hokuto no Ken - Seizetsu Juuban Shoubu (Japan)",
    "productCode": "DMG-HKJ"
  },
  "1446": {
    "name": "Sanrio Timenet - Mirai Hen (Japan) ",
    "productCode": "DMG-ATFJ-JPN"
  },
  "189": {
    "name": "Yu Yu Hakusho Dai-3-tama : Makai no Tobira (Japan)",
    "productCode": "DMG-UGJ"
  },
  "473": {
    "name": "Hiryuu no Ken Gaiden (Japan)",
    "productCode": "DMG-HRJ"
  },
  "1016": {
    "name": "Kidou Senkan Nadesico - Ruri Ruri Mahjong (Japan)",
    "productCode": "CGB-AQNJ-JPN"
  },
  "2817": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "1738": {
    "name": "Meitantei Conan - Chika Yuuenchi Satsujin Jiken (Japan) ",
    "productCode": "DMG-ADCJ-JPN"
  },
  "1692": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "1368": {
    "name": "Pokemon Pinball (USA)  ",
    "productCode": "DMG-VPHE-USA"
  },
  "2114": {
    "name": "Pro Mahjong Kiwame GB II (Japan) ",
    "productCode": "DMG-AA2J-JPN"
  },
  "2544": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "2051": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "2401": {
    "name": "Medarot - Kabuto Version (Japan) ",
    "productCode": "DMG-AMXJ-JPN"
  },
  "2952": {
    "name": "Dragon Ball Z - Gokuu Hishouden (Japan) ",
    "productCode": "DMG-ADBJ-JPN"
  },
  "1387": {
    "name": "Hamster Club (Japan)",
    "productCode": "DMG-AJNJ-JPN"
  },
  "648": {
    "name": "Konchuu Hakase (Japan)  ",
    "productCode": "DMG-AKJJ-JPN"
  },
  "218": {
    "name": "Sanrio Timenet - Kako Hen (Japan) ",
    "productCode": "DMG-ATPJ-JPN"
  },
  "2728": {
    "name": "Daisenryaku (Japan)",
    "productCode": "DMG-HDJ"
  },
  "1807": {
    "name": "Toy Story (USA)  ",
    "productCode": "DMG-AQHE-USA"
  },
  "832": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "69": {
    "name": "Yu Yu Hakusho (Japan)",
    "productCode": "DMG-UUJ"
  },
  "2378": {
    "name": "Monster Traveler (Japan) ",
    "productCode": "CGB-BFVJ-JPN"
  },
  "998": {
    "name": "Bishoujo Senshi Sailor Moon R (Japan)",
    "productCode": "DMG-QAJ"
  },
  "2682": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "1104": {
    "name": "Crayon Shin-chan 2 - Ora to Wanpaku Gokko Dazo (Japan)",
    "productCode": "DMG-COJ"
  },
  "131": {
    "name": "Rush 2049 (USA)",
    "productCode": "CGB-ASXE-USA"
  },
  "1554": {
    "name": "Nekketsu Koukou Soccer-bu - World Cup Hen (Japan)",
    "productCode": "DMG-NCJ"
  },
  "561": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "1041": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "424": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "1411": {
    "name": "Trump Boy (Japan)",
    "productCode": "DMG-TBJ"
  },
  "977": {
    "name": "HOT WHEELS STUNT TRACK DRIVER (USA)",
    "productCode": "DMG-AHEE-USA"
  },
  "2": {
    "name": "Flipull (Japan)",
    "productCode": "DMG-FPA"
  },
  "86": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "2397": {
    "name": "Power Pro Kun Pocket (Japan)  ",
    "productCode": "DMG-AVVJ-JPN"
  },
  "1942": {
    "name": "Gakken - Rekishi 512",
    "productCode": "DMG-AR3J-JPN"
  },
  "2552": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "2102": {
    "name": "Medarot - Kuwagata Version (Japan)",
    "productCode": "DMG-AMYJ-JPN"
  },
  "1684": {
    "name": "F-1 Race (USA)",
    "productCode": "DMG-F1-USA"
  },
  "2801": {
    "name": "Doraemon no Game Boy de Asobouyo Deluxe 10 (Japan) ",
    "productCode": "DMG-ADPJ-JPN"
  },
  "1391": {
    "name": "Moguranya (Japan) ",
    "productCode": "DMG-AMOJ-JPN"
  },
  "2944": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "2417": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "2047": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "577": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1542": {
    "name": "Kakutou Ryouri Densetsu Bistro Recipe - Kettou Bistgarm Hen (Japan) ",
    "productCode": "DMG-A2WJ-JPN"
  },
  "127": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1112": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "2694": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "824": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1811": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1954": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "2381": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "90": {
    "name": "Dokidoki Densetsu - Mahoujin Guruguru (Japan)",
    "productCode": "CGB-B96J-JPN"
  },
  "961": {
    "name": "Teenage Mutant Ninja Turtles - Fall of the Foot Clan (USA)",
    "productCode": "DMG-NT-USA"
  },
  "1407": {
    "name": "Doraemon - Taiketsu Himitsu Dougu (Japan)",
    "productCode": "DMG-DEJ"
  },
  "432": {
    "name": "Meitantei Conan - Giwaku no Gouka Ressha (Japan) ",
    "productCode": "DMG-ADKJ-JPN"
  },
  "598": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1057": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "1283": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1779": {
    "name": "Pocket Monsters Gin (Japan)  ",
    "productCode": "DMG-AAXJ-JPN"
  },
  "2856": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1329": {
    "name": "Medarot 3 - Kabuto Version (Japan)",
    "productCode": "CGB-B32J-JPN"
  },
  "2155": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "2505": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "2010": {
    "name": "Cardcaptor Sakura - Itsumo Sakura-chan to Issho (Japan)",
    "productCode": "DMG-AM7J-JPN"
  },
  "2440": {
    "name": "Meitantei Conan - Kigantou Hihou Densetsu (Japan) ",
    "productCode": "DMG-A5BJ-JPN"
  },
  "2913": {
    "name": "Capcom Quiz - Hatena no Daibouken (Japan)",
    "productCode": "DMG-HHJ"
  },
  "609": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "259": {
    "name": "Prince of Persia (USA)",
    "productCode": "DMG-ARIE-USA"
  },
  "1796": {
    "name": "Tennis (World)",
    "productCode": "DMG-TNA"
  },
  "1846": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2769": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "2293": {
    "name": "Hunter X Hunter - Kindan no Hihou (Japan)",
    "productCode": "CGB-BHKJ-JPN"
  },
  "873": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "2339": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "28": {
    "name": "Twinbee Da!! (Japan)",
    "productCode": "DMG-TDJ"
  },
  "1145": {
    "name": "Pachinko Time (Japan)",
    "productCode": "DMG-PTJ"
  },
  "170": {
    "name": "Hamster Paradise 2 (Japan)",
    "productCode": "CGB-BHMJ-JPN"
  },
  "1515": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "520": {
    "name": "Jinsei Game (Japan) ",
    "productCode": "DMG-AZGJ-JPN"
  },
  "1000": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "465": {
    "name": "Akazukin Chacha (Japan) ",
    "productCode": "DMG-ACCJ-JPN"
  },
  "1450": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "936": {
    "name": "The Smurfs Nightmare (USA)",
    "productCode": "CGB-ASNE-USA"
  },
  "1903": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2786": {
    "name": "Hamster Club (Japan)",
    "productCode": "DMG-AJNJ-JPN"
  },
  "2591": {
    "name": "Dino Breeder 2 (Japan) ",
    "productCode": "DMG-A2DJ-JPN"
  },
  "388": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1647": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2968": {
    "name": "Monster Race (Japan) ",
    "productCode": "DMG-AMRJ-JPN"
  },
  "672": {
    "name": "Mary-Kate & Ashley Get a Clue (USA)",
    "productCode": "DMG-BXFE-USA"
  },
  "1217": {
    "name": "Kingyo Chuuihou! - Wapiko no Wakuwaku Stamp Rally! (Japan)",
    "productCode": "DMG-KTJ"
  },
  "222": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "737": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1702": {
    "name": "007: The World Is Not Enough (USA)",
    "productCode": "CGB-BO7E-USA"
  },
  "2987": {
    "name": "Frogger (USA)",
    "productCode": "DMG-AFRE-USA"
  },
  "367": {
    "name": "Mahou Kishi Rayearth",
    "productCode": "DMG-ARYJ-JPN"
  },
  "1352": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "2084": {
    "name": "Meitantei Conan - Chika Yuuenchi Satsujin Jiken (Japan) ",
    "productCode": "DMG-ADCJ-JPN"
  },
  "1581": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "3046": {
    "name": "Midori no Makibaou (Japan) ",
    "productCode": "DMG-ANAJ-JPN"
  },
  "1978": {
    "name": "Sa-Ga 2 - Hihou Densetsu (Japan)",
    "productCode": "DMG-S2J"
  },
  "2657": {
    "name": "B-Daman Bakugaiden V - Final Mega Tune (Japan)",
    "productCode": "CGB-AIRJ-JPN"
  },
  "2207": {
    "name": "SD Sengokuden 2 - Tenka Touitsu Hen (Japan)",
    "productCode": "DMG-G3J"
  },
  "2712": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "808": {
    "name": "Medarot Cardrobottle - Kabuto Version (Japan) ",
    "productCode": "DMG-A8CJ-JPN"
  },
  "2342": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "53": {
    "name": "Crayon Shin-chan - Ora to Shiro wa Otomodachi Da yo (Japan)",
    "productCode": "DMG-K4J"
  },
  "1997": {
    "name": "Sylvanian Families 3 - Hoshi Furu Yoru no Sunadokei (Japan)",
    "productCode": "CGB-BL3J-JPN"
  },
  "1094": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2895": {
    "name": "Bokujou Monogatari GB (Japan)  ",
    "productCode": "DMG-AYWJ-JPN"
  },
  "275": {
    "name": "Hercules (USA, Europe)",
    "productCode": "DMG-AHCE-USA"
  },
  "1240": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "625": {
    "name": "Yoshi no Panepon",
    "productCode": "DMG-AYLJ-JPN"
  },
  "1610": {
    "name": "G-Arms Operation Gundam",
    "productCode": "DMG-GAJ"
  },
  "2196": {
    "name": "Bishoujo Senshi Sailor Moon R (Japan)",
    "productCode": "DMG-QAJ"
  },
  "2529": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "2179": {
    "name": "Black Bass - Lure Fishing (USA)",
    "productCode": "DMG-ALFE-USA"
  },
  "2483": {
    "name": "From TV Animation Slam Dunk - Gakeppuchi no Kesshou League (Japan) ",
    "productCode": "DMG-HXJ"
  },
  "1305": {
    "name": "Sanrio Uranai Party (Japan)",
    "productCode": "DMG-AG7J-JPN"
  },
  "330": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "1755": {
    "name": "Tekkyu Fight! - The Great Battle Gaiden (Japan)",
    "productCode": "DMG-IBJ"
  },
  "760": {
    "name": "Puzznic (Japan)",
    "productCode": "DMG-PZA"
  },
  "2250": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1885": {
    "name": "Ultraman Chou Toushi Gekiden (Japan) ",
    "productCode": "DMG-QUJ"
  },
  "2600": {
    "name": "Power Pro Kun Pocket (Japan)  ",
    "productCode": "DMG-AVVJ-JPN"
  },
  "449": {
    "name": "Yoshi no Panepon",
    "productCode": "DMG-AYLJ-JPN"
  },
  "1186": {
    "name": "Dancing Furby (Japan)",
    "productCode": "DMG-BFBJ-JPN"
  },
  "3011": {
    "name": "Tetris Flash (Japan) ",
    "productCode": "DMG-EHJ"
  },
  "1539": {
    "name": "World Bowling (Japan)",
    "productCode": "DMG-WBA"
  },
  "1493": {
    "name": "Tekkyu Fight! - The Great Battle Gaiden (Japan)",
    "productCode": "DMG-IBJ"
  },
  "1169": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "2315": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2745": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2180": {
    "name": "Ganbare Goemon - Kurofunetou no Nazo (Japan) ",
    "productCode": "DMG-AGDJ-JPN"
  },
  "2929": {
    "name": "Pocket Puyo Puyo Sun (Japan) ",
    "productCode": "DMG-AYSJ-JPN"
  },
  "1606": {
    "name": "Space Invaders (Japan)",
    "productCode": "DMG-SPA"
  },
  "633": {
    "name": "Hamster Paradise 2 (Japan)",
    "productCode": "CGB-BHMJ-JPN"
  },
  "1256": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "799": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQIJ-JPN"
  },
  "263": {
    "name": "Nemesis (Japan)",
    "productCode": "DMG-NMA"
  },
  "2883": {
    "name": "Medarot 2 - Kuwagata Version (Japan) ",
    "productCode": "DMG-A2NJ-JPN"
  },
  "776": {
    "name": "Kingyo Chuuihou! 2 - Gyopi-chan o Sagase! (Japan)",
    "productCode": "DMG-KJJ"
  },
  "1743": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "326": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "1313": {
    "name": "Game Boy Wars (Japan)",
    "productCode": "DMG-GWJ"
  },
  "2495": {
    "name": "Sesame Street - The Adventures of Elmo in Grouchland (USA)",
    "productCode": "DMG-AELE-USA"
  },
  "3007": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1190": {
    "name": "Pokemon Pinball (Japan)  ",
    "productCode": "DMG-VPHJ-JPN"
  },
  "2616": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "1939": {
    "name": "G-Arms Operation Gundam",
    "productCode": "DMG-GAJ"
  },
  "1893": {
    "name": "NBA All-Star Challenge 2 (USA, Europe)",
    "productCode": "DMG-H2-USA"
  },
  "2246": {
    "name": "Ganbare Goemon - Kurofunetou no Nazo (Japan) ",
    "productCode": "DMG-AGDJ-JPN"
  },
  "2753": {
    "name": "Momotarou Densetsu Gaiden (Japan)",
    "productCode": "DMG-MIJ"
  },
  "849": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "12": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "2303": {
    "name": "Tetris DX (World)  ",
    "productCode": "DMG-ATEA-JPN"
  },
  "1485": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "234": {
    "name": "Final Reverse (Japan)",
    "productCode": "DMG-FIJ"
  },
  "1201": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "664": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "1651": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "2587": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2568": {
    "name": "SD Sengokuden 2 - Tenka Touitsu Hen (Japan)",
    "productCode": "DMG-G3J"
  },
  "2092": {
    "name": "Tottoko Hamutarou 2 (Japan)",
    "productCode": "CGB-B86J-JPN"
  },
  "2138": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "1344": {
    "name": "SD Gundam Gaiden : Lacroan' Heroes (Japan)",
    "productCode": "DMG-LHJ"
  },
  "371": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "2991": {
    "name": "Super B-Daman - Fighting Phoenix (Japan) ",
    "productCode": "DMG-ABDJ-JPN"
  },
  "1714": {
    "name": "From TV Animation One Piece - Maboroshi no Grand Line Boukenki! (Japan) ",
    "productCode": "DMG-BZOJ-JPN"
  },
  "721": {
    "name": "Tottoko Hamutarou - Tomodachi Daisakusen Dechu (Japan)",
    "productCode": "CGB-BHTJ-JPN"
  },
  "2211": {
    "name": "Meitantei Conan - Karakuri Jiin Satsujin Jiken (Japan) ",
    "productCode": "DMG-A4BJ-JPN"
  },
  "2641": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "408": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "3050": {
    "name": "Crayon Shin-chan 3 - Ora no Gokigen Athletic (Japan)",
    "productCode": "DMG-HJJ"
  },
  "1597": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "1082": {
    "name": "F1 Boy (Japan)",
    "productCode": "DMG-FBJ"
  },
  "1578": {
    "name": "Motocross Maniacs (Japan)",
    "productCode": "DMG-MXA"
  },
  "1128": {
    "name": "Kirby no Kirakira Kids (Japan) ",
    "productCode": "DMG-AKCJ-JPN"
  },
  "1981": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "45": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "2354": {
    "name": "Hamster Club (Japan)",
    "productCode": "DMG-AJNJ-JPN"
  },
  "2704": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2773": {
    "name": "G-Arms Operation Gundam",
    "productCode": "DMG-GAJ"
  },
  "2289": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "869": {
    "name": "Shougi (Japan)",
    "productCode": "DMG-SGJ"
  },
  "32": {
    "name": "4-in-1 Fun Pak (USA)",
    "productCode": "DMG-F4-USA-1"
  },
  "2323": {
    "name": "Medarot 2 - Kabuto Version (Japan) ",
    "productCode": "DMG-A2MJ-JPN"
  },
  "490": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "3027": {
    "name": "Magical Taruruuto-kun (Japan)",
    "productCode": "DMG-MGJ"
  },
  "185": {
    "name": "Zen-Nihon Shounen Soccer Taikai - Mezase Nihon Ichi! (Japan)",
    "productCode": "CGB-BJFJ-JPN"
  },
  "2636": {
    "name": "Paperboy (USA)",
    "productCode": "DMG-MP-USA"
  },
  "1919": {
    "name": "Pocket Monsters Kin (Japan)  ",
    "productCode": "DMG-AAUJ-JPN"
  },
  "886": {
    "name": "Baseball Kids (Japan)",
    "productCode": "DMG-BKJ"
  },
  "2266": {
    "name": "Nakayoshi Pet Series 2 - Kawaii Usagi (Japan) (GB Compatible)",
    "productCode": "DMG-B7UJ-JPN"
  },
  "756": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1299": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "1763": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "306": {
    "name": "Mario Tennis GB (Japan)",
    "productCode": "CGB-BM8J-JPN"
  },
  "1333": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "2909": {
    "name": "Othello (Japan)",
    "productCode": "DMG-OTJ"
  },
  "1626": {
    "name": "Ranma 1-2 - Kakugeki Mondou!! (Japan)",
    "productCode": "DMG-ROJ"
  },
  "613": {
    "name": "Wario Land 3 (World) ",
    "productCode": "CGB-AW8A-JPN"
  },
  "1276": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "243": {
    "name": "WWF RAW (USA)",
    "productCode": "DMG-AWFE-USA"
  },
  "1558": {
    "name": "Nettou Garou Densetsu 2 - Aratanaru Tatakai (Japan) ",
    "productCode": "DMG-X3J"
  },
  "1108": {
    "name": "F-1 Spirit (Japan)",
    "productCode": "DMG-FZJ"
  },
  "994": {
    "name": "Bokujou Monogatari GB (Japan)  ",
    "productCode": "DMG-AYWJ-JPN"
  },
  "65": {
    "name": "Bob the Builder - Fix it Fun! (USA)",
    "productCode": "CGB-BOBE-USA"
  },
  "2374": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2724": {
    "name": "Mickey's Dangerous Chase (USA)",
    "productCode": "DMG-MC-USA"
  },
  "2231": {
    "name": "Animal Breeder 2 (Japan) ",
    "productCode": "DMG-AAJJ-JPN"
  },
  "2661": {
    "name": "Doraemon no Study Boy 3",
    "productCode": "DMG-AKKJ-JPN"
  },
  "428": {
    "name": "Alleyway (World)",
    "productCode": "DMG-AWA"
  },
  "582": {
    "name": "Mario Golf GB (Japan)",
    "productCode": "CGB-AWXJ-JPN"
  },
  "2548": {
    "name": "Yu Yu Hakusho Dai-3-tama : Makai no Tobira (Japan)",
    "productCode": "DMG-UGJ"
  },
  "2118": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1364": {
    "name": "Pocket Puyo Puyo Sun (Japan) ",
    "productCode": "DMG-AYSJ-JPN"
  },
  "351": {
    "name": "Pocket Monsters - Aka (Japan)  ",
    "productCode": "DMG-APAJ-JPN"
  },
  "1734": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "701": {
    "name": "Pocket Monsters Kin (Japan)  ",
    "productCode": "DMG-AAUJ-JPN"
  },
  "214": {
    "name": "Fushigi no Dungeon Fuurai No Shiren (Japan) ",
    "productCode": "DMG-AFDJ-JPN"
  },
  "1221": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "644": {
    "name": "Rockman X - Cyber Mission (Japan)",
    "productCode": "DMG-BRXJ-JPN"
  },
  "1671": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2732": {
    "name": "Nanonote (Japan)",
    "productCode": "DMG-NNJ"
  },
  "828": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2362": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "73": {
    "name": "Harry Potter to Kenja no Ishi (Japan)",
    "productCode": "CGB-BHVJ-JPN"
  },
  "982": {
    "name": "Razor Freestyle Scooter (USA)",
    "productCode": "CGB-BRZE-USA"
  },
  "2698": {
    "name": "Chibi Maruko-chan - Okozukai Daisakusen! (Japan)",
    "productCode": "DMG-CMJ"
  },
  "3066": {
    "name": "Tesserae (USA)",
    "productCode": "DMG-ER-USA"
  },
  "594": {
    "name": "Fushigi no Dungeon Fuurai No Shiren (Japan) ",
    "productCode": "DMG-AFDJ-JPN"
  },
  "1958": {
    "name": "Pachi-Slot Hisshou Guide GB (Japan) ",
    "productCode": "DMG-APGJ-JPN"
  },
  "2677": {
    "name": "Pocket Monsters - Midori (Japan)  ",
    "productCode": "DMG-APBJ-JPN"
  },
  "2227": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "717": {
    "name": "Hamster Club Awasete chu (Japan)",
    "productCode": "CGB-BJHJ-JPN"
  },
  "1722": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1688": {
    "name": "Monster Farm Battle Card GB (Japan) ",
    "productCode": "DMG-A6TJ-JPN"
  },
  "347": {
    "name": "Dexterity (USA)",
    "productCode": "DMG-FU-USA"
  },
  "1372": {
    "name": "From TV Animation One Piece - Maboroshi no Grand Line Boukenki! (Japan) ",
    "productCode": "DMG-BZOJ-JPN"
  },
  "1667": {
    "name": "Mickey Mouse (Japan)",
    "productCode": "DMG-MMA"
  },
  "2948": {
    "name": "Doraemon 2 - Animal Planet Densetsu (Japan)",
    "productCode": "DMG-DMJ"
  },
  "652": {
    "name": "Dai-2-ji Super Robot Taisen G (Japan) ",
    "productCode": "DMG-AG2J-JPN"
  },
  "1237": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "202": {
    "name": "Famista (Japan)",
    "productCode": "DMG-FSJ"
  },
  "1519": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "1149": {
    "name": "Chi to Ase to Namida no Koukou Yakyuu (Japan)",
    "productCode": "CGB-BBJJ-JPN"
  },
  "486": {
    "name": "Ganbare Goemon - Sarawareta Ebisumaru (Japan)",
    "productCode": "DMG-GCJ"
  },
  "2335": {
    "name": "WORLD CIRCUIT SERIES (USA)",
    "productCode": "DMG-FZ-USA"
  },
  "24": {
    "name": "Dragon Ball Z - Gokuu Hishouden (Japan) ",
    "productCode": "DMG-ADBJ-JPN"
  },
  "2765": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "2270": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "890": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2620": {
    "name": "Wheel of Fortune (USA)",
    "productCode": "DMG-WF-USA"
  },
  "193": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "469": {
    "name": "Medarot - Kuwagata Version (Japan)",
    "productCode": "DMG-AMYJ-JPN"
  },
  "3031": {
    "name": "Super Momotarou Dentetsu II (Japan)",
    "productCode": "DMG-G9J"
  },
  "2509": {
    "name": "Tennis (World)",
    "productCode": "DMG-TNA"
  },
  "2159": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "1325": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "310": {
    "name": "Kinniku Banzuke GB3 - Shinseiki Survival Retsuden! (Japan)",
    "productCode": "CGB-B7KJ-JPN"
  },
  "1775": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "740": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "255": {
    "name": "Wario Land 3 (World) ",
    "productCode": "CGB-AW8A-JPN"
  },
  "1260": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "605": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "1630": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1974": {
    "name": "Donkey Kong Land (Japan) ",
    "productCode": "DMG-ADDJ-JPN"
  },
  "941": {
    "name": "Meitantei Conan - Karakuri Jiin Satsujin Jiken (Japan) ",
    "productCode": "DMG-A4BJ-JPN"
  },
  "1427": {
    "name": "America Oudan Ultra Quiz Part 2 (Japan)",
    "productCode": "DMG-AUJ"
  },
  "412": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1077": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "1098": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "557": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "1562": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "107": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "1132": {
    "name": "Nemesis (Japan)",
    "productCode": "DMG-NMA"
  },
  "804": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "1831": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "2964": {
    "name": "Magical Tetris Challenge (USA)",
    "productCode": "CGB-AT7E-USA"
  },
  "384": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2437": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2067": {
    "name": "Side Pocket (World)",
    "productCode": "DMG-SWA"
  },
  "2572": {
    "name": "Mario Tennis GB (Japan)",
    "productCode": "CGB-BM8J-JPN"
  },
  "2088": {
    "name": "Momotarou Densetsu Gaiden (Japan)",
    "productCode": "DMG-MIJ"
  },
  "2122": {
    "name": "Animal Breeder 2 (Japan) ",
    "productCode": "DMG-AAJJ-JPN"
  },
  "691": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "2821": {
    "name": "Gobs of Games (USA) ",
    "productCode": "CGB-BFGE-USA"
  },
  "1020": {
    "name": "Shougi (Japan)",
    "productCode": "DMG-SGJ"
  },
  "445": {
    "name": "Same Game (Japan) ",
    "productCode": "DMG-AS5J-JPN"
  },
  "1470": {
    "name": "DX Jinsei Game (Japan)",
    "productCode": "CGB-BZGJ-JPN"
  },
  "916": {
    "name": "Metroid II - Return of Samus (World)",
    "productCode": "DMG-ME-USA"
  },
  "1923": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "1889": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "1866": {
    "name": "Shounen Ashibe - Yuuenchi Panic (Japan)",
    "productCode": "DMG-A2J"
  },
  "2749": {
    "name": "Hamster Paradise",
    "productCode": "DMG-AHMJ-JPN"
  },
  "853": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "2319": {
    "name": "GB Pachi-Slot Hisshouhou! Jr (Japan)",
    "productCode": "DMG-IPJ"
  },
  "1165": {
    "name": "R-Type (Japan)",
    "productCode": "DMG-REA"
  },
  "150": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "1535": {
    "name": "Zelda no Densetsu - Fushigi no Kinomi - Jikuu no Shou (Japan)",
    "productCode": "CGB-AZ8J-JPN"
  },
  "500": {
    "name": "Meitantei Conan - Karakuri Jiin Satsujin Jiken (Japan) ",
    "productCode": "DMG-A4BJ-JPN"
  },
  "2030": {
    "name": "SOCCER - Tonkin House (Japan) ",
    "productCode": "DMG-GSA"
  },
  "2460": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2933": {
    "name": "Crayon Shin-chan 3 - Ora no Gokigen Athletic (Japan)",
    "productCode": "DMG-HJJ"
  },
  "629": {
    "name": "J.League Fighting Soccer - The King of Ace Strikers (Japan)",
    "productCode": "DMG-JLJ"
  },
  "783": {
    "name": "Bomber Man GB (Japan) ",
    "productCode": "DMG-EEJ"
  },
  "279": {
    "name": "Baseball Kids (Japan)",
    "productCode": "DMG-BKJ"
  },
  "2899": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "1759": {
    "name": "Suzuki Aguri no F-1 Super Driving (Japan)",
    "productCode": "DMG-FQJ"
  },
  "2876": {
    "name": "Bomber Boy (Japan)",
    "productCode": "DMG-HBA"
  },
  "296": {
    "name": "Donkey Kong Land (Japan) ",
    "productCode": "DMG-ADDJ-JPN"
  },
  "1309": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2175": {
    "name": "Tottoko Hamutarou 2 (Japan)",
    "productCode": "CGB-B86J-JPN"
  },
  "2525": {
    "name": "Kingyo Chuuihou! - Wapiko no Wakuwaku Stamp Rally! (Japan)",
    "productCode": "DMG-KTJ"
  },
  "1935": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "900": {
    "name": "Gekitou Power Modeller (Japan) ",
    "productCode": "DMG-APZJ-JPN"
  },
  "1466": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "453": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1036": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "516": {
    "name": "Taikyoku Renju (Japan) ",
    "productCode": "DMG-TCA"
  },
  "1523": {
    "name": "Dancing Furby (Japan)",
    "productCode": "DMG-BFBJ-JPN"
  },
  "146": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1489": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQIJ-JPN"
  },
  "1173": {
    "name": "Doraemon 2 - Animal Planet Densetsu (Japan)",
    "productCode": "DMG-DMJ"
  },
  "845": {
    "name": "Pocket Monsters - Pikachu (Japan)  ",
    "productCode": "DMG-APSJ-JPN"
  },
  "1870": {
    "name": "Animal Breeder 3 (Japan) ",
    "productCode": "DMG-AA3J-JPN"
  },
  "795": {
    "name": "WWF RAW (USA)",
    "productCode": "DMG-AWFE-USA"
  },
  "2925": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2476": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2026": {
    "name": "Solomon's Club (Europe)",
    "productCode": "DMG-SC-UKV"
  },
  "2533": {
    "name": "Honoo no Toukyuuji - Dodge Danpei (Japan)",
    "productCode": "DMG-DAJ"
  },
  "2163": {
    "name": "Yu Yu Hakusho Dai-2-dan - Ankoku Bujutsukai Hen (Japan)",
    "productCode": "DMG-UKJ"
  },
  "2499": {
    "name": "Goukaku Boy GOLD - Shikakui Atama o Maruku Suru - Nanmon no Sho (Japan)",
    "productCode": "DMG-BS4J-JPN"
  },
  "280": {
    "name": "Hamster Club (Japan)",
    "productCode": "DMG-AJNJ-JPN"
  },
  "2860": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1061": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "404": {
    "name": "Q Billion (USA)",
    "productCode": "DMG-QB-USA"
  },
  "1431": {
    "name": "The Powerpuff Girls - Paint the Townsville Green (USA)",
    "productCode": "CGB-BPTE-USA"
  },
  "957": {
    "name": "Nekketsu Koukou Soccer-bu - World Cup Hen (Japan)",
    "productCode": "DMG-NCJ"
  },
  "1962": {
    "name": "Jantaku Boy (Japan)",
    "productCode": "DMG-GJJ"
  },
  "2708": {
    "name": "Aladdin (USA)",
    "productCode": "CGB-BADE-USA"
  },
  "1827": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "812": {
    "name": "Baseball Kids (Japan)",
    "productCode": "DMG-BKJ"
  },
  "49": {
    "name": "Medarot 2 - Kuwagata Version (Japan) ",
    "productCode": "DMG-A2NJ-JPN"
  },
  "2358": {
    "name": "Dai-2-ji Super Robot Taisen G (Japan) ",
    "productCode": "DMG-AG2J-JPN"
  },
  "1124": {
    "name": "Tottoko Hamutarou 2 (Japan)",
    "productCode": "CGB-B86J-JPN"
  },
  "111": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "1574": {
    "name": "Tennis (World)",
    "productCode": "DMG-TNA"
  },
  "541": {
    "name": "Super B-Daman - Fighting Phoenix (Japan) ",
    "productCode": "DMG-ABDJ-JPN"
  },
  "2071": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2421": {
    "name": "Daikaijuu Monogatari - The Miracle of the Zone (Japan) ",
    "productCode": "DMG-AMZJ-JPN"
  },
  "392": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "2972": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "668": {
    "name": "Doraemon - Taiketsu Himitsu Dougu (Japan)",
    "productCode": "DMG-DEJ"
  },
  "238": {
    "name": "Donkey Kong 2001 (Japan)",
    "productCode": "CGB-BDDJ-JPN"
  },
  "2837": {
    "name": "Ganbare Goemon - Sarawareta Ebisumaru (Japan)",
    "productCode": "DMG-GCJ"
  },
  "1718": {
    "name": "Bakuten Shoot Beyblade (Japan)",
    "productCode": "CGB-BB3J-JPN"
  },
  "687": {
    "name": "Monster Race 2 (Japan) ",
    "productCode": "DMG-AMWJ-JPN"
  },
  "1348": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "2134": {
    "name": "Bomber Man GB (Japan) ",
    "productCode": "DMG-EEJ"
  },
  "2564": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2070": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2420": {
    "name": "Pocket Monsters - Aka (Japan)  ",
    "productCode": "DMG-APAJ-JPN"
  },
  "2973": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "393": {
    "name": "Bomber Man GB 2 (Japan) ",
    "productCode": "DMG-AB2J-JPN"
  },
  "669": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "239": {
    "name": "Tiny Toon Adventures (Japan)",
    "productCode": "DMG-TXJ"
  },
  "2836": {
    "name": "Hamster Club 2 (Japan)",
    "productCode": "DMG-BJNJ-JPN"
  },
  "1719": {
    "name": "Oide Rascal (Japan)",
    "productCode": "CGB-BLSJ-JPN"
  },
  "1349": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "686": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "2135": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2565": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1060": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "405": {
    "name": "Sylvanian Melodies - Mori no Nakama to Odori Masho! (Japan) ",
    "productCode": "DMG-BMKJ-JPN"
  },
  "1430": {
    "name": "Dragon Quest I & II (Japan) ",
    "productCode": "DMG-AEDJ-JPN"
  },
  "956": {
    "name": "Nakajima Satoru - F-1 Hero GB - World Championship '91 (Japan)",
    "productCode": "DMG-F3J"
  },
  "1963": {
    "name": "Dead Heat Scramble (USA)",
    "productCode": "DMG-DHA"
  },
  "2709": {
    "name": "The Fortress of Fear - Wizards & Warriors X (USA, Europe)",
    "productCode": "DMG-WW-USA"
  },
  "1826": {
    "name": "Medarot - Kuwagata Version (Japan)",
    "productCode": "DMG-AMYJ-JPN"
  },
  "813": {
    "name": "Wario Land 3 (World) ",
    "productCode": "CGB-AW8A-JPN"
  },
  "48": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2359": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "1125": {
    "name": "Yu Yu Hakusho (Japan)",
    "productCode": "DMG-UUJ"
  },
  "110": {
    "name": "Kinniku Banzuke GB - Chousensha wa Kimida! (Japan) ",
    "productCode": "DMG-A5KJ-JPN"
  },
  "1575": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "540": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "794": {
    "name": "Donkey Kong GB - Dinky Kong & Dixie Kong (Japan)",
    "productCode": "CGB-AD3J-JPN"
  },
  "2924": {
    "name": "Mickey Mouse V (Japan)",
    "productCode": "DMG-I5J"
  },
  "2477": {
    "name": "Nettou The King of Fighters '96 (Japan) ",
    "productCode": "DMG-AK6J-JPN"
  },
  "2027": {
    "name": "Mini Yonku GB Let's & Go!! (Japan) ",
    "productCode": "DMG-AM4J-JPN"
  },
  "2532": {
    "name": "Bishoujo Senshi Sailor Moon (Japan)",
    "productCode": "DMG-AQJ"
  },
  "2162": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2498": {
    "name": "Magical Taruruuto-kun (Japan)",
    "productCode": "DMG-MGJ"
  },
  "2861": {
    "name": "Game Boy Gallery 2 (Japan)",
    "productCode": "DMG-AGIJ-JPN"
  },
  "281": {
    "name": "Donkey Kong (World)  ",
    "productCode": "DMG-QDA"
  },
  "1934": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "901": {
    "name": "J.League Live '95 (Japan) ",
    "productCode": "DMG-AWGJ-JPN"
  },
  "1467": {
    "name": "Kawa no Nushi Tsuri 3 (Japan) ",
    "productCode": "DMG-A7KJ-JPN"
  },
  "452": {
    "name": "Medarot 3 - Kuwagata Version (Japan)",
    "productCode": "CGB-B33J-JPN"
  },
  "1037": {
    "name": "Double Dragon (Japan)",
    "productCode": "DMG-DDA"
  },
  "517": {
    "name": "Medarot 2 - Kuwagata Version (Japan) ",
    "productCode": "DMG-A2NJ-JPN"
  },
  "1522": {
    "name": "Game Boy Wars (Japan)",
    "productCode": "DMG-GWJ"
  },
  "1488": {
    "name": "Pachinko Kaguya Hime (Japan)",
    "productCode": "DMG-P7J"
  },
  "147": {
    "name": "Pocket Monsters - Aka (Japan)  ",
    "productCode": "DMG-APAJ-JPN"
  },
  "1172": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "844": {
    "name": "J.League Fighting Soccer - The King of Ace Strikers (Japan)",
    "productCode": "DMG-JLJ"
  },
  "1871": {
    "name": "Hyper Lode Runner",
    "productCode": "DMG-HLA"
  },
  "2031": {
    "name": "ARMY MEN SARGE'S HEROES 2 (USA)",
    "productCode": "CGB-BSHE-USA"
  },
  "2461": {
    "name": "Nintendo Power Memory Cartridge",
    "productCode": "DMG-MMSA-JPN"
  },
  "2932": {
    "name": "Parodius Da! (Japan)",
    "productCode": "DMG-PVJ"
  },
  "628": {
    "name": "Tottemo! Lucky Man - Lucky Cookie Minna Daisuki!! (Japan) ",
    "productCode": "DMG-ALKJ-JPN"
  },
  "782": {
    "name": "Medarot 2 - Kabuto Version (Japan) ",
    "productCode": "DMG-A2MJ-JPN"
  },
  "2898": {
    "name": "Sylvanian Families - Otogi no Kuni no Pendant (Japan) ",
    "productCode": "DMG-ALVJ-JPN"
  },
  "278": {
    "name": "Street Fighter II (Japan) ",
    "productCode": "DMG-ASFJ-JPN"
  },
  "297": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQIJ-JPN"
  },
  "1758": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2877": {
    "name": "Bakuten Shoot Beyblade (Japan)",
    "productCode": "CGB-BB3J-JPN"
  },
  "1308": {
    "name": "Taikyoku Renju (Japan) ",
    "productCode": "DMG-TCA"
  },
  "2174": {
    "name": "Tennis (World)",
    "productCode": "DMG-TNA"
  },
  "2524": {
    "name": "Sa-Ga 2 - Hihou Densetsu (Japan)",
    "productCode": "DMG-S2J"
  },
  "1021": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "444": {
    "name": "Mary-Kate and Ashley - Crush Course (USA, Europe)",
    "productCode": "CGB-BCVE-USA"
  },
  "1471": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "917": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "1922": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "1888": {
    "name": "Doraemon Kart (Japan) ",
    "productCode": "DMG-ADRJ-JPN"
  },
  "1867": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2748": {
    "name": "Shutokou Racing, The (Japan)  ",
    "productCode": "DMG-ASUJ-JPN"
  },
  "852": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2318": {
    "name": "Mario Golf GB (Japan)",
    "productCode": "CGB-AWXJ-JPN"
  },
  "1164": {
    "name": "Taikyoku Renju (Japan) ",
    "productCode": "DMG-TCA"
  },
  "151": {
    "name": "Dig Dug (USA)",
    "productCode": "DMG-DY-USA"
  },
  "1534": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "501": {
    "name": "Jinsei Game Densetsu (Japan)",
    "productCode": "DMG-JGJ"
  },
  "385": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2965": {
    "name": "SolarStriker (World)",
    "productCode": "DMG-SSA"
  },
  "2436": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "2066": {
    "name": "NBA All-Star Challenge 2 (USA, Europe)",
    "productCode": "DMG-H2-USA"
  },
  "2573": {
    "name": "Makai Toushi Sa-Ga (Japan)",
    "productCode": "DMG-SAJ"
  },
  "2089": {
    "name": "Mini Yonku GB Let's & Go!! (Japan) ",
    "productCode": "DMG-AM4J-JPN"
  },
  "2123": {
    "name": "Ultraman Club - Tekikaijuu o Hakken seyo! (Japan)",
    "productCode": "DMG-ULJ"
  },
  "690": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2820": {
    "name": "The New Adventures of Mary-Kate & Ashley (USA, Europe) ",
    "productCode": "DMG-AXFE-USA"
  },
  "1975": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "940": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "1426": {
    "name": "Famista (Japan)",
    "productCode": "DMG-FSJ"
  },
  "413": {
    "name": "Battle Dodge Ball (Japan)",
    "productCode": "DMG-D6J"
  },
  "1076": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "556": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "1099": {
    "name": "Super Gals! Kotobuki Ran 2",
    "productCode": "CGB-BGUJ-JPN"
  },
  "1563": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "106": {
    "name": "Ken Griffey Jr.'s Slugfest (USA)",
    "productCode": "CGB-AYAE-USA"
  },
  "1133": {
    "name": "Bokujou Monogatari GB (Japan)  ",
    "productCode": "DMG-AYWJ-JPN"
  },
  "805": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1830": {
    "name": "Woody Woodpecker no Go! Go! Racing (Japan)",
    "productCode": "CGB-BWRJ-JPN"
  },
  "2508": {
    "name": "Medarot 5 - Susutake Mura no Tenkousei - Kabuto (Japan)",
    "productCode": "CGB-B5MJ-JPN"
  },
  "2158": {
    "name": "Nekketsu Koukou Soccer-bu - World Cup Hen (Japan)",
    "productCode": "DMG-NCJ"
  },
  "1324": {
    "name": "Nettou Samurai Spirits (Japan)  ",
    "productCode": "DMG-X4J"
  },
  "311": {
    "name": "Bishoujo Senshi Sailor Moon R (Japan)",
    "productCode": "DMG-QAJ"
  },
  "1774": {
    "name": "Medarot - Parts Collection 2 (Japan) ",
    "productCode": "DMG-A4MJ-JPN"
  },
  "741": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "254": {
    "name": "Teenage Mutant Ninja Turtles 2 (Japan)",
    "productCode": "DMG-TTA"
  },
  "1261": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "604": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "1631": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1518": {
    "name": "SD Gundam - SD Sengokuden - Kunitori Monogatari (Japan)",
    "productCode": "DMG-SDJ"
  },
  "487": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1148": {
    "name": "Battletoads (USA, Europe)",
    "productCode": "DMG-BV-USA"
  },
  "2334": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "25": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "2764": {
    "name": "Momotarou Dentetsu jr. - Zenkoku Ramen Meguri no Maki (Japan) ",
    "productCode": "DMG-AD8J-JPN"
  },
  "891": {
    "name": "J.League Live '95 (Japan) ",
    "productCode": "DMG-AWGJ-JPN"
  },
  "2271": {
    "name": "ARMY MEN 2 (USA)",
    "productCode": "CGB-BA2E-USA"
  },
  "2621": {
    "name": "Pachinko Time (Japan)",
    "productCode": "DMG-PTJ"
  },
  "192": {
    "name": "Puyo Puyo (Japan)  ",
    "productCode": "DMG-QQJ"
  },
  "468": {
    "name": "Kawa no Nushi Tsuri 3 (Japan) ",
    "productCode": "DMG-A7KJ-JPN"
  },
  "3030": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "716": {
    "name": "Mini Yonku GB Let's & Go!! (Japan) ",
    "productCode": "DMG-AM4J-JPN"
  },
  "1723": {
    "name": "Pocket Monsters Kin (Japan)  ",
    "productCode": "DMG-AAUJ-JPN"
  },
  "346": {
    "name": "Snoopy Magic Show (USA)",
    "productCode": "DMG-SN-USA"
  },
  "1689": {
    "name": "Tekkyu Fight! - The Great Battle Gaiden (Japan)",
    "productCode": "DMG-IBJ"
  },
  "1373": {
    "name": "Kinniku Banzuke GB - Chousensha wa Kimida! (Japan) ",
    "productCode": "DMG-A5KJ-JPN"
  },
  "1666": {
    "name": "Bishoujo Senshi Sailor Moon (Japan)",
    "productCode": "DMG-AQJ"
  },
  "2949": {
    "name": "Higashio Osamu Kanshuu Pro Yakyuu Stadium '91 (Japan)",
    "productCode": "DMG-PIJ"
  },
  "653": {
    "name": "Pocket Monsters - Pikachu (Japan)  ",
    "productCode": "DMG-APSJ-JPN"
  },
  "1236": {
    "name": "Pocket Monsters - Pikachu (Japan)  ",
    "productCode": "DMG-APSJ-JPN"
  },
  "203": {
    "name": "Pac-Man - Special Color Edition (USA) ",
    "productCode": "DMG-AACE-USA"
  },
  "2733": {
    "name": "Nekketsu Koukou Soccer-bu - World Cup Hen (Japan)",
    "productCode": "DMG-NCJ"
  },
  "829": {
    "name": "Ganbare Goemon - Sarawareta Ebisumaru (Japan)",
    "productCode": "DMG-GCJ"
  },
  "983": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2363": {
    "name": "Dragon Ball Z - Gokuu Gekitouden (Japan) ",
    "productCode": "DMG-AZ2J-JPN"
  },
  "72": {
    "name": "Super Momotarou Dentetsu II (Japan)",
    "productCode": "DMG-G9J"
  },
  "2699": {
    "name": "Monster Race (Japan) ",
    "productCode": "DMG-AMRJ-JPN"
  },
  "595": {
    "name": "J.League Winning Goal (Japan)",
    "productCode": "DMG-W7J"
  },
  "3067": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "1959": {
    "name": "Pocket Monsters - Pikachu (Japan)  ",
    "productCode": "DMG-APSJ-JPN"
  },
  "2676": {
    "name": "NBA All Star Challenge 2 (Japan)",
    "productCode": "DMG-H2A"
  },
  "2226": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2549": {
    "name": "Sanrio Uranai Party (Japan)",
    "productCode": "DMG-AG7J-JPN"
  },
  "2119": {
    "name": "Dino Breeder (Japan)  ",
    "productCode": "DMG-AWDJ-JPN"
  },
  "1365": {
    "name": "Medarot 3 - Kuwagata Version (Japan)",
    "productCode": "CGB-B33J-JPN"
  },
  "350": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1735": {
    "name": "J.League Winning Goal (Japan)",
    "productCode": "DMG-W7J"
  },
  "700": {
    "name": "Yoshi",
    "productCode": "DMG-YO-USA"
  },
  "215": {
    "name": "Tottoko Hamutarou 2 (Japan)",
    "productCode": "CGB-B86J-JPN"
  },
  "1220": {
    "name": "LEGO Alpha Team (USA)",
    "productCode": "CGB-BLPE-USA"
  },
  "645": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "1670": {
    "name": "Kingyo Chuuihou! - Wapiko no Wakuwaku Stamp Rally! (Japan)",
    "productCode": "DMG-KTJ"
  },
  "1559": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1109": {
    "name": "Quiz Sekai wa Show by Shoubai!! (Japan)",
    "productCode": "DMG-QSJ"
  },
  "64": {
    "name": "Animal Breeder 2 (Japan) ",
    "productCode": "DMG-AAJJ-JPN"
  },
  "2375": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "995": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2725": {
    "name": "Baseball Kids (Japan)",
    "productCode": "DMG-BKJ"
  },
  "2230": {
    "name": "Frogger (USA)",
    "productCode": "DMG-AFRE-USA"
  },
  "2660": {
    "name": "Bakuten Shoot Beyblade (Japan)",
    "productCode": "CGB-BB3J-JPN"
  },
  "429": {
    "name": "Crayon Shin-chan - Ora to Shiro wa Otomodachi Da yo (Japan)",
    "productCode": "DMG-K4J"
  },
  "583": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "1298": {
    "name": "Tasmania Story (USA)",
    "productCode": "DMG-TA-USA"
  },
  "757": {
    "name": "Medarot 4 - Kabuto Version (Japan)",
    "productCode": "CGB-B4MJ-JPN"
  },
  "1762": {
    "name": "SD Gundam Gaiden : Lacroan' Heroes (Japan)",
    "productCode": "DMG-LHJ"
  },
  "307": {
    "name": "Phantom Zona (Japan) ",
    "productCode": "DMG-BKZJ-JPN"
  },
  "1332": {
    "name": "Batman Forever (USA)",
    "productCode": "DMG-A3BE-USA"
  },
  "2908": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "1627": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "612": {
    "name": "The Bugs Bunny Crazy Castle (USA, Europe)",
    "productCode": "DMG-BB-USA"
  },
  "1277": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "242": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "2772": {
    "name": "Scooby-Doo Classic Creep Capers (USA)",
    "productCode": "CGB-BCCE-USA"
  },
  "868": {
    "name": "Crayon Shin-chan 2 - Ora to Wanpaku Gokko Dazo (Japan)",
    "productCode": "DMG-COJ"
  },
  "2288": {
    "name": "Command Master (Japan)",
    "productCode": "CGB-KCEJ-JPN"
  },
  "33": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2322": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "491": {
    "name": "Doraemon 2 - Animal Planet Densetsu (Japan)",
    "productCode": "DMG-DMJ"
  },
  "3026": {
    "name": "Grander Musashi RV (Japan) ",
    "productCode": "DMG-ARVJ-JPN"
  },
  "184": {
    "name": "Real Pro Yakyuu! - Central League Hen (Japan) ",
    "productCode": "DMG-AECJ-JPN"
  },
  "2637": {
    "name": "McDonald's Monogatari  (Japan)",
    "productCode": "CGB-BI9J-JPN"
  },
  "1918": {
    "name": "Tennis (World)",
    "productCode": "DMG-TNA"
  },
  "2267": {
    "name": "Yuu Yuu Hakusho Dai-4-Tama: Makai Touitsu (Japan) ",
    "productCode": "DMG-AUUJ-JPN"
  },
  "887": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2210": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "2640": {
    "name": "Cyborg Kuro-chan 2 - White Woods no Gyakushuu (Japan)",
    "productCode": "CGB-BSBJ-JPN"
  },
  "409": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "3051": {
    "name": "Daikaijuu Monogatari - The Miracle of the Zone (Japan) ",
    "productCode": "DMG-AMZJ-JPN"
  },
  "1596": {
    "name": "Dino Breeder (Japan)  ",
    "productCode": "DMG-AWDJ-JPN"
  },
  "1083": {
    "name": "Puyo Puyo (Japan)  ",
    "productCode": "DMG-QQJ"
  },
  "1579": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "1129": {
    "name": "Flappy Special (Japan)",
    "productCode": "DMG-V2A"
  },
  "1980": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "44": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "2355": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2705": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "235": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "1200": {
    "name": "Medarot 4 - Kabuto Version (Japan)",
    "productCode": "CGB-B4MJ-JPN"
  },
  "665": {
    "name": "Flipull (Japan)",
    "productCode": "DMG-FPA"
  },
  "1650": {
    "name": "Crayon Shin-chan - Ora to Shiro wa Otomodachi Da yo (Japan)",
    "productCode": "DMG-K4J"
  },
  "2586": {
    "name": "G-Arms Operation Gundam",
    "productCode": "DMG-GAJ"
  },
  "2569": {
    "name": "Daiku no Gen-san - Ghost Building Company (Japan)",
    "productCode": "DMG-DIJ"
  },
  "2093": {
    "name": "Bishoujo Senshi Sailor Moon R (Japan)",
    "productCode": "DMG-QAJ"
  },
  "2139": {
    "name": "Warau Inu no Bouken - Silly Go Lucky! (Japan)",
    "productCode": "CGB-BWBJ-JPN"
  },
  "1345": {
    "name": "Motocross Maniacs (Japan)",
    "productCode": "DMG-MXA"
  },
  "2990": {
    "name": "Donkey Kong (World)  ",
    "productCode": "DMG-QDA"
  },
  "370": {
    "name": "SOCCER - Tonkin House (Japan) ",
    "productCode": "DMG-GSA"
  },
  "1715": {
    "name": "Kaeru no Tame ni Kane wa Naru (Japan)",
    "productCode": "DMG-OKJ"
  },
  "720": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "3006": {
    "name": "Pocket Monsters - Aka (Japan)  ",
    "productCode": "DMG-APAJ-JPN"
  },
  "1191": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "2617": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "1938": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "1892": {
    "name": "Super Black Bass Pocket 2 (Japan) ",
    "productCode": "DMG-ABTJ-JPN"
  },
  "2247": {
    "name": "Hamster Club (Japan)",
    "productCode": "DMG-AJNJ-JPN"
  },
  "2752": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "848": {
    "name": "Nekketsu Kouha Kunio-kun - Bangai Rantou Hen (Japan)",
    "productCode": "DMG-KUJ"
  },
  "13": {
    "name": "Meitantei Conan - Norowareta Kouro (Japan) ",
    "productCode": "DMG-BC3J-JPN"
  },
  "2302": {
    "name": "The Powerpuff Girls - Bad Mojo Jojo (USA)",
    "productCode": "CGB-BJJE-USA"
  },
  "1484": {
    "name": "Dave Mirra FreeStyle BMX (USA)",
    "productCode": "CGB-BMXE-USA"
  },
  "2181": {
    "name": "Magical Taruruuto-kun (Japan)",
    "productCode": "DMG-MGJ"
  },
  "2928": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1607": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "632": {
    "name": "Versus Hero - Kakutou Ou e no Michi (Japan)",
    "productCode": "DMG-VHJ"
  },
  "798": {
    "name": "Wataru Mazekko Monster (Japan) ",
    "productCode": "DMG-AWAJ-JPN"
  },
  "1257": {
    "name": "Famista 2 (Japan)",
    "productCode": "DMG-FDJ"
  },
  "2882": {
    "name": "Quarth (Japan)",
    "productCode": "DMG-QRJ"
  },
  "262": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "777": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "1742": {
    "name": "Tottoko Hamutarou - Tomodachi Daisakusen Dechu (Japan)",
    "productCode": "CGB-BHTJ-JPN"
  },
  "327": {
    "name": "Mario Tennis GB (Japan)",
    "productCode": "CGB-BM8J-JPN"
  },
  "1312": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "2494": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2251": {
    "name": "Family Jockey 2 - Meiba no Kettou (Japan)",
    "productCode": "DMG-FVJ"
  },
  "1884": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "2601": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "1187": {
    "name": "Dragon Ball Z - Gokuu Hishouden (Japan) ",
    "productCode": "DMG-ADBJ-JPN"
  },
  "448": {
    "name": "Akumajou Special - Boku Dracula-kun (Japan)",
    "productCode": "DMG-DFJ"
  },
  "3010": {
    "name": "Hiryuu no Ken Gaiden (Japan)",
    "productCode": "DMG-HRJ"
  },
  "1538": {
    "name": "Pocket Monsters - Aka (Japan)  ",
    "productCode": "DMG-APAJ-JPN"
  },
  "1492": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1168": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "2314": {
    "name": "Higashio Osamu Kanshuu Pro Yakyuu Stadium '91 (Japan)",
    "productCode": "DMG-PIJ"
  },
  "2744": {
    "name": "Meitantei Conan - Chika Yuuenchi Satsujin Jiken (Japan) ",
    "productCode": "DMG-ADCJ-JPN"
  },
  "274": {
    "name": "Momotarou Collection 2 (Japan) ",
    "productCode": "DMG-AM3J-JPN"
  },
  "2894": {
    "name": "Othello (Japan)",
    "productCode": "DMG-OTJ"
  },
  "1241": {
    "name": "Taikyoku Renju (Japan) ",
    "productCode": "DMG-TCA"
  },
  "624": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1611": {
    "name": "Tottoko Hamutarou - Tomodachi Daisakusen Dechu (Japan)",
    "productCode": "CGB-BHTJ-JPN"
  },
  "2197": {
    "name": "Bomber Man GB 3 (Japan) ",
    "productCode": "DMG-AB3J-JPN"
  },
  "2528": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "2178": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "2482": {
    "name": "Momotarou Densetsu Gaiden (Japan)",
    "productCode": "DMG-MIJ"
  },
  "1304": {
    "name": "SD Sengokuden 2 - Tenka Touitsu Hen (Japan)",
    "productCode": "DMG-G3J"
  },
  "331": {
    "name": "Sa-Ga 2 - Hihou Densetsu (Japan)",
    "productCode": "DMG-S2J"
  },
  "1754": {
    "name": "Motocross Maniacs (Japan)",
    "productCode": "DMG-MXA"
  },
  "761": {
    "name": "Motocross Maniacs (Japan)",
    "productCode": "DMG-MXA"
  },
  "1580": {
    "name": "SD Gundam - SD Sengokuden - Kunitori Monogatari (Japan)",
    "productCode": "DMG-SDJ"
  },
  "3047": {
    "name": "Bomber Boy (Japan)",
    "productCode": "DMG-HBA"
  },
  "1979": {
    "name": "Moguranya (Japan) ",
    "productCode": "DMG-AMOJ-JPN"
  },
  "2656": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2206": {
    "name": "Doraemon - Taiketsu Himitsu Dougu (Japan)",
    "productCode": "DMG-DEJ"
  },
  "2713": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "809": {
    "name": "720 - Skate or Die (USA)",
    "productCode": "DMG-AA7E-USA"
  },
  "2343": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "52": {
    "name": "Kisekae Series 2 - Oshare Nikki (Japan)",
    "productCode": "CGB-B23J-JPN"
  },
  "1996": {
    "name": "Stuart Little - The Journey Home (USA)",
    "productCode": "CGB-BJIE-USA"
  },
  "1095": {
    "name": "Hamster Paradise 3 (Japan)",
    "productCode": "CGB-BH3J-JPN"
  },
  "2590": {
    "name": "NFL Football (USA)",
    "productCode": "DMG-FT-USA"
  },
  "1646": {
    "name": "Crayon Shin-chan 2 - Ora to Wanpaku Gokko Dazo (Japan)",
    "productCode": "DMG-COJ"
  },
  "2969": {
    "name": "Pac-Man (USA)",
    "productCode": "DMG-PCA"
  },
  "389": {
    "name": "Downtown - Nekketsu Koushinkyoku - Dokodemo Daiundoukai (Japan)",
    "productCode": "DMG-DUJ"
  },
  "673": {
    "name": "Suzuki Aguri no F-1 Super Driving (Japan)",
    "productCode": "DMG-FQJ"
  },
  "1216": {
    "name": "G-Arms Operation Gundam",
    "productCode": "DMG-GAJ"
  },
  "223": {
    "name": "Sylvanian Families - Otogi no Kuni no Pendant (Japan) ",
    "productCode": "DMG-ALVJ-JPN"
  },
  "736": {
    "name": "Star Ocean - Blue Sphere (Japan) ",
    "productCode": "DMG-BO2J-JPN"
  },
  "1703": {
    "name": "Mortal Kombat II - Kyuukyoku Shinken (Japan)",
    "productCode": "DMG-AMKE-USA"
  },
  "366": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2986": {
    "name": "Spot (Japan)",
    "productCode": "DMG-S3A"
  },
  "1353": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2085": {
    "name": "Card Game (Japan)",
    "productCode": "DMG-CGA"
  },
  "1847": {
    "name": "SD Gundam Gaiden : Lacroan' Heroes (Japan)",
    "productCode": "DMG-LHJ"
  },
  "2768": {
    "name": "Meitantei Conan - Giwaku no Gouka Ressha (Japan) ",
    "productCode": "DMG-ADKJ-JPN"
  },
  "872": {
    "name": "Tetris 2 (USA)",
    "productCode": "DMG-EH-USA"
  },
  "2292": {
    "name": "Namco Classic (Japan)",
    "productCode": "DMG-NHJ"
  },
  "2338": {
    "name": "Donkey Kong GB - Dinky Kong & Dixie Kong (Japan)",
    "productCode": "CGB-AD3J-JPN"
  },
  "29": {
    "name": "Soccer Boy (Japan)",
    "productCode": "DMG-SBA"
  },
  "1144": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "171": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1514": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "521": {
    "name": "Gojira-kun (Japan)",
    "productCode": "DMG-GZJ"
  },
  "1001": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "464": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1451": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "937": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1902": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2787": {
    "name": "Madden NFL 2002 (USA)",
    "productCode": "CGB-B2ME-USA"
  },
  "1282": {
    "name": "Monopoly (Japan)",
    "productCode": "DMG-LYJ"
  },
  "1778": {
    "name": "Shin Nihon Pro Wrestling - Toukon Sanjuushi (Japan)",
    "productCode": "DMG-FMJ"
  },
  "2857": {
    "name": "Bill and Ted's Excellent Adventure (USA)",
    "productCode": "DMG-LB-USA"
  },
  "1328": {
    "name": "Pokemon de Panepon (Japan)",
    "productCode": "CGB-BPNJ-JPN"
  },
  "2154": {
    "name": "Kawa no Nushi Tsuri 3 (Japan) ",
    "productCode": "DMG-A7KJ-JPN"
  },
  "2504": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "2011": {
    "name": "SD Gundam Gaiden : Lacroan' Heroes (Japan)",
    "productCode": "DMG-LHJ"
  },
  "2441": {
    "name": "Game Boy Wars (Japan)",
    "productCode": "DMG-GWJ"
  },
  "2912": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "608": {
    "name": "Kizuchi da Quiz da Gen-san da! (Japan)",
    "productCode": "DMG-QGJ"
  },
  "1797": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "258": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "576": {
    "name": "Tottoko Hamutarou - Tomodachi Daisakusen Dechu (Japan)",
    "productCode": "CGB-BHTJ-JPN"
  },
  "1543": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "126": {
    "name": "Family Jockey (Japan)",
    "productCode": "DMG-FJJ"
  },
  "1113": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQIJ-JPN"
  },
  "2695": {
    "name": "Mickey Mouse IV (Japan)",
    "productCode": "DMG-L4A"
  },
  "825": {
    "name": "Super Chinese Land (Japan)",
    "productCode": "DMG-CLJ"
  },
  "1810": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1955": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "960": {
    "name": "Gex 3 - Deep Pocket Gecko (USA)",
    "productCode": "CGB-AXGE-USA"
  },
  "2380": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "91": {
    "name": "Nekketsu Koukou Soccer-bu - World Cup Hen (Japan)",
    "productCode": "DMG-NCJ"
  },
  "1406": {
    "name": "Jinsei Game (Japan) ",
    "productCode": "DMG-AZGJ-JPN"
  },
  "433": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1056": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "599": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "2553": {
    "name": "Love Hina Pocket (Japan)",
    "productCode": "CGB-BPHJ-JPN"
  },
  "2103": {
    "name": "Megami Tensei Gaiden - Last Bible (Japan)",
    "productCode": "DMG-M7J"
  },
  "1685": {
    "name": "Outburst (Japan)",
    "productCode": "DMG-OBJ"
  },
  "2800": {
    "name": "Pinball - 66hiki no Wani Daikoushin! (Japan)",
    "productCode": "DMG-PBJ"
  },
  "1390": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2945": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "2416": {
    "name": "SD Gundam - SD Sengokuden - Kunitori Monogatari (Japan)",
    "productCode": "DMG-SDJ"
  },
  "2046": {
    "name": "Tottoko Hamutarou - Tomodachi Daisakusen Dechu (Japan)",
    "productCode": "CGB-BHTJ-JPN"
  },
  "2729": {
    "name": "Bishoujo Senshi Sailor Moon R (Japan)",
    "productCode": "DMG-QAJ"
  },
  "1806": {
    "name": "Donkey Kong (World)  ",
    "productCode": "DMG-QDA"
  },
  "833": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "999": {
    "name": "Tetris Attack (USA) ",
    "productCode": "DMG-AYLE-USA"
  },
  "68": {
    "name": "Phantom Zona (Japan) ",
    "productCode": "DMG-BKZJ-JPN"
  },
  "2379": {
    "name": "Dragon Ball Z - Gokuu Hishouden (Japan) ",
    "productCode": "DMG-ADBJ-JPN"
  },
  "2683": {
    "name": "DX Jinsei Game (Japan)",
    "productCode": "CGB-BZGJ-JPN"
  },
  "1105": {
    "name": "Super Black Bass Pocket (Japan) ",
    "productCode": "DMG-ABPJ-JPN"
  },
  "130": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1555": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "560": {
    "name": "Mysterium (USA)",
    "productCode": "DMG-MY-USA"
  },
  "1040": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "425": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "1410": {
    "name": "Kinniku Banzuke GB - Chousensha wa Kimida! (Japan) ",
    "productCode": "DMG-A5KJ-JPN"
  },
  "87": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "2396": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "3": {
    "name": "Monopoly (Japan)",
    "productCode": "DMG-LYJ"
  },
  "976": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "1943": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2816": {
    "name": "Looney Tunes Series - Daffy Duck (Japan) ",
    "productCode": "DMG-YSA"
  },
  "1739": {
    "name": "Gambler Densetsu Tetsuya - Shinjuku Tenun Hen (Japan)",
    "productCode": "CGB-BGYJ-JPN"
  },
  "1693": {
    "name": "Pocket Monsters - Pikachu (Japan)  ",
    "productCode": "DMG-APSJ-JPN"
  },
  "1369": {
    "name": "Sanrio Uranai Party (Japan)",
    "productCode": "DMG-AG7J-JPN"
  },
  "2115": {
    "name": "R-Type (Japan)",
    "productCode": "DMG-REA"
  },
  "2545": {
    "name": "Kinniku Banzuke GB2 - Mezase! Muscle Champion (Japan) ",
    "productCode": "DMG-B6KJ-JPN"
  },
  "2050": {
    "name": "Pocket Monsters - Pikachu (Japan)  ",
    "productCode": "DMG-APSJ-JPN"
  },
  "2400": {
    "name": "J.League Winning Goal (Japan)",
    "productCode": "DMG-W7J"
  },
  "2953": {
    "name": "Phantom Zona (Japan) ",
    "productCode": "DMG-BKZJ-JPN"
  },
  "649": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1386": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "219": {
    "name": "Power Pro GB (Japan)  ",
    "productCode": "DMG-APWJ-JPN"
  },
  "537": {
    "name": "Medarot 2 - Parts Collection (Japan) ",
    "productCode": "DMG-A7CJ-JPN"
  },
  "1502": {
    "name": "Othello World (Japan) ",
    "productCode": "DMG-ATOJ-JPN"
  },
  "167": {
    "name": "Medarot 2 - Kuwagata Version (Japan) ",
    "productCode": "DMG-A2NJ-JPN"
  },
  "1152": {
    "name": "Donkey Kong 2001 (Japan)",
    "productCode": "CGB-BDDJ-JPN"
  },
  "2284": {
    "name": "Medarot - Parts Collection 2 (Japan) ",
    "productCode": "DMG-A4MJ-JPN"
  },
  "864": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1851": {
    "name": "Barbie - Magic Genie Adventure (USA)",
    "productCode": "CGB-BMCE-USA"
  },
  "2791": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "1914": {
    "name": "Crayon Shin-chan - Ora to Shiro wa Otomodachi Da yo (Japan)",
    "productCode": "DMG-K4J"
  },
  "921": {
    "name": "Hokuto no Ken - Seizetsu Juuban Shoubu (Japan)",
    "productCode": "DMG-HKJ"
  },
  "188": {
    "name": "Momotarou Dengeki Momotaro Thunderbolt",
    "productCode": "DMG-G5J"
  },
  "1447": {
    "name": "Medarot - Kabuto Version (Japan) ",
    "productCode": "DMG-AMXJ-JPN"
  },
  "472": {
    "name": "Sanrio Carnival 2 (Japan)",
    "productCode": "DMG-S6J"
  },
  "1017": {
    "name": "Ranma 1-2 - Kakugeki Mondou!! (Japan)",
    "productCode": "DMG-ROJ"
  },
  "2512": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2142": {
    "name": "Nakayoshi Pet Series 2 - Kawaii Usagi (Japan) (GB Compatible)",
    "productCode": "DMG-B7UJ-JPN"
  },
  "2841": {
    "name": "Kawa no Nushi Tsuri 3 (Japan) ",
    "productCode": "DMG-A7KJ-JPN"
  },
  "1294": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1781": {
    "name": "Namco Classic (Japan)",
    "productCode": "DMG-NHJ"
  },
  "2904": {
    "name": "Snow Bros. Jr. (Japan)",
    "productCode": "DMG-SJJ"
  },
  "2457": {
    "name": "TONY HAWK'S PRO SKATER 3 (USA)",
    "productCode": "CGB-B3TE-USA"
  },
  "2007": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "496": {
    "name": "Pipe Dream (USA)",
    "productCode": "DMG-PDA"
  },
  "1159": {
    "name": "Doraemon Kart (Japan) ",
    "productCode": "DMG-ADRJ-JPN"
  },
  "1509": {
    "name": "ASTEROIDS (USA)",
    "productCode": "DMG-AARE-USA"
  },
  "2775": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "34": {
    "name": "Hook (Japan)",
    "productCode": "DMG-HSJ"
  },
  "2325": {
    "name": "SD Sengokuden 2 - Tenka Touitsu Hen (Japan)",
    "productCode": "DMG-G3J"
  },
  "2630": {
    "name": "Ultraman Club - Tekikaijuu o Hakken seyo! (Japan)",
    "productCode": "DMG-ULJ"
  },
  "880": {
    "name": "Majokko Mari-chan no Kisekae Monogatari (Japan)  ",
    "productCode": "DMG-A23J-JPN"
  },
  "2260": {
    "name": "Momotarou Densetsu Gaiden (Japan)",
    "productCode": "DMG-MIJ"
  },
  "3021": {
    "name": "Daa! Daa! Daa! - Totsuzen Card de Battle de Uranai de! (Japan)",
    "productCode": "CGB-BDOJ-JPN"
  },
  "183": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "479": {
    "name": "SolarStriker (World)",
    "productCode": "DMG-SSA"
  },
  "2149": {
    "name": "QIX (World)",
    "productCode": "DMG-QXA"
  },
  "2519": {
    "name": "Bakuretsu Senshi Warrior (Japan)",
    "productCode": "DMG-WRA"
  },
  "1765": {
    "name": "Sanrio Uranai Party (Japan)",
    "productCode": "DMG-AG7J-JPN"
  },
  "750": {
    "name": "Meitantei Conan - Giwaku no Gouka Ressha (Japan) ",
    "productCode": "DMG-ADKJ-JPN"
  },
  "1335": {
    "name": "Korokoro Kirby (Japan)",
    "productCode": "CGB-KKKJ-JPN"
  },
  "300": {
    "name": "G-Arms Operation Gundam",
    "productCode": "DMG-GAJ"
  },
  "615": {
    "name": "Quarth (USA)",
    "productCode": "DMG-QR-USA"
  },
  "1620": {
    "name": "Beatmania GB (Japan) ",
    "productCode": "DMG-AOOJ-JPN"
  },
  "245": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "1270": {
    "name": "Flipull (Japan)",
    "productCode": "DMG-FPA"
  },
  "992": {
    "name": "Battle Pingpong (Japan)",
    "productCode": "DMG-BPA"
  },
  "63": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "2372": {
    "name": "Pocket Puyo Puyo Tsuu (Japan) ",
    "productCode": "DMG-APYJ-JPN"
  },
  "2688": {
    "name": "Hamster Club 2 (Japan)",
    "productCode": "DMG-BJNJ-JPN"
  },
  "2722": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "838": {
    "name": "Purikura Pocket 2 - Kareshi Kaizou Daisakusen (Japan) ",
    "productCode": "DMG-A2PJ-JPN"
  },
  "584": {
    "name": "Nihon Daihyou Team - Eikou no Eleven (Japan) ",
    "productCode": "DMG-ASKJ-JPN"
  },
  "2237": {
    "name": "102 Dalmatas - Cachorros Al Rescate (USA)",
    "productCode": "CGB-B99E-USA"
  },
  "8": {
    "name": "Crayon Shin-chan - Ora to Shiro wa Otomodachi Da yo (Japan)",
    "productCode": "DMG-K4J"
  },
  "2667": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1948": {
    "name": "Fushigi no Dungeon Fuurai No Shiren (Japan) ",
    "productCode": "DMG-AFDJ-JPN"
  },
  "357": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1698": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "1362": {
    "name": "Bomber Man GB (Japan) ",
    "productCode": "DMG-EEJ"
  },
  "707": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1732": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1227": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "212": {
    "name": "Medarot Cardrobottle - Kabuto Version (Japan) ",
    "productCode": "DMG-A8CJ-JPN"
  },
  "2958": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1677": {
    "name": "Doraemon - Taiketsu Himitsu Dougu (Japan)",
    "productCode": "DMG-DEJ"
  },
  "642": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1118": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "1548": {
    "name": "Shin Nihon Pro Wrestling - Toukon Sanjuushi (Japan)",
    "productCode": "DMG-FMJ"
  },
  "2734": {
    "name": "SOLITAIRE FunPak (USA)",
    "productCode": "DMG-UX-USA"
  },
  "2364": {
    "name": "Fushigi no Dungeon Fuurai No Shiren (Japan) ",
    "productCode": "DMG-AFDJ-JPN"
  },
  "75": {
    "name": "Kawa no Nushi Tsuri 3 (Japan) ",
    "productCode": "DMG-A7KJ-JPN"
  },
  "984": {
    "name": "HEAD ON",
    "productCode": "DMG-PQA"
  },
  "2671": {
    "name": "Cosmo Tank (Japan)",
    "productCode": "DMG-CTJ"
  },
  "2221": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "3060": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "592": {
    "name": "Crayon Shin-chan 3 - Ora no Gokigen Athletic (Japan)",
    "productCode": "DMG-HJJ"
  },
  "438": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2108": {
    "name": "Pocket Monsters - Pikachu (Japan)  ",
    "productCode": "DMG-APSJ-JPN"
  },
  "2558": {
    "name": "Hamster Club Awasete chu (Japan)",
    "productCode": "CGB-BJHJ-JPN"
  },
  "1724": {
    "name": "Kawa no Nushi Tsuri 3 (Japan) ",
    "productCode": "DMG-A7KJ-JPN"
  },
  "711": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "1374": {
    "name": "Hamster Club (Japan)",
    "productCode": "DMG-AJNJ-JPN"
  },
  "341": {
    "name": "Nekketsu Koukou Soccer-bu - World Cup Hen (Japan)",
    "productCode": "DMG-NCJ"
  },
  "654": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1661": {
    "name": "Jungle Wars (Japan)",
    "productCode": "DMG-JWJ"
  },
  "204": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1231": {
    "name": "Yoshi's Cookie (USA)",
    "productCode": "DMG-CI-USA"
  },
  "2333": {
    "name": "Nekketsu Koukou Soccer-bu - World Cup Hen (Japan)",
    "productCode": "DMG-NCJ"
  },
  "22": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "2763": {
    "name": "Baseball (World)",
    "productCode": "DMG-BS-USA"
  },
  "879": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2299": {
    "name": "BILL BOB'S HUNTIN-N-FISHIN' (USA)",
    "productCode": "CGB-AHZE-USA"
  },
  "480": {
    "name": "Driver - You are the Wheelman (USA) ",
    "productCode": "CGB-BDRE-USA"
  },
  "195": {
    "name": "Ganbare Goemon - Kurofunetou no Nazo (Japan) ",
    "productCode": "DMG-AGDJ-JPN"
  },
  "3037": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "2276": {
    "name": "Meitantei Conan - Norowareta Kouro (Japan) ",
    "productCode": "DMG-BC3J-JPN"
  },
  "896": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "1909": {
    "name": "Rocket Power: Gettin' Air Nintendo (USA)",
    "productCode": "CGB-BRUE-USA"
  },
  "2626": {
    "name": "Snow White and the Seven Dwarfs (USA)",
    "productCode": "CGB-B7DE-USA"
  },
  "316": {
    "name": "Doraemon no Game Boy de Asobouyo Deluxe 10 (Japan) ",
    "productCode": "DMG-ADPJ-JPN"
  },
  "1323": {
    "name": "Heiankyou Alien (Japan)",
    "productCode": "DMG-HAA"
  },
  "1289": {
    "name": "PENGUIN LAND",
    "productCode": "DMG-PLJ"
  },
  "746": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1773": {
    "name": "Hyper Lode Runner",
    "productCode": "DMG-HLA"
  },
  "1266": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "253": {
    "name": "Tenchi o Kurau (Japan)",
    "productCode": "DMG-ETJ"
  },
  "1636": {
    "name": "Gex - Enter the Gecko (USA, Europe)",
    "productCode": "DMG-AEXE-USA"
  },
  "2919": {
    "name": "Tetris Flash (Japan) ",
    "productCode": "DMG-EHJ"
  },
  "603": {
    "name": "NBA All Star Challenge 2 (Japan)",
    "productCode": "DMG-H2A"
  },
  "414": {
    "name": "Alleyway (World)",
    "productCode": "DMG-AW-USA"
  },
  "1421": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1071": {
    "name": "The Bugs Bunny Crazy Castle 2 (USA)",
    "productCode": "DMG-BY-USA-1"
  },
  "947": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1972": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2348": {
    "name": "Pocket Monsters - Aka (Japan)  ",
    "productCode": "DMG-APAJ-JPN"
  },
  "59": {
    "name": "Wataru Mazekko Monster 2 (Japan) ",
    "productCode": "DMG-AWMJ-JPN"
  },
  "1837": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2718": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "802": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1564": {
    "name": "Kaisen Game - Navyblue (Japan)",
    "productCode": "DMG-NBA"
  },
  "551": {
    "name": "Yoshi",
    "productCode": "DMG-YO-USA"
  },
  "1134": {
    "name": "Ranma 1-2 (Japan)",
    "productCode": "DMG-RNJ"
  },
  "101": {
    "name": "Home Alone 2 Lost In New York (USA)",
    "productCode": "DMG-AHHJ-JPN"
  },
  "2431": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2061": {
    "name": "Pocket Bomber Man (Japan) ",
    "productCode": "DMG-APOJ-JPN"
  },
  "228": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "2962": {
    "name": "Mahjong Quest (Japan) ",
    "productCode": "DMG-AMJJ-JPN"
  },
  "382": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "678": {
    "name": "Takahashi Meijin no Bouken-jima II (Japan)",
    "productCode": "DMG-T3J"
  },
  "1358": {
    "name": "Donkey Kong Land (Japan) ",
    "productCode": "DMG-ADDJ-JPN"
  },
  "697": {
    "name": "Kinniku Banzuke GB - Chousensha wa Kimida! (Japan) ",
    "productCode": "DMG-A5KJ-JPN"
  },
  "1708": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "2827": {
    "name": "Ranma 1-2 - Netsuretsu Kakutou Hen (Japan)",
    "productCode": "DMG-R3J"
  },
  "2574": {
    "name": "Mini 4 Boy (Japan) ",
    "productCode": "DMG-AJ4J-JPN"
  },
  "2124": {
    "name": "Bikkuriman 2000 - Charging Card GB (Japan) ",
    "productCode": "DMG-BC2J-JPN"
  },
  "1925": {
    "name": "Kamen Rider SD - Hashire! Mighty Riders (Japan)",
    "productCode": "DMG-R6J"
  },
  "910": {
    "name": "Nettou Samurai Spirits (Japan)  ",
    "productCode": "DMG-X4J"
  },
  "1026": {
    "name": "Kirby no Block Ball (Japan) ",
    "productCode": "DMG-AKXJ-JPN"
  },
  "1476": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "443": {
    "name": "Game de Hakken!! Tamagotchi - Osutchi to Mesutchi (Japan) ",
    "productCode": "DMG-AOMJ-JPN"
  },
  "1499": {
    "name": "Tennis (World)",
    "productCode": "DMG-TNA"
  },
  "156": {
    "name": "Jantaku Boy (Japan)",
    "productCode": "DMG-GJJ"
  },
  "1163": {
    "name": "Pokemon Pinball (Japan)  ",
    "productCode": "DMG-VPHJ-JPN"
  },
  "506": {
    "name": "Meitantei Conan - Chika Yuuenchi Satsujin Jiken (Japan) ",
    "productCode": "DMG-ADCJ-JPN"
  },
  "1533": {
    "name": "SD Sengokuden 2 - Tenka Touitsu Hen (Japan)",
    "productCode": "DMG-G3J"
  },
  "855": {
    "name": "Medarot 5 - Susutake Mura no Tenkousei - Kuwagata (Japan)",
    "productCode": "CGB-B5NJ-JPN"
  },
  "1860": {
    "name": "Kitchen Panic (Japan)",
    "productCode": "DMG-KPJ"
  },
  "2935": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "785": {
    "name": "Tyco RC - Racin' Ratz (USA)",
    "productCode": "CGB-BTIE-USA"
  },
  "2036": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2466": {
    "name": "Korokoro Kirby (Japan)",
    "productCode": "CGB-KKKJ-JPN"
  },
  "2173": {
    "name": "Tennis (World)",
    "productCode": "DMG-TNA"
  },
  "2489": {
    "name": "Mickey Mouse II (Japan)",
    "productCode": "DMG-M2A"
  },
  "2523": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2870": {
    "name": "Nekketsu Kouha Kunio-kun - Bangai Rantou Hen (Japan)",
    "productCode": "DMG-KUJ"
  },
  "290": {
    "name": "Tetris Plus (USA)",
    "productCode": "DMG-ATRE-USA"
  },
  "455": {
    "name": "Donkey Kong Land (Japan) ",
    "productCode": "DMG-ADDJ-JPN"
  },
  "1460": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1030": {
    "name": "NBA 3 on 3 featuring Kobe Bryant (USA) ",
    "productCode": "DMG-ACVE-USA"
  },
  "1899": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "906": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1933": {
    "name": "Shin Megami Tensei Devil Children - Kuro no Sho (Japan) ",
    "productCode": "DMG-BHEJ-JPN"
  },
  "18": {
    "name": "Trump Boy (Japan)",
    "productCode": "DMG-TBJ"
  },
  "2309": {
    "name": "Pocket Monsters - Midori (Japan)  ",
    "productCode": "DMG-APBJ-JPN"
  },
  "2759": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1876": {
    "name": "Momotarou Dengeki Momotaro Thunderbolt",
    "productCode": "DMG-G5J"
  },
  "843": {
    "name": "Mortal Kombat (USA)",
    "productCode": "DMG-C9-USA"
  },
  "1525": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "510": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1175": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "140": {
    "name": "Tottoko Hamutarou 2 (Japan)",
    "productCode": "CGB-B86J-JPN"
  },
  "2470": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2020": {
    "name": "Shaman King Card Game - Chou Senjiryakketsu - Funbari Hen (Japan)",
    "productCode": "CGB-BQUJ-JPN"
  },
  "793": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "2889": {
    "name": "Medarot - Kuwagata Version (Japan)",
    "productCode": "DMG-AMYJ-JPN"
  },
  "269": {
    "name": "Kinniku Banzuke GB3 - Shinseiki Survival Retsuden! (Japan)",
    "productCode": "CGB-B7KJ-JPN"
  },
  "2923": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "639": {
    "name": "PONG the next level (USA)",
    "productCode": "CGB-AOVE-USA"
  },
  "1319": {
    "name": "Power Pro GB (Japan)  ",
    "productCode": "DMG-APWJ-JPN"
  },
  "286": {
    "name": "Bokujou Monogatari GB (Japan)  ",
    "productCode": "DMG-AYWJ-JPN"
  },
  "2866": {
    "name": "Pro Wrestling (Japan)",
    "productCode": "DMG-PRJ"
  },
  "1749": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2535": {
    "name": "Ojarumaru - Mangan Jinja no Ennichi de Ojaru! (Japan)",
    "productCode": "DMG-BOJJ-JPN"
  },
  "2165": {
    "name": "Medarot 2 - Kuwagata Version (Japan) ",
    "productCode": "DMG-A2NJ-JPN"
  },
  "1964": {
    "name": "Wataru Mazekko Monster (Japan) ",
    "productCode": "DMG-AWAJ-JPN"
  },
  "951": {
    "name": "Donkey Kong (World)  ",
    "productCode": "DMG-QDA"
  },
  "1067": {
    "name": "Cardcaptor Sakura - Itsumo Sakura-chan to Issho (Japan)",
    "productCode": "DMG-AM7J-JPN"
  },
  "1437": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "402": {
    "name": "Hamster Club (Japan)",
    "productCode": "DMG-AJNJ-JPN"
  },
  "117": {
    "name": "Red Arremer - Makaimura Gaiden (Japan)",
    "productCode": "DMG-RAJ"
  },
  "1122": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "547": {
    "name": "Kawa no Nushi Tsuri 3 (Japan) ",
    "productCode": "DMG-A7KJ-JPN"
  },
  "1088": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "1572": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "814": {
    "name": "Shikakui Atama o Maru Kusuru: Joushiki no Ka",
    "productCode": "DMG-BJ3J-JPN"
  },
  "1821": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "394": {
    "name": "B-Daman Bakugaiden - Victory e no Michi (Japan) ",
    "productCode": "DMG-AOKJ-JPN"
  },
  "2974": {
    "name": "Pokemon de Panepon (Japan)",
    "productCode": "CGB-BPNJ-JPN"
  },
  "2077": {
    "name": "Tenchi o Kurau (Japan)",
    "productCode": "DMG-ETJ"
  },
  "2427": {
    "name": "Mini Yonku GB Let's & Go!! (Japan) ",
    "productCode": "DMG-AM4J-JPN"
  },
  "2132": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2562": {
    "name": "Battleship (USA)",
    "productCode": "DMG-AIPE-USA"
  },
  "2098": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "2831": {
    "name": "Nekketsu Kouha Kunio-kun - Bangai Rantou Hen (Japan)",
    "productCode": "DMG-KUJ"
  },
  "681": {
    "name": "Selection - Erabareshi Mono (Japan)",
    "productCode": "DMG-SEJ"
  },
  "1339": {
    "name": "Hamster Paradise",
    "productCode": "DMG-AHMJ-JPN"
  },
  "1293": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2846": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "1769": {
    "name": "SD Gundam Gaiden : Lacroan' Heroes (Japan)",
    "productCode": "DMG-LHJ"
  },
  "2515": {
    "name": "Dragon Ball Z - Gokuu Hishouden (Japan) ",
    "productCode": "DMG-ADBJ-JPN"
  },
  "2145": {
    "name": "Chibi Maruko-chan - Okozukai Daisakusen! (Japan)",
    "productCode": "DMG-CMJ"
  },
  "2450": {
    "name": "Power Pro Kun Pocket (Japan)  ",
    "productCode": "DMG-AVVJ-JPN"
  },
  "2000": {
    "name": "Arcade Classic No. 4: Defender / Joust (USA)",
    "productCode": "DMG-ADJE-USA"
  },
  "1786": {
    "name": "Real Pro Yakyuu! - Central League Hen (Japan) ",
    "productCode": "DMG-AECJ-JPN"
  },
  "249": {
    "name": "Harry Potter and the Chamber of Secrets (USA, Europe) ",
    "productCode": "CGB-BH6E-USA"
  },
  "2903": {
    "name": "Moguranya (Japan) ",
    "productCode": "DMG-AMOJ-JPN"
  },
  "619": {
    "name": "PGA EUROPEAN TOUR GOLF (USA)",
    "productCode": "DMG-APRE-USA"
  },
  "38": {
    "name": "Medarot 2 - Kabuto Version (Japan) ",
    "productCode": "DMG-A2MJ-JPN"
  },
  "2329": {
    "name": "Dino Breeder 2 (Japan) ",
    "productCode": "DMG-A2DJ-JPN"
  },
  "2779": {
    "name": "America Oudan Ultra Quiz Part 2 (Japan)",
    "productCode": "DMG-AUJ"
  },
  "1856": {
    "name": "Fairy Kitty no Kaiun Jiten - Yousei no Kuni no Uranai Shugyou (Japan)  ",
    "productCode": "DMG-AFUJ-JPN"
  },
  "863": {
    "name": "Othello (Japan)",
    "productCode": "DMG-OTJ"
  },
  "2283": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1505": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "530": {
    "name": "World Bowling (Japan)",
    "productCode": "DMG-WBA"
  },
  "1155": {
    "name": "Kirby's Pinball Land (USA, Europe)",
    "productCode": "DMG-K9-USA"
  },
  "160": {
    "name": "Wario Land 2 (Japan) ",
    "productCode": "DMG-AW2J-JPN"
  },
  "475": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1440": {
    "name": "Tom and Jerry (USA)",
    "productCode": "CGB-ATXE-USA"
  },
  "1010": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2796": {
    "name": "Picross 2 (Japan) ",
    "productCode": "DMG-AP2J-JPN"
  },
  "926": {
    "name": "NFL Blitz (USA)",
    "productCode": "DMG-ABZE-USA"
  },
  "1913": {
    "name": "Pokemon Pinball (Japan)  ",
    "productCode": "DMG-VPHJ-JPN"
  },
  "2112": {
    "name": "From TV Animation One Piece - Maboroshi no Grand Line Boukenki! (Japan) ",
    "productCode": "DMG-BZOJ-JPN"
  },
  "2542": {
    "name": "Dragon Quest I & II (Japan) ",
    "productCode": "DMG-AEDJ-JPN"
  },
  "2811": {
    "name": "Shin Megami Tensei Devil Children - Shiro no Sho (Japan)",
    "productCode": "CGB-BHWJ-JPN"
  },
  "1694": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1381": {
    "name": "Granduel - Shinki Dungeon no Hihou (Japan)",
    "productCode": "CGB-ADVJ-JPN"
  },
  "2954": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2057": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2407": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "137": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQIJ-JPN"
  },
  "1102": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "567": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1552": {
    "name": "Picross 2 (Japan) ",
    "productCode": "DMG-AP2J-JPN"
  },
  "834": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1801": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "2684": {
    "name": "Super Robot Taisen (Japan)",
    "productCode": "DMG-SZJ"
  },
  "1944": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "971": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "4": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "80": {
    "name": "Monster Farm Battle Card GB (Japan) ",
    "productCode": "DMG-A6TJ-JPN"
  },
  "2391": {
    "name": "Hamster Paradise",
    "productCode": "DMG-AHMJ-JPN"
  },
  "1047": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "588": {
    "name": "Othello World (Japan) ",
    "productCode": "DMG-ATOJ-JPN"
  },
  "1417": {
    "name": "Pocket Golf (Japan)",
    "productCode": "DMG-AP6J-JPN"
  },
  "422": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "1682": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1378": {
    "name": "Fushigi no Dungeon Fuurai No Shiren (Japan) ",
    "productCode": "DMG-AFDJ-JPN"
  },
  "1728": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "2807": {
    "name": "Medarot 2 - Parts Collection (Japan) ",
    "productCode": "DMG-A7CJ-JPN"
  },
  "2554": {
    "name": "Tottoko Hamutarou - Tomodachi Daisakusen Dechu (Japan)",
    "productCode": "CGB-BHTJ-JPN"
  },
  "2104": {
    "name": "Pocket Monsters - Pikachu (Japan)  ",
    "productCode": "DMG-APSJ-JPN"
  },
  "2411": {
    "name": "Battleship (USA)",
    "productCode": "DMG-AIPE-USA"
  },
  "2041": {
    "name": "Red Arremer - Makaimura Gaiden (Japan)",
    "productCode": "DMG-RAJ"
  },
  "208": {
    "name": "FASTEST LAP",
    "productCode": "DMG-F2A"
  },
  "2942": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "658": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "1397": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "988": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "2368": {
    "name": "Tennis (World)",
    "productCode": "DMG-TNA"
  },
  "79": {
    "name": "ROADSTERS (USA)",
    "productCode": "DMG-ARRE-USA"
  },
  "2692": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "1817": {
    "name": "Nontan to Issho - Kurukuru Puzzle (Japan)",
    "productCode": "DMG-V5J"
  },
  "2738": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "822": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1544": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "571": {
    "name": "Beatmania GB (Japan) ",
    "productCode": "DMG-AOOJ-JPN"
  },
  "1114": {
    "name": "Micro Machines 1 and 2 - Twin Turbo (USA, Europe)",
    "productCode": "CGB-AT8E-USA"
  },
  "121": {
    "name": "Hyper Lode Runner",
    "productCode": "DMG-HLA"
  },
  "434": {
    "name": "Harry Potter to Kenja no Ishi (Japan)",
    "productCode": "CGB-BHVJ-JPN"
  },
  "1401": {
    "name": "Jurassic park (USA)",
    "productCode": "DMG-JQ-USA"
  },
  "1051": {
    "name": "Gremlins 2 - The New Batch (World)",
    "productCode": "DMG-GRA"
  },
  "2387": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "96": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "967": {
    "name": "Crayon Shin-chan 2 - Ora to Wanpaku Gokko Dazo (Japan)",
    "productCode": "DMG-COJ"
  },
  "1952": {
    "name": "Bakuretsu Senshi Warrior (Japan)",
    "productCode": "DMG-WRA"
  },
  "2153": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "2503": {
    "name": "SD Lupin Sansei - Kinko Yaburi Daisakusen (Japan)",
    "productCode": "DMG-XRJ"
  },
  "2850": {
    "name": "Azarashi Sentai Inazuma - Dokidoki Daisakusen! (Japan)",
    "productCode": "CGB-BOAJ-JPN"
  },
  "1285": {
    "name": "Crayon Shin-chan - Ora to Shiro wa Otomodachi Da yo (Japan)",
    "productCode": "DMG-K4J"
  },
  "2915": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1790": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "2016": {
    "name": "F-1 Spirit (Japan)",
    "productCode": "DMG-FZJ"
  },
  "2446": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "176": {
    "name": "Crayon Shin-chan - Ora to Shiro wa Otomodachi Da yo (Japan)",
    "productCode": "DMG-K4J"
  },
  "1143": {
    "name": "Nakayoshi Cooking Series 3 - Tanoshii Obentou (Japan)",
    "productCode": "CGB-B7BJ-JPN"
  },
  "526": {
    "name": "F-1 Spirit (Japan)",
    "productCode": "DMG-FZJ"
  },
  "1513": {
    "name": "G-Arms Operation Gundam",
    "productCode": "DMG-GAJ"
  },
  "2295": {
    "name": "SD Gundam Gaiden : Lacroan' Heroes (Japan)",
    "productCode": "DMG-LHJ"
  },
  "875": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1840": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1905": {
    "name": "Family Jockey (Japan)",
    "productCode": "DMG-FJJ"
  },
  "930": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "2780": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1006": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "199": {
    "name": "Doraemon - Taiketsu Himitsu Dougu (Japan)",
    "productCode": "DMG-DEJ"
  },
  "1456": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "463": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "674": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "1641": {
    "name": "Dragon Ball Z - Gokuu Hishouden (Japan) ",
    "productCode": "DMG-ADBJ-JPN"
  },
  "224": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "1211": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "2597": {
    "name": "Dragon Ball Z - Gokuu Hishouden (Japan) ",
    "productCode": "DMG-ADBJ-JPN"
  },
  "2128": {
    "name": "Selection - Erabareshi Mono (Japan)",
    "productCode": "DMG-SEJ"
  },
  "2578": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "2082": {
    "name": "Konamic Sports in Barcelona (Japan)",
    "productCode": "DMG-KHJ"
  },
  "1704": {
    "name": "Rockman World 4 (Japan)",
    "productCode": "DMG-R4J"
  },
  "731": {
    "name": "Doraemon - Taiketsu Himitsu Dougu (Japan)",
    "productCode": "DMG-DEJ"
  },
  "1354": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "2981": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "361": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "2651": {
    "name": "Animal Breeder (Japan) ",
    "productCode": "DMG-AJAJ-JPN"
  },
  "2201": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "3040": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "1587": {
    "name": "Pocket Monsters Gin (Japan)  ",
    "productCode": "DMG-AAXJ-JPN"
  },
  "418": {
    "name": "Yu Yu Hakusho Dai-2-dan - Ankoku Bujutsukai Hen (Japan)",
    "productCode": "DMG-UKJ"
  },
  "1138": {
    "name": "Pachinko Time (Japan)",
    "productCode": "DMG-PTJ"
  },
  "1092": {
    "name": "Zelda no Densetsu - Yume o Miru Shima (Japan)",
    "productCode": "DMG-ZLJ"
  },
  "1568": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "2714": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "1991": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "2344": {
    "name": "Power Pro Kun Pocket (Japan)  ",
    "productCode": "DMG-AVVJ-JPN"
  },
  "55": {
    "name": "Elevator Action (Japan)",
    "productCode": "DMG-EAA"
  },
  "2190": {
    "name": "Tenjin Kaisen (Japan)",
    "productCode": "DMG-TKJ"
  },
  "789": {
    "name": "America Oudan Ultra Quiz Part 3 (Japan)",
    "productCode": "DMG-U3J"
  },
  "1246": {
    "name": "Sanrio Carnival (Japan)",
    "productCode": "DMG-CSJ"
  },
  "2893": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "273": {
    "name": "Boomer's Adventure in ASMIK World (USA)",
    "productCode": "DMG-AS3J-JPN"
  },
  "1616": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2939": {
    "name": "TIGER WOODS PGA TOUR 2000 (USA)",
    "productCode": "DMG-AYGE-USA"
  },
  "623": {
    "name": "Daikaijuu Monogatari - The Miracle of the Zone (Japan) ",
    "productCode": "DMG-AMZJ-JPN"
  },
  "336": {
    "name": "Umi no Nushi Tsuri 2",
    "productCode": "DMG-A8UJ-JPN"
  },
  "1303": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "766": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "1753": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "2485": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1180": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "3017": {
    "name": "Makai Toushi Sa-Ga (Japan)",
    "productCode": "DMG-SAJ"
  },
  "1883": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "2256": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "1929": {
    "name": "Magical Taruruuto-kun (Japan)",
    "productCode": "DMG-MGJ"
  },
  "2606": {
    "name": "Super Robot Taisen - Link Battler (Japan) ",
    "productCode": "DMG-AL6J-JPN"
  },
  "2313": {
    "name": "SD Sengokuden 2 - Tenka Touitsu Hen (Japan)",
    "productCode": "DMG-G3J"
  },
  "2743": {
    "name": "Medarot - Kabuto Version (Japan) ",
    "productCode": "DMG-AMXJ-JPN"
  },
  "859": {
    "name": "Nekketsu Kouha Kunio-kun - Bangai Rantou Hen (Japan)",
    "productCode": "DMG-KUJ"
  },
  "1495": {
    "name": "Hamster Paradise",
    "productCode": "DMG-AHMJ-JPN"
  },
  "635": {
    "name": "Winnie the Pooh - Adventures in the 100 Acre Wood (USA)",
    "productCode": "CGB-BPOE-USA"
  },
  "1600": {
    "name": "Kawa no Nushi Tsuri 3 (Japan) ",
    "productCode": "DMG-A7KJ-JPN"
  },
  "265": {
    "name": "Sanrio Uranai Party (Japan)",
    "productCode": "DMG-AG7J-JPN"
  },
  "2885": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1250": {
    "name": "Space Invaders (Japan)",
    "productCode": "DMG-SPA"
  },
  "2186": {
    "name": "Moguranya (Japan) ",
    "productCode": "DMG-AMOJ-JPN"
  },
  "2169": {
    "name": "Mini Yonku GB Let's & Go!! (Japan) ",
    "productCode": "DMG-AM4J-JPN"
  },
  "2493": {
    "name": "Meitantei Conan - Chika Yuuenchi Satsujin Jiken (Japan) ",
    "productCode": "DMG-ADCJ-JPN"
  },
  "2539": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "1745": {
    "name": "Medarot 2 - Kuwagata Version (Japan) ",
    "productCode": "DMG-A2NJ-JPN"
  },
  "770": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "1315": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "320": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "2610": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2240": {
    "name": "Shougi 2 (Japan)",
    "productCode": "DMG-AS8J-JPN"
  },
  "1895": {
    "name": "Home Alone 2 Lost In New York (USA)",
    "productCode": "DMG-AHHJ-JPN"
  },
  "3001": {
    "name": "America Oudan Ultra Quiz Part 4 (Japan)",
    "productCode": "DMG-UAJ"
  },
  "1196": {
    "name": "F1 Boy (Japan)",
    "productCode": "DMG-FBJ"
  },
  "459": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1483": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "1179": {
    "name": "Yoshi no Panepon",
    "productCode": "DMG-AYLJ-JPN"
  },
  "1529": {
    "name": "Ranma 1-2 (Japan)",
    "productCode": "DMG-RNJ"
  },
  "2755": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "14": {
    "name": "Akumajou Special - Boku Dracula-kun (Japan)",
    "productCode": "DMG-DFJ"
  },
  "2305": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2581": {
    "name": "Wataru Mazekko Monster (Japan) ",
    "productCode": "DMG-AWAJ-JPN"
  },
  "1207": {
    "name": "Bishoujo Senshi Sailor Moon (Japan)",
    "productCode": "DMG-AQJ"
  },
  "232": {
    "name": "Shikakui Atama o Maruku Suru Shakai Battle-hen (Japan)",
    "productCode": "DMG-AK8J-JPN"
  },
  "2978": {
    "name": "Medarot 2 - Kuwagata Version (Japan) ",
    "productCode": "DMG-A2NJ-JPN"
  },
  "1657": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "398": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "662": {
    "name": "Tottoko Hamutarou 2 (Japan)",
    "productCode": "CGB-B86J-JPN"
  },
  "377": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "2997": {
    "name": "SD Gundam - SD Sengokuden - Kunitori Monogatari (Japan)",
    "productCode": "DMG-SDJ"
  },
  "1342": {
    "name": "Ultraman Club - Tekikaijuu o Hakken seyo! (Japan)",
    "productCode": "DMG-ULJ"
  },
  "727": {
    "name": "Kirby's Star Stacker (USA, Europe)",
    "productCode": "DMG-AKCE-USA"
  },
  "1712": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "2094": {
    "name": "Motocross Maniacs (Japan)",
    "productCode": "DMG-MXA"
  },
  "1591": {
    "name": "Pocket Puyo Puyo Tsuu (Japan) ",
    "productCode": "DMG-APYJ-JPN"
  },
  "3056": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "2217": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2647": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "1968": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "43": {
    "name": "Disney's The Little Mermaid (USA)",
    "productCode": "DMG-LD-USA"
  },
  "2352": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "1987": {
    "name": "Momotarou Dentetsu jr. - Zenkoku Ramen Meguri no Maki (Japan) ",
    "productCode": "DMG-AD8J-JPN"
  },
  "2702": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "818": {
    "name": "Ganbare! Nippon! Olympic 2000 (Japan)",
    "productCode": "CGB-B3HJ-JPN"
  },
  "1084": {
    "name": "Ganbare Goemon - Sarawareta Ebisumaru (Japan)",
    "productCode": "DMG-GCJ"
  },
  "1590": {
    "name": "Dracula Densetsu (Japan)",
    "productCode": "DMG-CVJ"
  },
  "3057": {
    "name": "Solomon's Club (Japan)",
    "productCode": "DMG-SCJ"
  },
  "2216": {
    "name": "Ou Dorobou Jing - Angel Version (Japan) ",
    "productCode": "DMG-AZWJ-JPN"
  },
  "2646": {
    "name": "Casper (USA)",
    "productCode": "DMG-ACEE-USA"
  },
  "1969": {
    "name": "Sesame Street - Elmo's ABCs (USA)",
    "productCode": "DMG-AEAE-USA"
  },
  "42": {
    "name": "Tetris Flash (Japan) ",
    "productCode": "DMG-EHJ"
  },
  "2353": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "1986": {
    "name": "Donkey Kong Land (Japan) ",
    "productCode": "DMG-ADDJ-JPN"
  },
  "2703": {
    "name": "Ultraman Club - Tekikaijuu o Hakken seyo! (Japan)",
    "productCode": "DMG-ULJ"
  },
  "819": {
    "name": "Yu Yu Hakusho Dai-3-tama : Makai no Tobira (Japan)",
    "productCode": "DMG-UGJ"
  },
  "1085": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "2580": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1206": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "233": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "399": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "2979": {
    "name": "Cosmo Tank (Japan)",
    "productCode": "DMG-CTJ"
  },
  "1656": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "663": {
    "name": "Super Momotarou Dentetsu II (Japan)",
    "productCode": "DMG-G9J"
  },
  "2996": {
    "name": "Pocket Densha 2 (Japan) ",
    "productCode": "DMG-AP8J-JPN"
  },
  "376": {
    "name": "Meitantei Conan - Giwaku no Gouka Ressha (Japan) ",
    "productCode": "DMG-ADKJ-JPN"
  },
  "1343": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "726": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1713": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2095": {
    "name": "Ghostbusters II (Japan)",
    "productCode": "DMG-GBA"
  },
  "2611": {
    "name": "Super B-Daman - Fighting Phoenix (Japan) ",
    "productCode": "DMG-ABDJ-JPN"
  },
  "2241": {
    "name": "QIX (World)",
    "productCode": "DMG-QXA"
  },
  "1894": {
    "name": "Bishoujo Senshi Sailor Moon R (Japan)",
    "productCode": "DMG-QAJ"
  },
  "3000": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "458": {
    "name": "From TV Animation One Piece - Maboroshi no Grand Line Boukenki! (Japan) ",
    "productCode": "DMG-BZOJ-JPN"
  },
  "1197": {
    "name": "Card Game (Japan)",
    "productCode": "DMG-CGA"
  },
  "1482": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1178": {
    "name": "Dead Heat Scramble (USA)",
    "productCode": "DMG-DH-USA"
  },
  "1528": {
    "name": "Meitantei Conan - Chika Yuuenchi Satsujin Jiken (Japan) ",
    "productCode": "DMG-ADCJ-JPN"
  },
  "2754": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "15": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "2304": {
    "name": "RPG Tsukuru GB (Japan)",
    "productCode": "CGB-A2QJ-JPN"
  },
  "634": {
    "name": "Hamster Club 2 (Japan)",
    "productCode": "DMG-BJNJ-JPN"
  },
  "1601": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "2884": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "264": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1251": {
    "name": "Chibi Maruko-chan 4 - Kore ga Nihon Da yo! Ouji-sama (Japan)",
    "productCode": "DMG-C4J"
  },
  "2187": {
    "name": "Ultra Golf (USA)",
    "productCode": "DMG-KGA"
  },
  "2168": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2492": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "2538": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1744": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "771": {
    "name": "J.League Winning Goal (Japan)",
    "productCode": "DMG-W7J"
  },
  "1314": {
    "name": "World Cup Striker (Japan)",
    "productCode": "DMG-YKA"
  },
  "321": {
    "name": "Shanghai (Japan) (Activision)",
    "productCode": "DMG-SHJ"
  },
  "1181": {
    "name": "Heiankyo Alien (USA)",
    "productCode": "DMG-HA-USA"
  },
  "3016": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQIJ-JPN"
  },
  "1882": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "2257": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "1928": {
    "name": "X-Men Mutant Academy (USA)",
    "productCode": "CGB-BXAE-USA"
  },
  "2607": {
    "name": "Mini Yonku GB Let's & Go!! (Japan) ",
    "productCode": "DMG-AM4J-JPN"
  },
  "2312": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2742": {
    "name": "Tetris DX (World)  ",
    "productCode": "DMG-ATEA-JPN"
  },
  "858": {
    "name": "Monster Race (Japan) ",
    "productCode": "DMG-AMRJ-JPN"
  },
  "1494": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "2191": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "1247": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "788": {
    "name": "Kirby no Block Ball (Japan) ",
    "productCode": "DMG-AKXJ-JPN"
  },
  "272": {
    "name": "Meitantei Conan - Giwaku no Gouka Ressha (Japan) ",
    "productCode": "DMG-ADKJ-JPN"
  },
  "2892": {
    "name": "Penguin Wars (USA)",
    "productCode": "DMG-PWJ"
  },
  "1617": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "2938": {
    "name": "Chibi Maruko-chan 3 - Mezase! Game Taishou no Maki (Japan)",
    "productCode": "DMG-M3J"
  },
  "622": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "337": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "1302": {
    "name": "Ganbare Goemon - Kurofunetou no Nazo (Japan) ",
    "productCode": "DMG-AGDJ-JPN"
  },
  "767": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1752": {
    "name": "Tennis (World)",
    "productCode": "DMG-TNA"
  },
  "2484": {
    "name": "Mickey's Chase (Japan)",
    "productCode": "DMG-MCJ"
  },
  "2650": {
    "name": "Kikou Keisatsu Metal Jack (Japan)",
    "productCode": "DMG-M5J"
  },
  "2200": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "3041": {
    "name": "Game Boy Gallery (Japan) ",
    "productCode": "DMG-AGAJ-JPN"
  },
  "1586": {
    "name": "ARCADE CLASSIC 2 CENTIPEDE MILLIPEDE (USA)",
    "productCode": "DMG-ACPE-USA"
  },
  "419": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "1139": {
    "name": "Yoshi's Cookie (USA)",
    "productCode": "DMG-CI-USA"
  },
  "1093": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1569": {
    "name": "Dragon Quest III - Soshite Densetsu e... (Japan)",
    "productCode": "CGB-BD3J-JPN"
  },
  "2715": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "1990": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "2345": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "54": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "675": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1640": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "225": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "1210": {
    "name": "Nettou The King of Fighters '96 (Japan) ",
    "productCode": "DMG-AK6J-JPN"
  },
  "2596": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "2129": {
    "name": "Downtown - Nekketsu Koushinkyoku - Dokodemo Daiundoukai (Japan)",
    "productCode": "DMG-DUJ"
  },
  "2579": {
    "name": "Bomber Man Max - Yami no Senshi (Japan)",
    "productCode": "CGB-A7BJ-JPN"
  },
  "2083": {
    "name": "Crayon Shin-chan 2 - Ora to Wanpaku Gokko Dazo (Japan)",
    "productCode": "DMG-COJ"
  },
  "1705": {
    "name": "Bomber Boy (Japan)",
    "productCode": "DMG-HBA"
  },
  "730": {
    "name": "In Your Face (USA)",
    "productCode": "DMG-YF-USA"
  },
  "1355": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "360": {
    "name": "Puzzle Boy (Japan)",
    "productCode": "DMG-APJ"
  },
  "2980": {
    "name": "Tottoko Hamutarou - Tomodachi Daisakusen Dechu (Japan)",
    "productCode": "CGB-BHTJ-JPN"
  },
  "177": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "1142": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "527": {
    "name": "Hamster Paradise 4 (Japan)",
    "productCode": "CGB-BCUJ-JPN"
  },
  "1512": {
    "name": "Mario no Picross (Japan) ",
    "productCode": "DMG-APCJ-JPN"
  },
  "874": {
    "name": "Star Wars (USA)",
    "productCode": "DMG-WS-USA-1"
  },
  "2294": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "1841": {
    "name": "SD Gundam Gaiden : Lacroan' Heroes (Japan)",
    "productCode": "DMG-LHJ"
  },
  "1904": {
    "name": "Tennis (World)",
    "productCode": "DMG-TNA"
  },
  "931": {
    "name": "Goukaku Boy GOLD - Shikakui Atama o Maruku Suru - Joushiki no Sho (Japan)",
    "productCode": "DMG-AM5J-JPN"
  },
  "2781": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1007": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1457": {
    "name": "Pocket GI Stable (Japan) ",
    "productCode": "DMG-APUJ-JPN"
  },
  "198": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "462": {
    "name": "Tsume Shogi Hyakuban Shoubu (Japan)",
    "productCode": "DMG-S4J"
  },
  "2152": {
    "name": "Super B-Daman - Fighting Phoenix (Japan) ",
    "productCode": "DMG-ABDJ-JPN"
  },
  "2502": {
    "name": "Pocket Puyo Puyo Tsuu (Japan) ",
    "productCode": "DMG-APYJ-JPN"
  },
  "2851": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1284": {
    "name": "Snoopy Magic Show (USA)",
    "productCode": "DMG-SNA"
  },
  "2914": {
    "name": "Monster Race (Japan) ",
    "productCode": "DMG-AMRJ-JPN"
  },
  "1791": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "2017": {
    "name": "Medarot 3 - Kuwagata Version (Japan)",
    "productCode": "CGB-B33J-JPN"
  },
  "2447": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "2369": {
    "name": "Shougi Saikyou (Japan)  ",
    "productCode": "DMG-AMSJ-JPN"
  },
  "78": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "989": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "2693": {
    "name": "SD Gundam Gaiden : Lacroan' Heroes (Japan)",
    "productCode": "DMG-LHJ"
  },
  "1816": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "2739": {
    "name": "Cyborg Kuro-chan - Devil Fukkatsu (Japan)",
    "productCode": "CGB-BSKJ-JPN"
  },
  "823": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1545": {
    "name": "Puyo Puyo (Japan)  ",
    "productCode": "DMG-QQJ"
  },
  "570": {
    "name": "Magical Taruruuto-kun (Japan)",
    "productCode": "DMG-MGJ"
  },
  "1115": {
    "name": "Tetris Flash (Japan) ",
    "productCode": "DMG-EHJ"
  },
  "120": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "435": {
    "name": "Ojarumaru - Mangan Jinja no Ennichi de Ojaru! (Japan)",
    "productCode": "DMG-BOJJ-JPN"
  },
  "1400": {
    "name": "America Oudan Ultra Quiz Part 4 (Japan)",
    "productCode": "DMG-UAJ"
  },
  "1050": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "966": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "2386": {
    "name": "Oyatsu Quiz Mogu Mogu Q (Japan) ",
    "productCode": "DMG-AMQJ-JPN"
  },
  "97": {
    "name": "Midori no Makibaou (Japan) ",
    "productCode": "DMG-ANAJ-JPN"
  },
  "1953": {
    "name": "IRON MAN X-O MANOWAR IN HEAVY METAL (USA)",
    "productCode": "DMG-AXIE-USA"
  },
  "1683": {
    "name": "SD Gundam Gaiden : Lacroan' Heroes (Japan)",
    "productCode": "DMG-LHJ"
  },
  "1379": {
    "name": "The Powerpuff Girls - Paint the Townsville Green (USA)",
    "productCode": "CGB-BPTE-USA"
  },
  "1729": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "2806": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "2555": {
    "name": "Shaman King: Chou Senjiryakketsu Meramera (Japan)",
    "productCode": "CGB-BQVJ-JPN"
  },
  "2105": {
    "name": "Fushigi no Dungeon Fuurai No Shiren (Japan) ",
    "productCode": "DMG-AFDJ-JPN"
  },
  "2410": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2040": {
    "name": "Trump Collection GB (Japan)",
    "productCode": "DMG-ATCJ-JPN"
  },
  "209": {
    "name": "Kachiuma Yosou Keiba Kizoku EX '95 (Japan)",
    "productCode": "DMG-AQEJ-JPN"
  },
  "2943": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "1396": {
    "name": "Medarot 3 - Kuwagata Version (Japan)",
    "productCode": "CGB-B33J-JPN"
  },
  "659": {
    "name": "From TV Animation One Piece - Maboroshi no Grand Line Boukenki! (Japan) ",
    "productCode": "DMG-BZOJ-JPN"
  },
  "136": {
    "name": "Super Black Bass Pocket 2 (Japan) ",
    "productCode": "DMG-ABTJ-JPN"
  },
  "1103": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "566": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "1553": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "835": {
    "name": "Ultraman Club - Tekikaijuu o Hakken seyo! (Japan)",
    "productCode": "DMG-ULJ"
  },
  "1800": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "2685": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1945": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "81": {
    "name": "Hokuto no Ken - Seizetsu Juuban Shoubu (Japan)",
    "productCode": "DMG-HKJ"
  },
  "2390": {
    "name": "Teenage Mutant Ninja Turtles - Fall of the Foot Clan (USA)",
    "productCode": "DMG-NTJ"
  },
  "5": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "970": {
    "name": "Dancing Furby (Japan)",
    "productCode": "DMG-BFBJ-JPN"
  },
  "589": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1046": {
    "name": "Bouken! Puzzle Road (Japan)",
    "productCode": "DMG-PUJ"
  },
  "1416": {
    "name": "Prince of Persia (Japan)",
    "productCode": "DMG-NPJ"
  },
  "423": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "2113": {
    "name": "BurgerTime Deluxe (World)",
    "productCode": "DMG-GMA"
  },
  "2543": {
    "name": "Pocket GI Stable (Japan) ",
    "productCode": "DMG-APUJ-JPN"
  },
  "2810": {
    "name": "Home Alone 2 Lost In New York (USA)",
    "productCode": "DMG-AHHJ-JPN"
  },
  "1695": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1380": {
    "name": "Shaman King Card Game - Chou Senjiryakketsu - Funbari Hen (Japan)",
    "productCode": "CGB-BQUJ-JPN"
  },
  "2955": {
    "name": "Fushigi no Dungeon Fuurai No Shiren (Japan) ",
    "productCode": "DMG-AFDJ-JPN"
  },
  "2056": {
    "name": "Medarot - Parts Collection (Japan) ",
    "productCode": "DMG-AMPJ-JPN"
  },
  "2406": {
    "name": "Rockman World 3 (Japan)",
    "productCode": "DMG-W3J"
  },
  "39": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2328": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2778": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "1857": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "2282": {
    "name": "Milon no Meikyuu Kumikyoku (Japan)",
    "productCode": "DMG-M8J"
  },
  "862": {
    "name": "Aladdin (USA) ",
    "productCode": "DMG-ALAE-USA"
  },
  "1504": {
    "name": "Hero Shuugou!! Pinball Party (Japan)",
    "productCode": "DMG-PPJ"
  },
  "531": {
    "name": "Captain Tsubasa VS (Japan)",
    "productCode": "DMG-T5J"
  },
  "1154": {
    "name": "Sakura Taisen GB - Geki Hana Gumi Nyuutai! (Japan)",
    "productCode": "CGB-BRJJ-JPN"
  },
  "161": {
    "name": "Power Pro Kun Pocket (Japan)  ",
    "productCode": "DMG-AVVJ-JPN"
  },
  "474": {
    "name": "Puyo Puyo (Japan)  ",
    "productCode": "DMG-QQJ"
  },
  "1441": {
    "name": "Burai Senshi Deluxe (Japan)",
    "productCode": "DMG-BUA"
  },
  "1011": {
    "name": "Yoshi no Cookie",
    "productCode": "DMG-CIJ"
  },
  "2797": {
    "name": "Shaman King: Chou Senjiryakketsu Meramera (Japan)",
    "productCode": "CGB-BQVJ-JPN"
  },
  "927": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1912": {
    "name": "From TV Animation One Piece - Maboroshi no Grand Line Boukenki! (Japan) ",
    "productCode": "DMG-BZOJ-JPN"
  },
  "1338": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1292": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "2847": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "1768": {
    "name": "Nakayoshi Pet Series 4 - Kawaii Koneko (Japan)",
    "productCode": "CGB-B7NJ-JPN"
  },
  "2514": {
    "name": "Super Mario Land 2 - 6-tsu no Kinka (Japan)",
    "productCode": "DMG-L6J"
  },
  "2144": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2451": {
    "name": "Shin Megami Tensei Devil Children - Aka no Sho (Japan) ",
    "productCode": "DMG-BHNJ-JPN"
  },
  "2001": {
    "name": "Monster Race Okawari (Japan) ",
    "productCode": "DMG-AMFJ-JPN"
  },
  "248": {
    "name": "Kinniku Banzuke GB - Chousensha wa Kimida! (Japan) ",
    "productCode": "DMG-A5KJ-JPN"
  },
  "1787": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "2902": {
    "name": "Yu-Gi-Oh! Duel Monsters III - Tri Holy God Advant (Japan)",
    "productCode": "CGB-BY3J-JPN"
  },
  "618": {
    "name": "Medarot 2 - Kabuto Version (Japan) ",
    "productCode": "DMG-A2MJ-JPN"
  },
  "2975": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "395": {
    "name": "R-Type (Japan)",
    "productCode": "DMG-REA"
  },
  "2076": {
    "name": "Shounen Ashibe - Yuuenchi Panic (Japan)",
    "productCode": "DMG-A2J"
  },
  "2426": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2133": {
    "name": "Super Momotarou Dentetsu (Japan)",
    "productCode": "DMG-MDJ"
  },
  "2563": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "2099": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2830": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "680": {
    "name": "Puyo Puyo (Japan)  ",
    "productCode": "DMG-QQJ"
  },
  "1965": {
    "name": "Keitai Denjuu Telefang - Speed Version (Japan)",
    "productCode": "DMG-BTZJ-JPN"
  },
  "950": {
    "name": "Hong Kong (Japan)",
    "productCode": "DMG-HGJ"
  },
  "1066": {
    "name": "Antz (USA) ",
    "productCode": "DMG-ANXE-USA"
  },
  "1436": {
    "name": "Grander Musashi RV (Japan) ",
    "productCode": "DMG-ARVJ-JPN"
  },
  "403": {
    "name": "Wario Land 3 (World) ",
    "productCode": "CGB-AW8A-JPN"
  },
  "116": {
    "name": "Wataru Mazekko Monster (Japan) ",
    "productCode": "DMG-AWAJ-JPN"
  },
  "1123": {
    "name": "Bomber Man Collection (Japan) ",
    "productCode": "DMG-ABCJ-JPN"
  },
  "1089": {
    "name": "Super B-Daman - Fighting Phoenix (Japan) ",
    "productCode": "DMG-ABDJ-JPN"
  },
  "546": {
    "name": "Ayakashi no Shiro (Japan)",
    "productCode": "DMG-AYJ"
  },
  "1573": {
    "name": "Kirby no Block Ball (Japan) ",
    "productCode": "DMG-AKXJ-JPN"
  },
  "815": {
    "name": "Nakayoshi Pet Series 1 - Kawaii Hamster (Japan) ",
    "productCode": "DMG-B7HJ-JPN"
  },
  "1820": {
    "name": "Hamster Paradise",
    "productCode": "DMG-AHMJ-JPN"
  },
  "2471": {
    "name": "Momotarou Dentetsu jr. - Zenkoku Ramen Meguri no Maki (Japan) ",
    "productCode": "DMG-AD8J-JPN"
  },
  "2021": {
    "name": "Tetris Flash (Japan) ",
    "productCode": "DMG-EHJ"
  },
  "792": {
    "name": "Ultraman Club - Tekikaijuu o Hakken seyo! (Japan)",
    "productCode": "DMG-ULJ"
  },
  "268": {
    "name": "Sanrio Carnival (Japan)",
    "productCode": "DMG-CSJ"
  },
  "2888": {
    "name": "Kisekae Series 3 - Kisekae Hamster (Japan)",
    "productCode": "CGB-BKHJ-JPN"
  },
  "2922": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "638": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "1318": {
    "name": "Sweet Ange (Japan) ",
    "productCode": "DMG-AUBJ-JPN"
  },
  "2867": {
    "name": "Donkey Kong (World)  ",
    "productCode": "DMG-QDA"
  },
  "1748": {
    "name": "Medarot 3 - Kabuto Version (Japan)",
    "productCode": "CGB-B32J-JPN"
  },
  "287": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "2534": {
    "name": "Pokemon de Panepon (Japan)",
    "productCode": "CGB-BPNJ-JPN"
  },
  "2164": {
    "name": "Buzz Lightyear of Star Command (USA)",
    "productCode": "CGB-BUZE-USA"
  },
  "454": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "1461": {
    "name": "Racing Damashii (Japan)",
    "productCode": "DMG-RDJ"
  },
  "1031": {
    "name": "Hamster Paradise 3 (Japan)",
    "productCode": "CGB-BH3J-JPN"
  },
  "1898": {
    "name": "Ultraman Club - Tekikaijuu o Hakken seyo! (Japan)",
    "productCode": "DMG-ULJ"
  },
  "907": {
    "name": "Nakayoshi Pet Series 2 - Kawaii Usagi (Japan)",
    "productCode": "CGB-B7IJ-JPN"
  },
  "1932": {
    "name": "Zelda no Densetsu - Fushigi no Kinomi - Jikuu no Shou (Japan)",
    "productCode": "CGB-AZ8J-JPN"
  },
  "19": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "2308": {
    "name": "Shin Megami Tensei Devil Children - Kuro no Sho (Japan) ",
    "productCode": "DMG-BHEJ-JPN"
  },
  "2758": {
    "name": "Blue's Clues - Blue's Alphabet Book (USA)",
    "productCode": "CGB-BALE-USA"
  },
  "1877": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "842": {
    "name": "Golf (World)",
    "productCode": "DMG-GOA"
  },
  "1524": {
    "name": "Medarot 3 - Kabuto Version (Japan)",
    "productCode": "CGB-B32J-JPN"
  },
  "511": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1174": {
    "name": "Nushi Tsuri Adventure - Kite no Bouken (Japan) ",
    "productCode": "CGB-VVJJ-JPN"
  },
  "141": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VUA"
  },
  "2934": {
    "name": "Sa-Ga 3 - Jikuu no Hasha (Japan)",
    "productCode": "DMG-OSJ"
  },
  "784": {
    "name": "Tales of Phantasia - Narikiri Dungeon (Japan) ",
    "productCode": "DMG-AN6J-JPN"
  },
  "2037": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "2467": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "2172": {
    "name": "Jeopardy! (USA)",
    "productCode": "DMG-JP-USA"
  },
  "2488": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "2522": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "291": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "2871": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1924": {
    "name": "Pachinko Time (Japan)",
    "productCode": "DMG-PTJ"
  },
  "911": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1027": {
    "name": "Tottoko Hamutarou 2 (Japan)",
    "productCode": "CGB-B86J-JPN"
  },
  "1477": {
    "name": "Goukaku Boy GOLD - Shikakui Atama o Maruku Suru - Keisan no Tatsujin (Japan)",
    "productCode": "DMG-BC4J-JPN"
  },
  "442": {
    "name": "Pokemon - Blue Version (USA, Europe) ",
    "productCode": "DMG-APEE-USA"
  },
  "157": {
    "name": "Teenage Mutant Ninja Turtles - Fall of the Foot Clan (USA)",
    "productCode": "DMG-NTJ"
  },
  "1498": {
    "name": "Onigashima Pachinkoten (Japan)",
    "productCode": "DMG-OGJ"
  },
  "1162": {
    "name": "Pachinko CR Daiku no Gen-san GB (Japan) ",
    "productCode": "DMG-AKZJ-JPN"
  },
  "507": {
    "name": "Nekketsu Koukou Soccer-bu - World Cup Hen (Japan)",
    "productCode": "DMG-NCJ"
  },
  "1532": {
    "name": "B-Daman Bakugaiden - Victory e no Michi (Japan) ",
    "productCode": "DMG-AOKJ-JPN"
  },
  "854": {
    "name": "Doraemon 2 - Animal Planet Densetsu (Japan)",
    "productCode": "DMG-DMJ"
  },
  "1861": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "2430": {
    "name": "Pokemon Card GB (Japan) ",
    "productCode": "DMG-ACXJ-JPN"
  },
  "2060": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "229": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "383": {
    "name": "Nettou Garou Densetsu 2 - Aratanaru Tatakai (Japan) ",
    "productCode": "DMG-X3J"
  },
  "2963": {
    "name": "Zoids - Jashin Fukkatsu! Genobreaker Hen (Japan)  ",
    "productCode": "DMG-BGZJ-JPN"
  },
  "679": {
    "name": "Kinniku Banzuke GB - Chousensha wa Kimida! (Japan) ",
    "productCode": "DMG-A5KJ-JPN"
  },
  "696": {
    "name": "Kawa no Nushi Tsuri 3 (Japan) ",
    "productCode": "DMG-A7KJ-JPN"
  },
  "1359": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1709": {
    "name": "Shaun Palmer's Pro Snowboarding (USA)",
    "productCode": "CGB-B3SE-USA"
  },
  "2826": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "2575": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "2125": {
    "name": "Vegas Stakes (USA)",
    "productCode": "DMG-AVSE-USA"
  },
  "415": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "1420": {
    "name": "The New Batman Adventures - Chaos in Gotham (Europe) ",
    "productCode": "CGB-BBBP-EUR"
  },
  "1070": {
    "name": "Dragon Ball Z - Gokuu Hishouden (Japan) ",
    "productCode": "DMG-ADBJ-JPN"
  },
  "946": {
    "name": "Pachinko Time (Japan)",
    "productCode": "DMG-PTJ"
  },
  "1973": {
    "name": "Baseball Kids (Japan)",
    "productCode": "DMG-BKJ"
  },
  "2349": {
    "name": "Puzzle Nintama Rantarou (Japan) ",
    "productCode": "DMG-APNJ-JPN"
  },
  "58": {
    "name": "Pocket Monsters - Crystal Version (Japan)",
    "productCode": "CGB-BXTJ-JPN"
  },
  "1836": {
    "name": "Elevator Action (USA)",
    "productCode": "DMG-EA-USA"
  },
  "2719": {
    "name": "Fushigi no Dungeon Fuurai No Shiren (Japan) ",
    "productCode": "DMG-AFDJ-JPN"
  },
  "803": {
    "name": "Tottoko Hamutarou 2 (Japan)",
    "productCode": "CGB-B86J-JPN"
  },
  "1565": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "550": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1135": {
    "name": "Wario Land - Super Mario Land 3 (World)",
    "productCode": "DMG-WJA"
  },
  "100": {
    "name": "G-Arms Operation Gundam",
    "productCode": "DMG-GAJ"
  },
  "317": {
    "name": "Uno (USA)",
    "productCode": "DMG-AUNE-USA"
  },
  "1322": {
    "name": "Tottoko Hamutarou - Tomodachi Daisakusen Dechu (Japan)",
    "productCode": "CGB-BHTJ-JPN"
  },
  "747": {
    "name": "Nekketsu Koukou Soccer-bu - World Cup Hen (Japan)",
    "productCode": "DMG-NCJ"
  },
  "1288": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "1772": {
    "name": "Kindaichi Shounen no Jikenbo - 10nenme no Shoutaijou (Japan) ",
    "productCode": "DMG-BKSJ-JPN"
  },
  "1267": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "252": {
    "name": "QIX (World)",
    "productCode": "DMG-QXA"
  },
  "1637": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2918": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "602": {
    "name": "Mini 4 Boy II",
    "productCode": "DMG-AJ2J-JPN"
  },
  "2332": {
    "name": "Donkey Kong Land (Japan) ",
    "productCode": "DMG-ADDJ-JPN"
  },
  "23": {
    "name": "Bakuten Shoot Beyblade (Japan)",
    "productCode": "CGB-BB3J-JPN"
  },
  "2762": {
    "name": "Pocket Monsters - Midori (Japan)  ",
    "productCode": "DMG-APBJ-JPN"
  },
  "2298": {
    "name": "Kawa no Nushi Tsuri 3 (Japan) ",
    "productCode": "DMG-A7KJ-JPN"
  },
  "878": {
    "name": "Kirby no Kirakira Kids (Japan) ",
    "productCode": "DMG-AKCJ-JPN"
  },
  "481": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "194": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "3036": {
    "name": "Yu-Gi-Oh! Duel Monsters 4 - Battle of Great Duelist - Yuugi Deck (Japan)",
    "productCode": "CGB-BY4J-JPN"
  },
  "897": {
    "name": "Medarot 3 - Kabuto Version (Japan)",
    "productCode": "CGB-B32J-JPN"
  },
  "2277": {
    "name": "Super Mario Land (World) ",
    "productCode": "DMG-MLA"
  },
  "1908": {
    "name": "Motocross Maniacs (Japan)",
    "productCode": "DMG-MXA"
  },
  "2627": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "2109": {
    "name": "Mahjong Quest (Japan) ",
    "productCode": "DMG-AMJJ-JPN"
  },
  "2559": {
    "name": "Ultraman Club - Tekikaijuu o Hakken seyo! (Japan)",
    "productCode": "DMG-ULJ"
  },
  "1725": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "710": {
    "name": "Sakigake!! Otoko Juku - Meioutou Kessen (Japan)",
    "productCode": "DMG-OMJ"
  },
  "1375": {
    "name": "Dragon Quest I & II (Japan) ",
    "productCode": "DMG-AEDJ-JPN"
  },
  "340": {
    "name": "Wario Land 3 (World) ",
    "productCode": "CGB-AW8A-JPN"
  },
  "655": {
    "name": "Donkey Kong (World)  ",
    "productCode": "DMG-QDA"
  },
  "1660": {
    "name": "Puyo Puyo (Japan)  ",
    "productCode": "DMG-QQJ"
  },
  "205": {
    "name": "Baseball (World)",
    "productCode": "DMG-BSA"
  },
  "1230": {
    "name": "Yakuman (Japan)",
    "productCode": "DMG-MJJ"
  },
  "1119": {
    "name": "Medarot - Kuwagata Version (Japan)",
    "productCode": "DMG-AMYJ-JPN"
  },
  "1549": {
    "name": "Tokyo Disneyland - Mickey no Cinderella-jou Mystery Tour (Japan) ",
    "productCode": "DMG-ADLJ-JPN"
  },
  "2735": {
    "name": "M&M's Minis Madness (USA)",
    "productCode": "CGB-BMIE-USA"
  },
  "985": {
    "name": "Game de Hakken!! Tamagotchi 2 (Japan) ",
    "productCode": "DMG-AT3J-JPN"
  },
  "2365": {
    "name": "Pocket Monsters - Midori (Japan)  ",
    "productCode": "DMG-APBJ-JPN"
  },
  "74": {
    "name": "Dragon Quest Monsters 2 - Maruta no Fushigi na Kagi (Japan) ",
    "productCode": "DMG-BQLJ-JPN"
  },
  "2670": {
    "name": "Hokuto no Ken - Seizetsu Juuban Shoubu (Japan)",
    "productCode": "DMG-HKJ"
  },
  "2220": {
    "name": "Jantaku Boy (Japan)",
    "productCode": "DMG-GJJ"
  },
  "593": {
    "name": "Medarot 2 - Parts Collection (Japan) ",
    "productCode": "DMG-A7CJ-JPN"
  },
  "3061": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "439": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "1699": {
    "name": "Black Bass - Lure Fishing (USA)",
    "productCode": "DMG-ALFE-USA"
  },
  "356": {
    "name": "Dr. Mario (World)",
    "productCode": "DMG-VU-USA-1"
  },
  "1363": {
    "name": "Hamster Club (Japan)",
    "productCode": "DMG-AJNJ-JPN"
  },
  "706": {
    "name": "Power Pro Kun Pocket (Japan)  ",
    "productCode": "DMG-AVVJ-JPN"
  },
  "1733": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "1226": {
    "name": "Mario Golf GB (Japan)",
    "productCode": "CGB-AWXJ-JPN"
  },
  "213": {
    "name": "Onigashima Pachinkoten (Japan)",
    "productCode": "DMG-OGJ"
  },
  "2959": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "1676": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "643": {
    "name": "Super Momotarou Dentetsu II (Japan)",
    "productCode": "DMG-G9J"
  },
  "62": {
    "name": "Yu-Gi-Oh! Duel Monsters (Japan) ",
    "productCode": "DMG-AYUJ-JPN"
  },
  "2373": {
    "name": "Kirby No Pinball",
    "productCode": "DMG-K9J"
  },
  "993": {
    "name": "Fushigi no Dungeon Fuurai No Shiren (Japan) ",
    "productCode": "DMG-AFDJ-JPN"
  },
  "2689": {
    "name": "Famista 3 (Japan)",
    "productCode": "DMG-N3J"
  },
  "2723": {
    "name": "Tetris (World)",
    "productCode": "DMG-TRA"
  },
  "839": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "585": {
    "name": "Super Donkey Kong GB (Japan) ",
    "productCode": "DMG-YTJ"
  },
  "2236": {
    "name": "SD Gundam - SD Sengokuden - Kunitori Monogatari (Japan)",
    "productCode": "DMG-SDJ"
  },
  "9": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "2666": {
    "name": "Yu-Gi-Oh! Duel Monsters II - Dark Duel Stories (Japan) ",
    "productCode": "DMG-AYKJ-JPN"
  },
  "1949": {
    "name": "Magical Taruruuto-kun (Japan)",
    "productCode": "DMG-MGJ"
  },
  "2148": {
    "name": "Puyo Puyo (Japan)  ",
    "productCode": "DMG-QQJ"
  },
  "2518": {
    "name": "Dragon Quest Monsters - Terry no Wonderland (Japan)  ",
    "productCode": "DMG-ADQJ-JPN"
  },
  "1764": {
    "name": "Game de Hakken!! Tamagotchi (Japan) ",
    "productCode": "DMG-ATAJ-JPN"
  },
  "751": {
    "name": "Medarot - Parts Collection (Japan) ",
    "productCode": "DMG-AMPJ-JPN"
  },
  "1334": {
    "name": "Dead Heat Scramble (USA)",
    "productCode": "DMG-DHA"
  },
  "301": {
    "name": "Druaga no Tou (Japan)",
    "productCode": "DMG-ADA"
  },
  "614": {
    "name": "From TV Animation One Piece - Yume no Luffy Kaizokudan Tanjou! (Japan)  ",
    "productCode": "DMG-BLUJ-JPN"
  },
  "1621": {
    "name": "Shanghai (USA)",
    "productCode": "DMG-SH-USA"
  },
  "244": {
    "name": "F1 Race (World) ",
    "productCode": "DMG-F1A"
  },
  "1271": {
    "name": "Klax (Japan)",
    "productCode": "DMG-KLA"
  },
  "1158": {
    "name": "Yoshi no Tamago (Japan)",
    "productCode": "DMG-YOJ"
  },
  "497": {
    "name": "Picross 2 (Japan) ",
    "productCode": "DMG-AP2J-JPN"
  },
  "1508": {
    "name": "Sanrio Carnival (Japan)",
    "productCode": "DMG-CSJ"
  },
  "2774": {
    "name": "Tenchi o Kurau (Japan)",
    "productCode": "DMG-ETJ"
  },
  "35": {
    "name": "Hamster Paradise 4 (Japan)",
    "productCode": "CGB-BCUJ-JPN"
  },
  "2324": {
    "name": "Gakken Shiaza Jukugo 288 Goukaku (Japan)",
    "productCode": "DMG-AY3J-JPN"
  },
  "2631": {
    "name": "Yu Yu Hakusho Dai-3-tama : Makai no Tobira (Japan)",
    "productCode": "DMG-UGJ"
  },
  "2261": {
    "name": "Hoshi no Kirby (Japan)",
    "productCode": "DMG-KYJ"
  },
  "881": {
    "name": "Hoshi no Kirby 2 (Japan) ",
    "productCode": "DMG-AKBJ-JPN"
  },
  "3020": {
    "name": "Road Champs BXS Stunt Biking (USA)",
    "productCode": "CGB-BXSE-USA"
  },
  "182": {
    "name": "Goukaku Boy Series - Eijukugo Target 1000 (Japan)",
    "productCode": "DMG-AJ5J-JPN"
  },
  "478": {
    "name": "Pro Mahjong Kiwame GB II (Japan) ",
    "productCode": "DMG-AA2J-JPN"
  }
} as const;

export const dailyFeature = [
  "CGB-AATE-USA",
  "CGB-B99E-USA",
  "CGB-BB3J-JPN",
  "CGB-BMCE-USA",
  "DMG-A2DJ-JPN",
  "DMG-A3DJ-JPN",
  "DMG-A4RJ-JPN",
  "DMG-AARE-USA",
  "DMG-AC5E-USA",
  "DMG-ACCJ-JPN",
  "DMG-ACPE-USA",
  "DMG-ADJE-USA",
  "DMG-AF3J-JPN",
  "DMG-AGNJ-JPN",
  "DMG-AH-USA",
  "DMG-AIPE-USA",
  "DMG-AJ5J-JPN",
  "DMG-AM5J-JPN",
  "DMG-AMZJ-JPN",
  "DMG-ANXE-USA",
  "DMG-AS2J-JPN",
  "DMG-AW-USA",
  "DMG-AWDJ-JPN",
  "DMG-AWGJ-JPN",
  "DMG-BB-USA",
  "DMG-BC4J-JPN",
  "DMG-BE3J-JPN",
  "DMG-BJ3J-JPN",
  "DMG-BKJ",
  "DMG-BLA",
  "DMG-BS4J-JPN",
  "DMG-BT-USA",
  "DMG-C2J",
  "DMG-CCJ",
  "DMG-CGA",
  "DMG-CTJ",
  "DMG-DDA",
  "DMG-DGJ",
  "DMG-DHA",
  "DMG-DQJ",
  "DMG-DVJ",
  "DMG-DY-USA",
  "DMG-EAA",
  "DMG-F1A",
  "DMG-F2A",
  "DMG-F4-USA-1",
  "DMG-F4J",
  "DMG-FCJ",
  "DMG-FDJ",
  "DMG-FJJ",
  "DMG-FK-USA",
  "DMG-FP-USA",
  "DMG-FU-USA",
  "DMG-FUA",
  "DMG-FVJ",
  "DMG-FZ-USA",
  "DMG-FZJ",
  "DMG-GBA",
  "DMG-GMA",
  "DMG-GRA",
  "DMG-GT-USA",
  "DMG-HAA",
  "DMG-HLA",
  "DMG-HRJ",
  "DMG-HSJ",
  "DMG-JBA",
  "DMG-JCA",
  "DMG-JFJ",
  "DMG-JLJ",
  "DMG-JP-USA",
  "DMG-JQ-USA",
  "DMG-JWJ",
  "DMG-KLA",
  "DMG-KTJ",
  "DMG-LB-USA",
  "DMG-LN-USA",
  "DMG-M3J",
  "DMG-M7J",
  "DMG-M9J",
  "DMG-MUJ",
  "DMG-NBA",
  "DMG-P8-USA",
  "DMG-PQA",
  "DMG-STJ",
  "DMG-V2A",
  "DMG-VSA",
  "DMG-VVJ",
  "DMG-W7J",
  "DMG-WRA",
  "DMG-WW-USA",
  "DMG-YF-USA",
  "DMG-YSA",
  "DMG-YVJ",
  "DMG-ABPJ-JPN",
  "DMG-ABTJ-JPN",
];

export type Metadata = typeof metadata;
export default metadata;